var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useApiClient } from './useApiClient';
import useSwr from 'swr';
/**
 * Accepts a term for customer
 * @summary customers/{customerId}/acceptedTerms
 */
export var createCustomerAcceptedTerm = function (client, customerId, globalCustomersAcceptedTermDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/acceptedTerms"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersAcceptedTermDto,
    }, options);
};
/**
 * GET: Returns access permissions
 * @summary customers/{customerId}/accessPermissions
 */
export var getCustomerAccessPermissions = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/accessPermissions"), method: 'get', headers: headers }, options);
};
export var getGetCustomerAccessPermissionsKey = function (customerId) {
    return ["/customers/".concat(customerId, "/accessPermissions")];
};
/**
 * @summary customers/{customerId}/accessPermissions
 */
export var useGetCustomerAccessPermissions = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerAccessPermissionsKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerAccessPermissions(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Change password based on the old one.
 * @summary accounts/my/changePassword
 */
export var updateAccountsMyChangePassword = function (client, globalAccountsChangePasswordDto, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/accounts/my/changePassword",
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalAccountsChangePasswordDto,
        params: params,
    }, options);
};
/**
 * Retrieves the account info for account with given login string.
 * @summary accounts/my
 */
export var getAccountsMy = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/accounts/my", method: 'get', headers: headers, params: params }, options);
};
export var getGetAccountsMyKey = function (params) {
    return __spreadArray(["/accounts/my"], (params ? [params] : []), true);
};
/**
 * @summary accounts/my
 */
export var useGetAccountsMy = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetAccountsMyKey(params) : null); });
    var swrFn = function () {
        return getAccountsMy(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * First step of password reset. Send temporary password to the user over notification channel(s)
 * @summary accounts/my/sendTemporaryPassword
 */
export var createAccountsMySendTemporaryPassword = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/accounts/my/sendTemporaryPassword", method: 'post', headers: headers, params: params }, options);
};
/**
 * Second step of password reset. Reset password based on temporary and new password.
 * @summary accounts/my/resetPassword
 */
export var updateAccountsMyResetPassword = function (client, globalAccountsResetPasswordDto, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/accounts/my/resetPassword",
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalAccountsResetPasswordDto,
        params: params,
    }, options);
};
/**
 * Returns metadata for change password endpoint
<param name="tenant">Tenant name</param>
 * @summary accounts/changePasswordMetadata
 */
export var getAccountsChangePasswordMetadata = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/accounts/changePasswordMetadata", method: 'get', headers: headers }, options);
};
export var getGetAccountsChangePasswordMetadataKey = function () {
    return ["/accounts/changePasswordMetadata"];
};
/**
 * @summary accounts/changePasswordMetadata
 */
export var useGetAccountsChangePasswordMetadata = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetAccountsChangePasswordMetadataKey() : null); });
    var swrFn = function () {
        return getAccountsChangePasswordMetadata(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides set of permissions based on identity in access token
 * @summary accounts/my/permissions
 */
export var getAccountsMyPermissions = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/accounts/my/permissions", method: 'get', headers: headers }, options);
};
export var getGetAccountsMyPermissionsKey = function () { return ["/accounts/my/permissions"]; };
/**
 * @summary accounts/my/permissions
 */
export var useGetAccountsMyPermissions = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetAccountsMyPermissionsKey() : null); });
    var swrFn = function () {
        return getAccountsMyPermissions(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns information about customer activation
 * @summary customers/{customerId}/activationRequest
 */
export var getCustomerActivationRequest = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/activationRequest"), method: 'get', headers: headers }, options);
};
export var getGetCustomerActivationRequestKey = function (customerId) {
    return ["/customers/".concat(customerId, "/activationRequest")];
};
/**
 * @summary customers/{customerId}/activationRequest
 */
export var useGetCustomerActivationRequest = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerActivationRequestKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerActivationRequest(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Requests resending of activation code for given customer
 * @summary customers/{customerId}/activationRequest
 */
export var updateCustomerActivationRequest = function (client, customerId, globalCustomersActivationRequestDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/activationRequest"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersActivationRequestDto,
    }, options);
};
/**
 * GET: Returns metadata about customer activation
 * @summary customers/{customerId}/activationRequestMetadata
 */
export var getCustomerActivationRequestMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/activationRequestMetadata"), method: 'get', headers: headers }, options);
};
export var getGetCustomerActivationRequestMetadataKey = function (customerId) {
    return ["/customers/".concat(customerId, "/activationRequestMetadata")];
};
/**
 * @summary customers/{customerId}/activationRequestMetadata
 */
export var useGetCustomerActivationRequestMetadata = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerActivationRequestMetadataKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerActivationRequestMetadata(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets customer addresses
 * @summary customers/{customerId}/addresses
 */
export var getCustomerAddresses = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/addresses"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerAddressesKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/addresses")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/addresses
 */
export var useGetCustomerAddresses = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerAddressesKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerAddresses(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Creates customer address
 * @summary customers/{customerId}/addresses
 */
export var createCustomerAddress = function (client, customerId, globalCustomersAddressDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/addresses"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersAddressDtoBody,
    }, options);
};
/**
 * PUT: Updates customer address
 * @summary customers/{customerId}/addresses/{addressId}
 */
export var updateCustomerAddress = function (client, customerId, addressId, globalCustomersAddressDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/addresses/").concat(addressId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersAddressDtoBody,
    }, options);
};
/**
 * DELETE: Remove customer address identified by id
 * @summary customers/{customerId}/addresses/{addressId}
 */
export var deleteCustomerAddress = function (client, customerId, addressId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/addresses/").concat(addressId), method: 'delete', headers: headers }, options);
};
/**
 * GET: Gets metadata information for address endpoints of the customer with given customer id
 * @summary customers/{customerId}/addressesMetadata
 */
export var getCustomerAddressesMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/addressesMetadata"), method: 'get', headers: headers }, options);
};
export var getGetCustomerAddressesMetadataKey = function (customerId) {
    return ["/customers/".concat(customerId, "/addressesMetadata")];
};
/**
 * @summary customers/{customerId}/addressesMetadata
 */
export var useGetCustomerAddressesMetadata = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerAddressesMetadataKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerAddressesMetadata(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns options for address formatting
 * @deprecated
 * @summary addressFormats
 */
export var getAddressFormats = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/addressFormats", method: 'get', headers: headers }, options);
};
export var getGetAddressFormatsKey = function () { return ["/addressFormats"]; };
/**
 * @deprecated
 * @summary addressFormats
 */
export var useGetAddressFormats = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetAddressFormatsKey() : null); });
    var swrFn = function () {
        return getAddressFormats(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns specific option for address formatting
 * @deprecated
 * @summary addressFormats/{type}
 */
export var getAddressFormat = function (client, type, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/addressFormats/".concat(type), method: 'get', headers: headers }, options);
};
export var getGetAddressFormatKey = function (type) { return ["/addressFormats/".concat(type)]; };
/**
 * @deprecated
 * @summary addressFormats/{type}
 */
export var useGetAddressFormat = function (type, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!type;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetAddressFormatKey(type) : null); });
    var swrFn = function () {
        return getAddressFormat(customInstance, type, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns the available payment methods
 * @summary paymentProviders/adyen/payments/{onlinePaymentId}/paymentMethods
 */
export var getPaymentProvidersAdyenPaymentPaymentMethods = function (client, onlinePaymentId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/paymentProviders/adyen/payments/".concat(onlinePaymentId, "/paymentMethods"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetPaymentProvidersAdyenPaymentPaymentMethodsKey = function (onlinePaymentId) {
    return ["/paymentProviders/adyen/payments/".concat(onlinePaymentId, "/paymentMethods")];
};
/**
 * @summary paymentProviders/adyen/payments/{onlinePaymentId}/paymentMethods
 */
export var useGetPaymentProvidersAdyenPaymentPaymentMethods = function (onlinePaymentId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!onlinePaymentId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetPaymentProvidersAdyenPaymentPaymentMethodsKey(onlinePaymentId) : null;
    });
    var swrFn = function () {
        return getPaymentProvidersAdyenPaymentPaymentMethods(customInstance, onlinePaymentId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns the available payment methods
 * @deprecated
 * @summary payments/{onlinePaymentId}/paymentProviders/adyen/paymentMethods
 */
export var getPaymentPaymentProvidersAdyenPaymentMethodsDeprecated = function (client, onlinePaymentId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/payments/".concat(onlinePaymentId, "/paymentProviders/adyen/paymentMethods"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetPaymentPaymentProvidersAdyenPaymentMethodsDeprecatedKey = function (onlinePaymentId) { return ["/payments/".concat(onlinePaymentId, "/paymentProviders/adyen/paymentMethods")]; };
/**
 * @deprecated
 * @summary payments/{onlinePaymentId}/paymentProviders/adyen/paymentMethods
 */
export var useGetPaymentPaymentProvidersAdyenPaymentMethodsDeprecated = function (onlinePaymentId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!onlinePaymentId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetPaymentPaymentProvidersAdyenPaymentMethodsDeprecatedKey(onlinePaymentId)
            : null;
    });
    var swrFn = function () {
        return getPaymentPaymentProvidersAdyenPaymentMethodsDeprecated(customInstance, onlinePaymentId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Initiates payment
 * @summary paymentProviders/adyen/payments/{onlinePaymentId}
 */
export var createPaymentProvidersAdyenPayment = function (client, onlinePaymentId, globalPaymentsAdyenPaymentRequestDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/paymentProviders/adyen/payments/".concat(onlinePaymentId),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalPaymentsAdyenPaymentRequestDtoBody,
    }, options);
};
/**
 * POST: Initiates payment
 * @deprecated
 * @summary payments/{onlinePaymentId}/paymentProviders/adyen/payments
 */
export var createPaymentPaymentProvidersAdyenPaymentDeprecated = function (client, onlinePaymentId, globalPaymentsAdyenPaymentRequestDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/payments/".concat(onlinePaymentId, "/paymentProviders/adyen/payments"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalPaymentsAdyenPaymentRequestDtoBody,
    }, options);
};
/**
 * POST: Sends payment details when a customer is required to perform additional actions
 * @summary paymentProviders/adyen/payments/{onlinePaymentId}/paymentDetail
 */
export var createPaymentProvidersAdyenPaymentPaymentDetail = function (client, onlinePaymentId, createPaymentProvidersAdyenPaymentPaymentDetailBodyBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/paymentProviders/adyen/payments/".concat(onlinePaymentId, "/paymentDetail"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: createPaymentProvidersAdyenPaymentPaymentDetailBodyBody,
    }, options);
};
/**
 * POST: Sends payment details when a customer is required to perform additional actions
 * @deprecated
 * @summary payments/{onlinePaymentId}/paymentProviders/adyen/paymentDetails
 */
export var createPaymentPaymentProvidersAdyenPaymentDetailDeprecated = function (client, onlinePaymentId, createPaymentProvidersAdyenPaymentPaymentDetailBodyBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/payments/".concat(onlinePaymentId, "/paymentProviders/adyen/paymentDetails"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: createPaymentProvidersAdyenPaymentPaymentDetailBodyBody,
    }, options);
};
/**
 * GET: Returns client credentials for FE component
 * @summary paymentProviders/adyen/payments/{onlinePaymentId}/clientCredential
 */
export var getPaymentProvidersAdyenPaymentClientCredential = function (client, onlinePaymentId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/paymentProviders/adyen/payments/".concat(onlinePaymentId, "/clientCredential"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetPaymentProvidersAdyenPaymentClientCredentialKey = function (onlinePaymentId) {
    return ["/paymentProviders/adyen/payments/".concat(onlinePaymentId, "/clientCredential")];
};
/**
 * @summary paymentProviders/adyen/payments/{onlinePaymentId}/clientCredential
 */
export var useGetPaymentProvidersAdyenPaymentClientCredential = function (onlinePaymentId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!onlinePaymentId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetPaymentProvidersAdyenPaymentClientCredentialKey(onlinePaymentId) : null;
    });
    var swrFn = function () {
        return getPaymentProvidersAdyenPaymentClientCredential(customInstance, onlinePaymentId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns client credentials for FE component
 * @deprecated
 * @summary payments/{onlinePaymentId}/paymentProviders/adyen/clientCredentials
 */
export var getPaymentPaymentProvidersAdyenClientCredentialsDeprecated = function (client, onlinePaymentId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/payments/".concat(onlinePaymentId, "/paymentProviders/adyen/clientCredentials"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetPaymentPaymentProvidersAdyenClientCredentialsDeprecatedKey = function (onlinePaymentId) { return ["/payments/".concat(onlinePaymentId, "/paymentProviders/adyen/clientCredentials")]; };
/**
 * @deprecated
 * @summary payments/{onlinePaymentId}/paymentProviders/adyen/clientCredentials
 */
export var useGetPaymentPaymentProvidersAdyenClientCredentialsDeprecated = function (onlinePaymentId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!onlinePaymentId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetPaymentPaymentProvidersAdyenClientCredentialsDeprecatedKey(onlinePaymentId)
            : null;
    });
    var swrFn = function () {
        return getPaymentPaymentProvidersAdyenClientCredentialsDeprecated(customInstance, onlinePaymentId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Adyen Checkout/Recurring API - Disables stored payment details to stop charging a shopper with this particular recurring detail ID
 * @summary customers/{customerId}/paymentProviders/adyen/contractDisableRequest
 */
export var createCustomerPaymentProvidersAdyenContractDisableRequest = function (client, customerId, globalCustomersAdyenContractDisableRequestDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/paymentProviders/adyen/contractDisableRequest"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersAdyenContractDisableRequestDto,
    }, options);
};
/**
 * GET: Returns analytics data of registration with given ID
 * @summary customerRegistrations/{registrationId}/analytics
 */
export var getCustomerRegistrationAnalytics = function (client, registrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customerRegistrations/".concat(registrationId, "/analytics"), method: 'get', headers: headers }, options);
};
export var getGetCustomerRegistrationAnalyticsKey = function (registrationId) {
    return ["/customerRegistrations/".concat(registrationId, "/analytics")];
};
/**
 * @summary customerRegistrations/{registrationId}/analytics
 */
export var useGetCustomerRegistrationAnalytics = function (registrationId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!registrationId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerRegistrationAnalyticsKey(registrationId) : null); });
    var swrFn = function () {
        return getCustomerRegistrationAnalytics(customInstance, registrationId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets the customer approvals of the customer for given customer id
 * @summary customers/{customerId}/approval
 */
export var getCustomerApproval = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/approval"), method: 'get', headers: headers }, options);
};
export var getGetCustomerApprovalKey = function (customerId) {
    return ["/customers/".concat(customerId, "/approval")];
};
/**
 * @summary customers/{customerId}/approval
 */
export var useGetCustomerApproval = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerApprovalKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerApproval(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Update the customer approvals of the customer for given customer id
 * @summary customers/{customerId}/approval
 */
export var updateCustomerApproval = function (client, customerId, globalSharedApprovalDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/approval"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalSharedApprovalDto,
    }, options);
};
/**
 * GET: Gets metadata information for approval endpoints of the customer with given customer id
 * @summary customers/{customerId}/approvalMetadata
 */
export var getCustomerApprovalMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/approvalMetadata"), method: 'get', headers: headers }, options);
};
export var getGetCustomerApprovalMetadataKey = function (customerId) {
    return ["/customers/".concat(customerId, "/approvalMetadata")];
};
/**
 * @summary customers/{customerId}/approvalMetadata
 */
export var useGetCustomerApprovalMetadata = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerApprovalMetadataKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerApprovalMetadata(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets product(s) ATP
 * @summary atpClusters/{atpClusterId}/atps/{itemCode}
 */
export var getAtpClusterAtp = function (client, atpClusterId, itemCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/atpClusters/".concat(atpClusterId, "/atps/").concat(itemCode), method: 'get', headers: headers }, options);
};
export var getGetAtpClusterAtpKey = function (atpClusterId, itemCode) {
    return ["/atpClusters/".concat(atpClusterId, "/atps/").concat(itemCode)];
};
/**
 * @summary atpClusters/{atpClusterId}/atps/{itemCode}
 */
export var useGetAtpClusterAtp = function (atpClusterId, itemCode, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(atpClusterId && itemCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetAtpClusterAtpKey(atpClusterId, itemCode) : null); });
    var swrFn = function () {
        return getAtpClusterAtp(customInstance, atpClusterId, itemCode, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets product(s) ATP
 * @summary atpClusters/{atpClusterId}/atps
 */
export var getAtpClusterAtps = function (client, atpClusterId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/atpClusters/".concat(atpClusterId, "/atps"), method: 'get', headers: headers, params: params }, options);
};
export var getGetAtpClusterAtpsKey = function (atpClusterId, params) {
    return __spreadArray(["/atpClusters/".concat(atpClusterId, "/atps")], (params ? [params] : []), true);
};
/**
 * @summary atpClusters/{atpClusterId}/atps
 */
export var useGetAtpClusterAtps = function (atpClusterId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!atpClusterId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetAtpClusterAtpsKey(atpClusterId, params) : null); });
    var swrFn = function () {
        return getAtpClusterAtps(customInstance, atpClusterId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets ATP cluster
 * @deprecated
 * @summary atpClusters/{atpClusterId}
 */
export var getAtpCluster = function (client, atpClusterId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/atpClusters/".concat(atpClusterId), method: 'get', headers: headers }, options);
};
export var getGetAtpClusterKey = function (atpClusterId) {
    return ["/atpClusters/".concat(atpClusterId)];
};
/**
 * @deprecated
 * @summary atpClusters/{atpClusterId}
 */
export var useGetAtpCluster = function (atpClusterId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!atpClusterId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetAtpClusterKey(atpClusterId) : null); });
    var swrFn = function () {
        return getAtpCluster(customInstance, atpClusterId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Find ATP cluster based on delivery channel and/or delivery address
 * @deprecated
 * @summary atpClusters
 */
export var getAtpClusters = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/atpClusters", method: 'get', headers: headers, params: params }, options);
};
export var getGetAtpClustersKey = function (params) {
    return __spreadArray(["/atpClusters"], (params ? [params] : []), true);
};
/**
 * @deprecated
 * @summary atpClusters
 */
export var useGetAtpClusters = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetAtpClustersKey(params) : null); });
    var swrFn = function () {
        return getAtpClusters(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get autoship configuration
 * @summary customers/{customerId}/autoshipConfiguration
 */
export var getCustomerAutoshipConfiguration = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/autoshipConfiguration"), method: 'get', headers: headers }, options);
};
export var getGetCustomerAutoshipConfigurationKey = function (customerId) {
    return ["/customers/".concat(customerId, "/autoshipConfiguration")];
};
/**
 * @summary customers/{customerId}/autoshipConfiguration
 */
export var useGetCustomerAutoshipConfiguration = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerAutoshipConfigurationKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerAutoshipConfiguration(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get autoship availability per specified product/item
 * @summary customers/{customerId}/autoshipAvailabilities
 */
export var getCustomerAutoshipAvailabilities = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/autoshipAvailabilities"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerAutoshipAvailabilitiesKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/autoshipAvailabilities")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/autoshipAvailabilities
 */
export var useGetCustomerAutoshipAvailabilities = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerAutoshipAvailabilitiesKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerAutoshipAvailabilities(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get autoship types.
Optionally filtered by product contained in subscription.
 * @summary customers/{customerId}/autoshipTypes
 */
export var getCustomerAutoshipTypes = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/autoshipTypes"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerAutoshipTypesKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/autoshipTypes")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/autoshipTypes
 */
export var useGetCustomerAutoshipTypes = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerAutoshipTypesKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerAutoshipTypes(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns URLs and titles of legal info articles.
 * @summary customers/{customerId}/autoshipLegalArticles
 */
export var getCustomerAutoshipLegalArticles = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/autoshipLegalArticles"), method: 'get', headers: headers }, options);
};
export var getGetCustomerAutoshipLegalArticlesKey = function (customerId) {
    return ["/customers/".concat(customerId, "/autoshipLegalArticles")];
};
/**
 * @summary customers/{customerId}/autoshipLegalArticles
 */
export var useGetCustomerAutoshipLegalArticles = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerAutoshipLegalArticlesKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerAutoshipLegalArticles(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Post autoship instruction.
Depends on instruction status (Pending/Finished) provides only validation or also creates new autoship subscription if Finished
 * @summary customers/{customerId}/autoshipInstructions
 */
export var createCustomerAutoshipInstruction = function (client, customerId, globalCustomersAutoshipInstructionDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/autoshipInstructions"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersAutoshipInstructionDto,
    }, options);
};
/**
 * GET: Provides information about concept availability
 * @summary concepts/{conceptCode}/availability
 */
export var getConceptAvailability = function (client, conceptCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/concepts/".concat(conceptCode, "/availability"), method: 'get', headers: headers }, options);
};
export var getGetConceptAvailabilityKey = function (conceptCode) {
    return ["/concepts/".concat(conceptCode, "/availability")];
};
/**
 * @summary concepts/{conceptCode}/availability
 */
export var useGetConceptAvailability = function (conceptCode, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!conceptCode;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetConceptAvailabilityKey(conceptCode) : null); });
    var swrFn = function () {
        return getConceptAvailability(customInstance, conceptCode, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get availability of concepts for specific customer
 * @summary customers/{customerId}/concepts/availabilities
 */
export var getCustomerConceptsAvailabilities = function (client, customerId, globalConceptsAvailabilitiesQueryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/concepts/availabilities"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalConceptsAvailabilitiesQueryDtoBody,
    }, options);
};
/**
 * Get availability of concepts
 * @summary concepts/availabilities
 */
export var getConceptsAvailabilities = function (client, globalConceptsAvailabilitiesQueryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/concepts/availabilities",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalConceptsAvailabilitiesQueryDtoBody,
    }, options);
};
/**
 * GET: Provides information about concept availability
 * @summary customers/{customerId}/concepts/{conceptCode}/availability
 */
export var getCustomerConceptAvailability = function (client, customerId, conceptCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/concepts/").concat(conceptCode, "/availability"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetCustomerConceptAvailabilityKey = function (customerId, conceptCode) {
    return ["/customers/".concat(customerId, "/concepts/").concat(conceptCode, "/availability")];
};
/**
 * @summary customers/{customerId}/concepts/{conceptCode}/availability
 */
export var useGetCustomerConceptAvailability = function (customerId, conceptCode, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && conceptCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerConceptAvailabilityKey(customerId, conceptCode) : null); });
    var swrFn = function () {
        return getCustomerConceptAvailability(customInstance, customerId, conceptCode, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get availability of product for specific customer
 * @summary customers/{customerId}/products/{productCode}/availability
 */
export var getCustomerProductAvailability = function (client, customerId, productCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/products/").concat(productCode, "/availability"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetCustomerProductAvailabilityKey = function (customerId, productCode) {
    return ["/customers/".concat(customerId, "/products/").concat(productCode, "/availability")];
};
/**
 * @summary customers/{customerId}/products/{productCode}/availability
 */
export var useGetCustomerProductAvailability = function (customerId, productCode, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && productCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerProductAvailabilityKey(customerId, productCode) : null); });
    var swrFn = function () {
        return getCustomerProductAvailability(customInstance, customerId, productCode, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get availability of product
 * @summary products/{productCode}/availability
 */
export var getProductAvailability = function (client, productCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/products/".concat(productCode, "/availability"), method: 'get', headers: headers }, options);
};
export var getGetProductAvailabilityKey = function (productCode) {
    return ["/products/".concat(productCode, "/availability")];
};
/**
 * @summary products/{productCode}/availability
 */
export var useGetProductAvailability = function (productCode, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!productCode;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetProductAvailabilityKey(productCode) : null); });
    var swrFn = function () {
        return getProductAvailability(customInstance, productCode, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get products availability for specified collection of products
 * @summary products/availability
 */
export var getProductsAvailability = function (client, globalProductsProductAvailabilityQueryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/products/availability",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalProductsProductAvailabilityQueryDtoBody,
    }, options);
};
/**
 * Get products Availability for specified customer and specified collection of products
 * @summary customer/{customerId}/products/availability
 */
export var getCustomerProductsAvailability = function (client, customerId, globalProductsProductAvailabilityQueryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customer/".concat(customerId, "/products/availability"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalProductsProductAvailabilityQueryDtoBody,
    }, options);
};
/**
 * Get information about possibility to subscribe for BIS notifications for each product requested by productCodes.
 * @deprecated
 * @summary backInStockNotifications
 */
export var getBackInStockNotificationsDeprecated = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/backInStockNotifications", method: 'get', headers: headers, params: params }, options);
};
export var getGetBackInStockNotificationsDeprecatedKey = function (params) { return __spreadArray(["/backInStockNotifications"], (params ? [params] : []), true); };
/**
 * @deprecated
 * @summary backInStockNotifications
 */
export var useGetBackInStockNotificationsDeprecated = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetBackInStockNotificationsDeprecatedKey(params) : null); });
    var swrFn = function () {
        return getBackInStockNotificationsDeprecated(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Stores passed by parameter notificationData information so user receives BIS notifications.
 * @summary backInStockNotificationSubscriptions
 */
export var createBackInStockNotificationSubscription = function (client, globalBackInStockNotificationsBackInStockNotificationSubscriptionDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/backInStockNotificationSubscriptions",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalBackInStockNotificationsBackInStockNotificationSubscriptionDtoBody,
    }, options);
};
/**
 * Get configuration for back in stock notifications.
 * @summary backInStockNotificationsConfiguration
 */
export var getBackInStockNotificationsConfiguration = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/backInStockNotificationsConfiguration", method: 'get', headers: headers }, options);
};
export var getGetBackInStockNotificationsConfigurationKey = function () {
    return ["/backInStockNotificationsConfiguration"];
};
/**
 * @summary backInStockNotificationsConfiguration
 */
export var useGetBackInStockNotificationsConfiguration = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetBackInStockNotificationsConfigurationKey() : null); });
    var swrFn = function () {
        return getBackInStockNotificationsConfiguration(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get information about possibility to subscribe for BIS notifications for each product requested by productCodes.
 * @deprecated
 * @summary customers/{customerId}/backInStockNotifications
 */
export var getCustomerBackInStockNotificationsDeprecated = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/backInStockNotifications"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerBackInStockNotificationsDeprecatedKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/backInStockNotifications")], (params ? [params] : []), true); };
/**
 * @deprecated
 * @summary customers/{customerId}/backInStockNotifications
 */
export var useGetCustomerBackInStockNotificationsDeprecated = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetCustomerBackInStockNotificationsDeprecatedKey(customerId, params) : null;
    });
    var swrFn = function () {
        return getCustomerBackInStockNotificationsDeprecated(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Stores passed by parameter notificationData information so user receives BIS notifications.
 * @summary customers/{customerId}/backInStockNotificationSubscriptions
 */
export var createCustomerBackInStockNotificationSubscription = function (client, customerId, globalBackInStockNotificationsBackInStockNotificationSubscriptionDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/backInStockNotificationSubscriptions"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalBackInStockNotificationsBackInStockNotificationSubscriptionDtoBody,
    }, options);
};
/**
 * GET: Gets bank account approvals
 * @summary customers/{customerId}/bankAccountApprovals
 */
export var getCustomerBankAccountApprovals = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/bankAccountApprovals"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerBankAccountApprovalsKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/bankAccountApprovals")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/bankAccountApprovals
 */
export var useGetCustomerBankAccountApprovals = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerBankAccountApprovalsKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerBankAccountApprovals(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets customer bank accounts
 * @summary customers/{customerId}/bankAccounts
 */
export var getCustomerBankAccounts = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/bankAccounts"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerBankAccountsKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/bankAccounts")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/bankAccounts
 */
export var useGetCustomerBankAccounts = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerBankAccountsKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerBankAccounts(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Creates customer bank account
 * @summary customers/{customerId}/bankAccounts
 */
export var createCustomerBankAccount = function (client, customerId, globalCustomersBankAccountDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/bankAccounts"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersBankAccountDtoBody,
    }, options);
};
/**
 * PUT: Updates customer bank account
 * @summary customers/{customerId}/bankAccounts/{bankAccountId}
 */
export var updateCustomerBankAccount = function (client, customerId, bankAccountId, globalCustomersBankAccountDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/bankAccounts/").concat(bankAccountId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersBankAccountDtoBody,
    }, options);
};
/**
 * DELETE: Removes customer bank account by Id
 * @summary customers/{customerId}/bankAccounts/{bankAccountId}
 */
export var deleteCustomerBankAccount = function (client, customerId, bankAccountId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/bankAccounts/").concat(bankAccountId), method: 'delete', headers: headers }, options);
};
/**
 * GET: Gets metadata information for bank account endpoints of the customer with given customer id
 * @summary customers/{customerId}/bankAccountsMetadata
 */
export var getCustomerBankAccountsMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/bankAccountsMetadata"), method: 'get', headers: headers }, options);
};
export var getGetCustomerBankAccountsMetadataKey = function (customerId) {
    return ["/customers/".concat(customerId, "/bankAccountsMetadata")];
};
/**
 * @summary customers/{customerId}/bankAccountsMetadata
 */
export var useGetCustomerBankAccountsMetadata = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerBankAccountsMetadataKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerBankAccountsMetadata(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Authorize customer's bank account
 * @summary customers/{customerId}/bankAccounts/{bankAccountId}/authorizationRequest
 */
export var createCustomerBankAccountAuthorizationRequest = function (client, customerId, bankAccountId, globalCustomersBankAccountAuthorizationRequestDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/bankAccounts/").concat(bankAccountId, "/authorizationRequest"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersBankAccountAuthorizationRequestDto,
    }, options);
};
/**
 * Get bank bonus payment summary for period
 * @summary customers/{customerId}/bankBonusPaymentSummary
 */
export var getCustomerBankBonusPaymentSummary = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/bankBonusPaymentSummary"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerBankBonusPaymentSummaryKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/bankBonusPaymentSummary")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/bankBonusPaymentSummary
 */
export var useGetCustomerBankBonusPaymentSummary = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerBankBonusPaymentSummaryKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerBankBonusPaymentSummary(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides all bank branches matching the optional filters
 * @summary bankBranches
 */
export var getBankBranches = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/bankBranches", method: 'get', headers: headers, params: params }, options);
};
export var getGetBankBranchesKey = function (params) {
    return __spreadArray(["/bankBranches"], (params ? [params] : []), true);
};
/**
 * @summary bankBranches
 */
export var useGetBankBranches = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetBankBranchesKey(params) : null); });
    var swrFn = function () {
        return getBankBranches(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides bank branch by id
 * @summary bankBranches/{bankBranchId}
 */
export var getBankBranch = function (client, bankBranchId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/bankBranches/".concat(bankBranchId), method: 'get', headers: headers }, options);
};
export var getGetBankBranchKey = function (bankBranchId) {
    return ["/bankBranches/".concat(bankBranchId)];
};
/**
 * @summary bankBranches/{bankBranchId}
 */
export var useGetBankBranch = function (bankBranchId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!bankBranchId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetBankBranchKey(bankBranchId) : null); });
    var swrFn = function () {
        return getBankBranch(customInstance, bankBranchId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides all banks
 * @summary banks
 */
export var getBanks = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/banks", method: 'get', headers: headers, params: params }, options);
};
export var getGetBanksKey = function (params) {
    return __spreadArray(["/banks"], (params ? [params] : []), true);
};
/**
 * @summary banks
 */
export var useGetBanks = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetBanksKey(params) : null); });
    var swrFn = function () { return getBanks(customInstance, params, headers, requestOptions).then(function (d) { return d.data; }); };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns bank by id
 * @summary banks/{bankId}
 */
export var getBank = function (client, bankId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/banks/".concat(bankId), method: 'get', headers: headers }, options);
};
export var getGetBankKey = function (bankId) { return ["/banks/".concat(bankId)]; };
/**
 * @summary banks/{bankId}
 */
export var useGetBank = function (bankId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!bankId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetBankKey(bankId) : null); });
    var swrFn = function () { return getBank(customInstance, bankId, headers, requestOptions).then(function (d) { return d.data; }); };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provide basket with purchased products
 * @summary customers/{customerId}/basket
 */
export var getCustomerBasket = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/basket"), method: 'get', headers: headers }, options);
};
export var getGetCustomerBasketKey = function (customerId) {
    return ["/customers/".concat(customerId, "/basket")];
};
/**
 * @summary customers/{customerId}/basket
 */
export var useGetCustomerBasket = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerBasketKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerBasket(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Apply shopping bag related offer
 * @summary shoppingSessions/{sessionId}/basketOffers/{offerId}
 */
export var createShoppingSessionBasketOffer = function (client, sessionId, offerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/basketOffers/").concat(offerId), method: 'post', headers: headers }, options);
};
/**
 * PUT: Purchase shopping bag related offer
 * @summary shoppingSessions/{sessionId}/basketOffers/{offerId}
 */
export var updateShoppingSessionBasketOffer = function (client, sessionId, offerId, globalShoppingOfferChoicesDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/basketOffers/").concat(offerId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingOfferChoicesDto,
    }, options);
};
/**
 * GET: Get list of shopping bag related offers
 * @summary shoppingSessions/{sessionId}/basketOffers
 */
export var getShoppingSessionBasketOffers = function (client, sessionId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/basketOffers"), method: 'get', headers: headers, params: params }, options);
};
export var getGetShoppingSessionBasketOffersKey = function (sessionId, params) { return __spreadArray(["/shoppingSessions/".concat(sessionId, "/basketOffers")], (params ? [params] : []), true); };
/**
 * @summary shoppingSessions/{sessionId}/basketOffers
 */
export var useGetShoppingSessionBasketOffers = function (sessionId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionBasketOffersKey(sessionId, params) : null); });
    var swrFn = function () {
        return getShoppingSessionBasketOffers(customInstance, sessionId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets available blocking codes
 * @summary blockingCodes
 */
export var getBlockingCodes = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/blockingCodes", method: 'get', headers: headers, params: params }, options);
};
export var getGetBlockingCodesKey = function (params) {
    return __spreadArray(["/blockingCodes"], (params ? [params] : []), true);
};
/**
 * @summary blockingCodes
 */
export var useGetBlockingCodes = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetBlockingCodesKey(params) : null); });
    var swrFn = function () {
        return getBlockingCodes(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets blockings for given customer
 * @summary customers/{customerId}/blockings
 */
export var getCustomerBlockings = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/blockings"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerBlockingsKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/blockings")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/blockings
 */
export var useGetCustomerBlockings = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerBlockingsKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerBlockings(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * DELETE: Deletes single blocking for customer
 * @summary customers/{customerId}/blockings/{blockingId}
 */
export var deleteCustomerBlocking = function (client, customerId, blockingId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/blockings/").concat(blockingId), method: 'delete', headers: headers }, options);
};
/**
 * POST: Create customer's bonus commitment
 * @summary customers/{customerId}/bonusCommitment
 */
export var createCustomerBonusCommitment = function (client, customerId, globalCustomersCommitBonusCommitmentDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/bonusCommitment"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersCommitBonusCommitmentDto,
    }, options);
};
/**
 * GET: Returns branch for given customer
 * @summary customers/{customerId}/branch
 */
export var getCustomerBranch = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/branch"), method: 'get', headers: headers }, options);
};
export var getGetCustomerBranchKey = function (customerId) {
    return ["/customers/".concat(customerId, "/branch")];
};
/**
 * @summary customers/{customerId}/branch
 */
export var useGetCustomerBranch = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerBranchKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerBranch(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Updates branch for given customer
 * @summary customers/{customerId}/branch
 */
export var updateCustomerBranch = function (client, customerId, globalCustomersCustomerBranchDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/branch"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersCustomerBranchDto,
    }, options);
};
/**
 * GET: Returns metadata for customer branch
 * @summary customers/{customerId}/branchMetadata
 */
export var getCustomerBranchMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/branchMetadata"), method: 'get', headers: headers }, options);
};
export var getGetCustomerBranchMetadataKey = function (customerId) {
    return ["/customers/".concat(customerId, "/branchMetadata")];
};
/**
 * @summary customers/{customerId}/branchMetadata
 */
export var useGetCustomerBranchMetadata = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerBranchMetadataKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerBranchMetadata(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns all available Oriflame branches
 * @summary branches
 */
export var getBranches = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/branches", method: 'get', headers: headers }, options);
};
export var getGetBranchesKey = function () { return ["/branches"]; };
/**
 * @summary branches
 */
export var useGetBranches = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetBranchesKey() : null); });
    var swrFn = function () { return getBranches(customInstance, headers, requestOptions).then(function (d) { return d.data; }); };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns specific branch by ID
 * @summary branches/{branchId}
 */
export var getBranch = function (client, branchId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/branches/".concat(branchId), method: 'get', headers: headers }, options);
};
export var getGetBranchKey = function (branchId) { return ["/branches/".concat(branchId)]; };
/**
 * @summary branches/{branchId}
 */
export var useGetBranch = function (branchId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!branchId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetBranchKey(branchId) : null); });
    var swrFn = function () {
        return getBranch(customInstance, branchId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get all brands, optionally filtered by given category
 * @summary brands
 */
export var getBrands = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/brands", method: 'get', headers: headers, params: params }, options);
};
export var getGetBrandsKey = function (params) {
    return __spreadArray(["/brands"], (params ? [params] : []), true);
};
/**
 * @summary brands
 */
export var useGetBrands = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetBrandsKey(params) : null); });
    var swrFn = function () {
        return getBrands(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Creates a record of a call interaction between customer service and the customer.
 * @summary callInteractions
 */
export var createCallInteraction = function (client, globalCallInteractionsCallInteractionDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/callInteractions",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCallInteractionsCallInteractionDto,
    }, options);
};
/**
 * GET: Gets configuration of welcome program step targets
 * @summary campaigns/welcomeProgram/targets
 */
export var getCampaignsWelcomeProgramTargets = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/campaigns/welcomeProgram/targets", method: 'get', headers: headers }, options);
};
export var getGetCampaignsWelcomeProgramTargetsKey = function () {
    return ["/campaigns/welcomeProgram/targets"];
};
/**
 * @summary campaigns/welcomeProgram/targets
 */
export var useGetCampaignsWelcomeProgramTargets = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCampaignsWelcomeProgramTargetsKey() : null); });
    var swrFn = function () {
        return getCampaignsWelcomeProgramTargets(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets welcome program benefits
 * @summary campaigns/welcomeProgram/{step}/benefits
 */
export var getCampaignsWelcomeProgramBenefits = function (client, step, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/campaigns/welcomeProgram/".concat(step, "/benefits"), method: 'get', headers: headers }, options);
};
export var getGetCampaignsWelcomeProgramBenefitsKey = function (step) {
    return ["/campaigns/welcomeProgram/".concat(step, "/benefits")];
};
/**
 * @summary campaigns/welcomeProgram/{step}/benefits
 */
export var useGetCampaignsWelcomeProgramBenefits = function (step, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!step;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCampaignsWelcomeProgramBenefitsKey(step) : null); });
    var swrFn = function () {
        return getCampaignsWelcomeProgramBenefits(customInstance, step, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets configuration of activity program step targets
 * @summary campaigns/activityProgram/targets
 */
export var getCampaignsActivityProgramTargets = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/campaigns/activityProgram/targets", method: 'get', headers: headers }, options);
};
export var getGetCampaignsActivityProgramTargetsKey = function () {
    return ["/campaigns/activityProgram/targets"];
};
/**
 * @summary campaigns/activityProgram/targets
 */
export var useGetCampaignsActivityProgramTargets = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCampaignsActivityProgramTargetsKey() : null); });
    var swrFn = function () {
        return getCampaignsActivityProgramTargets(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets collection of points assigned to products in campaign
 * @deprecated
 * @summary customers/{customerId}/campaigns/{campaignType}/benefits
 */
export var getCustomerCampaignBenefits = function (client, customerId, campaignType, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/campaigns/").concat(campaignType, "/benefits"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCustomerCampaignBenefitsKey = function (customerId, campaignType, params) {
    return __spreadArray([
        "/customers/".concat(customerId, "/campaigns/").concat(campaignType, "/benefits")
    ], (params ? [params] : []), true);
};
/**
 * @deprecated
 * @summary customers/{customerId}/campaigns/{campaignType}/benefits
 */
export var useGetCustomerCampaignBenefits = function (customerId, campaignType, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && campaignType);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetCustomerCampaignBenefitsKey(customerId, campaignType, params) : null;
    });
    var swrFn = function () {
        return getCustomerCampaignBenefits(customInstance, customerId, campaignType, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets campaigns points of the customer
 * @summary campaigns/{campaignId}/points
 */
export var getCampaignPoints = function (client, campaignId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/campaigns/".concat(campaignId, "/points"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCampaignPointsKey = function (campaignId, params) {
    return __spreadArray(["/campaigns/".concat(campaignId, "/points")], (params ? [params] : []), true);
};
/**
 * @summary campaigns/{campaignId}/points
 */
export var useGetCampaignPoints = function (campaignId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!campaignId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCampaignPointsKey(campaignId, params) : null); });
    var swrFn = function () {
        return getCampaignPoints(customInstance, campaignId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets campaigns points of the sponsor earned by recruits
 * @summary campaigns/{campaignId}/recruitPoints
 */
export var getCampaignRecruitPoints = function (client, campaignId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/campaigns/".concat(campaignId, "/recruitPoints"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCampaignRecruitPointsKey = function (campaignId, params) { return __spreadArray(["/campaigns/".concat(campaignId, "/recruitPoints")], (params ? [params] : []), true); };
/**
 * @summary campaigns/{campaignId}/recruitPoints
 */
export var useGetCampaignRecruitPoints = function (campaignId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!campaignId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCampaignRecruitPointsKey(campaignId, params) : null); });
    var swrFn = function () {
        return getCampaignRecruitPoints(customInstance, campaignId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets campaign points transactions (earned, redeemed, expired)
 * @summary campaigns/{campaignId}/transactions
 */
export var getCampaignTransactions = function (client, campaignId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/campaigns/".concat(campaignId, "/transactions"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCampaignTransactionsKey = function (campaignId, params) { return __spreadArray(["/campaigns/".concat(campaignId, "/transactions")], (params ? [params] : []), true); };
/**
 * @summary campaigns/{campaignId}/transactions
 */
export var useGetCampaignTransactions = function (campaignId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!campaignId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCampaignTransactionsKey(campaignId, params) : null); });
    var swrFn = function () {
        return getCampaignTransactions(customInstance, campaignId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets orders of the customer together with points earned and redeemed by that orders
<param name="tenant">Tenant name</param><param name="customerId">Customer Id</param><param name="periodId">Period Id</param><param name="filters">Additional filter URL encoded expression. Eg. Bp GT 100 | (ConsultantName CONTAINS John & ConsultantName NEQ Rambo)</param><param name="sort">Sort expression (field sortType)</param><param name="includeTotalCountInResult">Include total count in result</param><param name="skip">Skip</param><param name="take">Take</param>
 * @summary customer/{customerId}/reports/campaignPointsByOrders
 */
export var getCustomerReportsCampaignPointsByOrders = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customer/".concat(customerId, "/reports/campaignPointsByOrders"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCustomerReportsCampaignPointsByOrdersKey = function (customerId, params) {
    return __spreadArray(["/customer/".concat(customerId, "/reports/campaignPointsByOrders")], (params ? [params] : []), true);
};
/**
 * @summary customer/{customerId}/reports/campaignPointsByOrders
 */
export var useGetCustomerReportsCampaignPointsByOrders = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerReportsCampaignPointsByOrdersKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerReportsCampaignPointsByOrders(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets campaigns filterable by optional parameters
 * @summary campaigns
 */
export var getCampaigns = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/campaigns", method: 'get', headers: headers, params: params }, options);
};
export var getGetCampaignsKey = function (params) {
    return __spreadArray(["/campaigns"], (params ? [params] : []), true);
};
/**
 * @summary campaigns
 */
export var useGetCampaigns = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCampaignsKey(params) : null); });
    var swrFn = function () {
        return getCampaigns(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get specific campaign
 * @summary campaigns/{campaignId}
 */
export var getCampaign = function (client, campaignId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/campaigns/".concat(campaignId), method: 'get', headers: headers }, options);
};
export var getGetCampaignKey = function (campaignId) { return ["/campaigns/".concat(campaignId)]; };
/**
 * @summary campaigns/{campaignId}
 */
export var useGetCampaign = function (campaignId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!campaignId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCampaignKey(campaignId) : null); });
    var swrFn = function () {
        return getCampaign(customInstance, campaignId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get products offered as campaign benefits
 * @summary campaigns/{campaignId}/benefits
 */
export var getCampaignBenefits = function (client, campaignId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/campaigns/".concat(campaignId, "/benefits"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCampaignBenefitsKey = function (campaignId, params) {
    return __spreadArray(["/campaigns/".concat(campaignId, "/benefits")], (params ? [params] : []), true);
};
/**
 * @summary campaigns/{campaignId}/benefits
 */
export var useGetCampaignBenefits = function (campaignId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!campaignId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCampaignBenefitsKey(campaignId, params) : null); });
    var swrFn = function () {
        return getCampaignBenefits(customInstance, campaignId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provide content of the catalogue
 * @summary catalogues/catalogue/{catalogueCode}/content
 */
export var getCataloguesCatalogueContent = function (client, catalogueCode, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/catalogues/catalogue/".concat(catalogueCode, "/content"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCataloguesCatalogueContentKey = function (catalogueCode, params) { return __spreadArray(["/catalogues/catalogue/".concat(catalogueCode, "/content")], (params ? [params] : []), true); };
/**
 * @summary catalogues/catalogue/{catalogueCode}/content
 */
export var useGetCataloguesCatalogueContent = function (catalogueCode, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!catalogueCode;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCataloguesCatalogueContentKey(catalogueCode, params) : null); });
    var swrFn = function () {
        return getCataloguesCatalogueContent(customInstance, catalogueCode, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets configuration for CatalogueIPaper for authorized customer.
 * @summary applications/catalogueIPaper/customers/{customerId}/configuration
 */
export var getApplicationsCatalogueIPaperCustomerConfiguration = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/catalogueIPaper/customers/".concat(customerId, "/configuration"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetApplicationsCatalogueIPaperCustomerConfigurationKey = function (customerId) {
    return ["/applications/catalogueIPaper/customers/".concat(customerId, "/configuration")];
};
/**
 * @summary applications/catalogueIPaper/customers/{customerId}/configuration
 */
export var useGetApplicationsCatalogueIPaperCustomerConfiguration = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetApplicationsCatalogueIPaperCustomerConfigurationKey(customerId) : null;
    });
    var swrFn = function () {
        return getApplicationsCatalogueIPaperCustomerConfiguration(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provide catalogue item
 * @summary catalogues/{catalogueId}/catalogueItems/{catalogueItemId}
 */
export var getCatalogueCatalogueItem = function (client, catalogueId, catalogueItemId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/catalogues/".concat(catalogueId, "/catalogueItems/").concat(catalogueItemId), method: 'get', headers: headers }, options);
};
export var getGetCatalogueCatalogueItemKey = function (catalogueId, catalogueItemId) {
    return ["/catalogues/".concat(catalogueId, "/catalogueItems/").concat(catalogueItemId)];
};
/**
 * @summary catalogues/{catalogueId}/catalogueItems/{catalogueItemId}
 */
export var useGetCatalogueCatalogueItem = function (catalogueId, catalogueItemId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(catalogueId && catalogueItemId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCatalogueCatalogueItemKey(catalogueId, catalogueItemId) : null); });
    var swrFn = function () {
        return getCatalogueCatalogueItem(customInstance, catalogueId, catalogueItemId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provide items of the catalogue
 * @summary catalogues/{catalogueId}/catalogueItems
 */
export var getCatalogueCatalogueItems = function (client, catalogueId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/catalogues/".concat(catalogueId, "/catalogueItems"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCatalogueCatalogueItemsKey = function (catalogueId, params) { return __spreadArray(["/catalogues/".concat(catalogueId, "/catalogueItems")], (params ? [params] : []), true); };
/**
 * @summary catalogues/{catalogueId}/catalogueItems
 */
export var useGetCatalogueCatalogueItems = function (catalogueId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!catalogueId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCatalogueCatalogueItemsKey(catalogueId, params) : null); });
    var swrFn = function () {
        return getCatalogueCatalogueItems(customInstance, catalogueId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provide merchandising offers related to printed catalogue
 * @summary catalogueOffers
 */
export var getCatalogueOffers = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/catalogueOffers", method: 'get', headers: headers, params: params }, options);
};
export var getGetCatalogueOffersKey = function (params) {
    return __spreadArray(["/catalogueOffers"], (params ? [params] : []), true);
};
/**
 * @summary catalogueOffers
 */
export var useGetCatalogueOffers = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCatalogueOffersKey(params) : null); });
    var swrFn = function () {
        return getCatalogueOffers(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provide catalogues related to the period
 * @deprecated
 * @summary catalogues
 */
export var getCataloguesDeprecated = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/catalogues", method: 'get', headers: headers, params: params }, options);
};
export var getGetCataloguesDeprecatedKey = function (params) {
    return __spreadArray(["/catalogues"], (params ? [params] : []), true);
};
/**
 * @deprecated
 * @summary catalogues
 */
export var useGetCataloguesDeprecated = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCataloguesDeprecatedKey(params) : null); });
    var swrFn = function () {
        return getCataloguesDeprecated(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get all categories
 * @summary categories
 */
export var getCategories = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/categories", method: 'get', headers: headers }, options);
};
export var getGetCategoriesKey = function () { return ["/categories"]; };
/**
 * @summary categories
 */
export var useGetCategories = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCategoriesKey() : null); });
    var swrFn = function () { return getCategories(customInstance, headers, requestOptions).then(function (d) { return d.data; }); };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns Chat bot configuration
 * @summary applications/chatBot/configuration
 */
export var getApplicationsChatBotConfiguration = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/chatBot/configuration", method: 'get', headers: headers }, options);
};
export var getGetApplicationsChatBotConfigurationKey = function () {
    return ["/applications/chatBot/configuration"];
};
/**
 * @summary applications/chatBot/configuration
 */
export var useGetApplicationsChatBotConfiguration = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsChatBotConfigurationKey() : null); });
    var swrFn = function () {
        return getApplicationsChatBotConfiguration(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Query claims history
 * @summary claims
 */
export var getClaims = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/claims", method: 'get', headers: headers, params: params }, options);
};
export var getGetClaimsKey = function (params) {
    return __spreadArray(["/claims"], (params ? [params] : []), true);
};
/**
 * @summary claims
 */
export var useGetClaims = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetClaimsKey(params) : null); });
    var swrFn = function () {
        return getClaims(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get specific claim of a customer
 * @summary claims/{claimId}
 */
export var getClaim = function (client, claimId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/claims/".concat(claimId), method: 'get', headers: headers }, options);
};
export var getGetClaimKey = function (claimId) { return ["/claims/".concat(claimId)]; };
/**
 * @summary claims/{claimId}
 */
export var useGetClaim = function (claimId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!claimId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetClaimKey(claimId) : null); });
    var swrFn = function () {
        return getClaim(customInstance, claimId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provide claim items
 * @summary claims/{claimId}/claimItems
 */
export var getClaimClaimItems = function (client, claimId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/claims/".concat(claimId, "/claimItems"), method: 'get', headers: headers }, options);
};
export var getGetClaimClaimItemsKey = function (claimId) {
    return ["/claims/".concat(claimId, "/claimItems")];
};
/**
 * @summary claims/{claimId}/claimItems
 */
export var useGetClaimClaimItems = function (claimId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!claimId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetClaimClaimItemsKey(claimId) : null); });
    var swrFn = function () {
        return getClaimClaimItems(customInstance, claimId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides delivery selection of supplementary order.
 * @summary claims/{claimId}/delivery
 */
export var getClaimDelivery = function (client, claimId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/claims/".concat(claimId, "/delivery"), method: 'get', headers: headers }, options);
};
export var getGetClaimDeliveryKey = function (claimId) { return ["/claims/".concat(claimId, "/delivery")]; };
/**
 * @summary claims/{claimId}/delivery
 */
export var useGetClaimDelivery = function (claimId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!claimId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetClaimDeliveryKey(claimId) : null); });
    var swrFn = function () {
        return getClaimDelivery(customInstance, claimId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Update delivery of supplementary order.
 * @summary claims/{claimId}/delivery
 */
export var updateClaimDelivery = function (client, claimId, globalClaimSessionsClaimDeliveryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/claims/".concat(claimId, "/delivery"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalClaimSessionsClaimDeliveryDtoBody,
    }, options);
};
/**
 * GET: Provides available delivery methods
 * @summary claims/{claimId}/deliveryMethods
 */
export var getClaimDeliveryMethods = function (client, claimId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/claims/".concat(claimId, "/deliveryMethods"), method: 'get', headers: headers }, options);
};
export var getGetClaimDeliveryMethodsKey = function (claimId) {
    return ["/claims/".concat(claimId, "/deliveryMethods")];
};
/**
 * @summary claims/{claimId}/deliveryMethods
 */
export var useGetClaimDeliveryMethods = function (claimId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!claimId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetClaimDeliveryMethodsKey(claimId) : null); });
    var swrFn = function () {
        return getClaimDeliveryMethods(customInstance, claimId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides available delivery channels
 * @summary claims/{claimId}/deliveryChannels
 */
export var getClaimDeliveryChannels = function (client, claimId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/claims/".concat(claimId, "/deliveryChannels"), method: 'get', headers: headers, params: params }, options);
};
export var getGetClaimDeliveryChannelsKey = function (claimId, params) { return __spreadArray(["/claims/".concat(claimId, "/deliveryChannels")], (params ? [params] : []), true); };
/**
 * @summary claims/{claimId}/deliveryChannels
 */
export var useGetClaimDeliveryChannels = function (claimId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!claimId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetClaimDeliveryChannelsKey(claimId, params) : null); });
    var swrFn = function () {
        return getClaimDeliveryChannels(customInstance, claimId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provide the claim tracking
 * @summary claims/{claimId}/tracking
 */
export var getClaimTracking = function (client, claimId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/claims/".concat(claimId, "/tracking"), method: 'get', headers: headers }, options);
};
export var getGetClaimTrackingKey = function (claimId) { return ["/claims/".concat(claimId, "/tracking")]; };
/**
 * @summary claims/{claimId}/tracking
 */
export var useGetClaimTracking = function (claimId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!claimId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetClaimTrackingKey(claimId) : null); });
    var swrFn = function () {
        return getClaimTracking(customInstance, claimId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Process claim by customer service
 * @summary claims/{claimId}/processing
 */
export var updateClaimProcessing = function (client, claimId, globalClaimsClaimProcessDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/claims/".concat(claimId, "/processing"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalClaimsClaimProcessDto,
    }, options);
};
/**
 * PUT: Approve/refuse a claim
 * @summary claims/{claimId}/approval
 */
export var updateClaimApproval = function (client, claimId, globalClaimsClaimApprovalDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/claims/".concat(claimId, "/approval"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalClaimsClaimApprovalDto,
    }, options);
};
/**
 * GET: Get claim categories based on claim type
 * @summary claimCategories
 */
export var getClaimCategories = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/claimCategories", method: 'get', headers: headers, params: params }, options);
};
export var getGetClaimCategoriesKey = function (params) {
    return __spreadArray(["/claimCategories"], (params ? [params] : []), true);
};
/**
 * @summary claimCategories
 */
export var useGetClaimCategories = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetClaimCategoriesKey(params) : null); });
    var swrFn = function () {
        return getClaimCategories(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get sub-categories of claim category
 * @summary claimCategories/{claimCategory}/subCategories
 */
export var getClaimCategorySubCategories = function (client, claimCategory, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/claimCategories/".concat(claimCategory, "/subCategories"), method: 'get', headers: headers }, options);
};
export var getGetClaimCategorySubCategoriesKey = function (claimCategory) { return ["/claimCategories/".concat(claimCategory, "/subCategories")]; };
/**
 * @summary claimCategories/{claimCategory}/subCategories
 */
export var useGetClaimCategorySubCategories = function (claimCategory, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!claimCategory;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetClaimCategorySubCategoriesKey(claimCategory) : null); });
    var swrFn = function () {
        return getClaimCategorySubCategories(customInstance, claimCategory, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get causes of claim category
 * @summary claimCategories/{claimCategory}/causes
 */
export var getClaimCategoryCauses = function (client, claimCategory, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/claimCategories/".concat(claimCategory, "/causes"), method: 'get', headers: headers }, options);
};
export var getGetClaimCategoryCausesKey = function (claimCategory) { return ["/claimCategories/".concat(claimCategory, "/causes")]; };
/**
 * @summary claimCategories/{claimCategory}/causes
 */
export var useGetClaimCategoryCauses = function (claimCategory, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!claimCategory;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetClaimCategoryCausesKey(claimCategory) : null); });
    var swrFn = function () {
        return getClaimCategoryCauses(customInstance, claimCategory, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get reasons of claim cause
 * @summary claimCategories/{claimCategory}/causes/{claimCause}/reasons
 */
export var getClaimCategoryCauseReasons = function (client, claimCategory, claimCause, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/claimCategories/".concat(claimCategory, "/causes/").concat(claimCause, "/reasons"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetClaimCategoryCauseReasonsKey = function (claimCategory, claimCause) { return ["/claimCategories/".concat(claimCategory, "/causes/").concat(claimCause, "/reasons")]; };
/**
 * @summary claimCategories/{claimCategory}/causes/{claimCause}/reasons
 */
export var useGetClaimCategoryCauseReasons = function (claimCategory, claimCause, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(claimCategory && claimCause);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetClaimCategoryCauseReasonsKey(claimCategory, claimCause) : null); });
    var swrFn = function () {
        return getClaimCategoryCauseReasons(customInstance, claimCategory, claimCause, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get actions of claim category
 * @summary claimCategories/{claimCategory}/actions
 */
export var getClaimCategoryActions = function (client, claimCategory, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/claimCategories/".concat(claimCategory, "/actions"), method: 'get', headers: headers }, options);
};
export var getGetClaimCategoryActionsKey = function (claimCategory) { return ["/claimCategories/".concat(claimCategory, "/actions")]; };
/**
 * @summary claimCategories/{claimCategory}/actions
 */
export var useGetClaimCategoryActions = function (claimCategory, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!claimCategory;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetClaimCategoryActionsKey(claimCategory) : null); });
    var swrFn = function () {
        return getClaimCategoryActions(customInstance, claimCategory, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get scenarios for claim category, cause and action
 * @summary claimCategories/{claimCategory}/scenarios
 */
export var getClaimCategoryScenarios = function (client, claimCategory, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/claimCategories/".concat(claimCategory, "/scenarios"), method: 'get', headers: headers, params: params }, options);
};
export var getGetClaimCategoryScenariosKey = function (claimCategory, params) { return __spreadArray(["/claimCategories/".concat(claimCategory, "/scenarios")], (params ? [params] : []), true); };
/**
 * @summary claimCategories/{claimCategory}/scenarios
 */
export var useGetClaimCategoryScenarios = function (claimCategory, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!claimCategory;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetClaimCategoryScenariosKey(claimCategory, params) : null); });
    var swrFn = function () {
        return getClaimCategoryScenarios(customInstance, claimCategory, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Set delivery of supplementary order.
 * @summary claimSessions/{sessionId}/delivery
 */
export var updateClaimSessionDelivery = function (client, sessionId, globalClaimSessionsClaimDeliveryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/claimSessions/".concat(sessionId, "/delivery"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalClaimSessionsClaimDeliveryDtoBody,
    }, options);
};
/**
 * GET: Gets customer's delivery selection of supplementary order.
 * @summary claimSessions/{sessionId}/delivery
 */
export var getClaimSessionDelivery = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/claimSessions/".concat(sessionId, "/delivery"), method: 'get', headers: headers }, options);
};
export var getGetClaimSessionDeliveryKey = function (sessionId) {
    return ["/claimSessions/".concat(sessionId, "/delivery")];
};
/**
 * @summary claimSessions/{sessionId}/delivery
 */
export var useGetClaimSessionDelivery = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetClaimSessionDeliveryKey(sessionId) : null); });
    var swrFn = function () {
        return getClaimSessionDelivery(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides available delivery channels
 * @summary claimSessions/{sessionId}/deliveryChannels
 */
export var getClaimSessionDeliveryChannels = function (client, sessionId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/claimSessions/".concat(sessionId, "/deliveryChannels"), method: 'get', headers: headers, params: params }, options);
};
export var getGetClaimSessionDeliveryChannelsKey = function (sessionId, params) { return __spreadArray(["/claimSessions/".concat(sessionId, "/deliveryChannels")], (params ? [params] : []), true); };
/**
 * @summary claimSessions/{sessionId}/deliveryChannels
 */
export var useGetClaimSessionDeliveryChannels = function (sessionId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetClaimSessionDeliveryChannelsKey(sessionId, params) : null); });
    var swrFn = function () {
        return getClaimSessionDeliveryChannels(customInstance, sessionId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides available delivery methods
 * @summary claimSessions/{sessionId}/deliveryMethods
 */
export var getClaimSessionDeliveryMethods = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/claimSessions/".concat(sessionId, "/deliveryMethods"), method: 'get', headers: headers }, options);
};
export var getGetClaimSessionDeliveryMethodsKey = function (sessionId) {
    return ["/claimSessions/".concat(sessionId, "/deliveryMethods")];
};
/**
 * @summary claimSessions/{sessionId}/deliveryMethods
 */
export var useGetClaimSessionDeliveryMethods = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetClaimSessionDeliveryMethodsKey(sessionId) : null); });
    var swrFn = function () {
        return getClaimSessionDeliveryMethods(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Set customer's note.
 * @summary claimSessions/{sessionId}/description
 */
export var updateClaimSessionDescription = function (client, sessionId, globalClaimSessionsClaimDescriptionDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/claimSessions/".concat(sessionId, "/description"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalClaimSessionsClaimDescriptionDto,
    }, options);
};
/**
 * GET: Gets customer's note.
 * @summary claimSessions/{sessionId}/description
 */
export var getClaimSessionDescription = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/claimSessions/".concat(sessionId, "/description"), method: 'get', headers: headers }, options);
};
export var getGetClaimSessionDescriptionKey = function (sessionId) {
    return ["/claimSessions/".concat(sessionId, "/description")];
};
/**
 * @summary claimSessions/{sessionId}/description
 */
export var useGetClaimSessionDescription = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetClaimSessionDescriptionKey(sessionId) : null); });
    var swrFn = function () {
        return getClaimSessionDescription(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Submit new claim
 * @summary claimSessions/{sessionId}/claim
 */
export var createClaimSessionClaim = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/claimSessions/".concat(sessionId, "/claim"), method: 'post', headers: headers }, options);
};
/**
 * POST: Return order item
 * @summary claimSessions/{sessionId}/returnedItems
 */
export var createClaimSessionReturnedItem = function (client, sessionId, globalClaimSessionsReturnClaimItemDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/claimSessions/".concat(sessionId, "/returnedItems"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalClaimSessionsReturnClaimItemDto,
    }, options);
};
/**
 * PUT: Cancel order
 * @summary claimSessions/{sessionId}/returnedItems
 */
export var updateClaimSessionReturnedItems = function (client, sessionId, globalClaimSessionsDistributionIssueDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/claimSessions/".concat(sessionId, "/returnedItems"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalClaimSessionsDistributionIssueDtoBody,
    }, options);
};
/**
 * POST: Submit missing order item
 * @summary claimSessions/{sessionId}/missingItems
 */
export var createClaimSessionMissingItem = function (client, sessionId, globalClaimSessionsMissingClaimItemDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/claimSessions/".concat(sessionId, "/missingItems"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalClaimSessionsMissingClaimItemDto,
    }, options);
};
/**
 * PUT: Submit missing order items
 * @summary claimSessions/{sessionId}/missingItems
 */
export var updateClaimSessionMissingItems = function (client, sessionId, globalClaimSessionsMissingClaimItemsDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/claimSessions/".concat(sessionId, "/missingItems"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalClaimSessionsMissingClaimItemsDto,
    }, options);
};
/**
 * POST: Exchange order item
 * @summary claimSessions/{sessionId}/exchangedItems
 */
export var createClaimSessionExchangedItem = function (client, sessionId, globalClaimSessionsExchangeClaimItemDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/claimSessions/".concat(sessionId, "/exchangedItems"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalClaimSessionsExchangeClaimItemDto,
    }, options);
};
/**
 * PUT: Resend order
 * @summary claimSessions/{sessionId}/exchangedItems
 */
export var updateClaimSessionExchangedItems = function (client, sessionId, globalClaimSessionsDistributionIssueDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/claimSessions/".concat(sessionId, "/exchangedItems"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalClaimSessionsDistributionIssueDtoBody,
    }, options);
};
/**
 * POST: Submit wrong price of order item
 * @summary claimSessions/{sessionId}/wrongItems
 */
export var createClaimSessionWrongItem = function (client, sessionId, globalClaimSessionsClaimItemBaseDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/claimSessions/".concat(sessionId, "/wrongItems"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalClaimSessionsClaimItemBaseDto,
    }, options);
};
/**
 * GET: Gets submitted claim items
 * @summary claimSessions/{sessionId}/claimItems
 */
export var getClaimSessionClaimItems = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/claimSessions/".concat(sessionId, "/claimItems"), method: 'get', headers: headers }, options);
};
export var getGetClaimSessionClaimItemsKey = function (sessionId) {
    return ["/claimSessions/".concat(sessionId, "/claimItems")];
};
/**
 * @summary claimSessions/{sessionId}/claimItems
 */
export var useGetClaimSessionClaimItems = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetClaimSessionClaimItemsKey(sessionId) : null); });
    var swrFn = function () {
        return getClaimSessionClaimItems(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * DELETE: Clear submitted claim items
 * @summary claimSessions/{sessionId}/claimItems
 */
export var deleteClaimSessionClaimItems = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/claimSessions/".concat(sessionId, "/claimItems"), method: 'delete', headers: headers }, options);
};
/**
 * GET: Gets order items to complaint.
 * @summary claimSessions/{sessionId}/orderItems
 */
export var getClaimSessionOrderItems = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/claimSessions/".concat(sessionId, "/orderItems"), method: 'get', headers: headers }, options);
};
export var getGetClaimSessionOrderItemsKey = function (sessionId) {
    return ["/claimSessions/".concat(sessionId, "/orderItems")];
};
/**
 * @summary claimSessions/{sessionId}/orderItems
 */
export var useGetClaimSessionOrderItems = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetClaimSessionOrderItemsKey(sessionId) : null); });
    var swrFn = function () {
        return getClaimSessionOrderItems(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns catalogue items from all catalogues for specified period and product code
 * @summary applications/claimsSpa/catalogueItemsSearch
 */
export var getApplicationsClaimsSpaCatalogueItemsSearch = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/claimsSpa/catalogueItemsSearch", method: 'get', headers: headers, params: params }, options);
};
export var getGetApplicationsClaimsSpaCatalogueItemsSearchKey = function (params) { return __spreadArray(["/applications/claimsSpa/catalogueItemsSearch"], (params ? [params] : []), true); };
/**
 * @summary applications/claimsSpa/catalogueItemsSearch
 */
export var useGetApplicationsClaimsSpaCatalogueItemsSearch = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsClaimsSpaCatalogueItemsSearchKey(params) : null); });
    var swrFn = function () {
        return getApplicationsClaimsSpaCatalogueItemsSearch(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get claim scenario
 * @summary claimScenarios/{scenarioId}
 */
export var getClaimScenario = function (client, scenarioId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/claimScenarios/".concat(scenarioId), method: 'get', headers: headers }, options);
};
export var getGetClaimScenarioKey = function (scenarioId) {
    return ["/claimScenarios/".concat(scenarioId)];
};
/**
 * @summary claimScenarios/{scenarioId}
 */
export var useGetClaimScenario = function (scenarioId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!scenarioId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetClaimScenarioKey(scenarioId) : null); });
    var swrFn = function () {
        return getClaimScenario(customInstance, scenarioId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Starts new claim session.
 * @summary claimSessions
 */
export var createClaimSession = function (client, globalClaimSessionsClaimingDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/claimSessions",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalClaimSessionsClaimingDto,
    }, options);
};
/**
 * GET: Gets claim session data.
Session expires after 60 minutes if not refreshed by any non read-only action.
 * @summary claimSessions/{sessionId}
 */
export var getClaimSession = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/claimSessions/".concat(sessionId), method: 'get', headers: headers }, options);
};
export var getGetClaimSessionKey = function (sessionId) {
    return ["/claimSessions/".concat(sessionId)];
};
/**
 * @summary claimSessions/{sessionId}
 */
export var useGetClaimSession = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetClaimSessionKey(sessionId) : null); });
    var swrFn = function () {
        return getClaimSession(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets collection of concept labels for anonymous customer.
 * @summary conceptLabels
 */
export var getConceptLabels = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/conceptLabels", method: 'get', headers: headers, params: params }, options);
};
export var getGetConceptLabelsKey = function (params) {
    return __spreadArray(["/conceptLabels"], (params ? [params] : []), true);
};
/**
 * @summary conceptLabels
 */
export var useGetConceptLabels = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetConceptLabelsKey(params) : null); });
    var swrFn = function () {
        return getConceptLabels(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets concept search results by the specified category. This endpoint implements category navigation and search functionality.
 * @summary navigationCategories/{category}/concepts
 */
export var getNavigationCategoryConcepts = function (client, category, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/navigationCategories/".concat(category, "/concepts"), method: 'get', headers: headers, params: params }, options);
};
export var getGetNavigationCategoryConceptsKey = function (category, params) { return __spreadArray(["/navigationCategories/".concat(category, "/concepts")], (params ? [params] : []), true); };
/**
 * @summary navigationCategories/{category}/concepts
 */
export var useGetNavigationCategoryConcepts = function (category, headers, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!category;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetNavigationCategoryConceptsKey(category, params) : null); });
    var swrFn = function () {
        return getNavigationCategoryConcepts(customInstance, category, headers, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets concept search results by the specified brand. This endpoint implements  brand navigation and search functionality.
 * @summary navigationBrands/{brand}/concepts
 */
export var getNavigationBrandConcepts = function (client, brand, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/navigationBrands/".concat(brand, "/concepts"), method: 'get', headers: headers, params: params }, options);
};
export var getGetNavigationBrandConceptsKey = function (brand, params) { return __spreadArray(["/navigationBrands/".concat(brand, "/concepts")], (params ? [params] : []), true); };
/**
 * @summary navigationBrands/{brand}/concepts
 */
export var useGetNavigationBrandConcepts = function (brand, headers, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!brand;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetNavigationBrandConceptsKey(brand, params) : null); });
    var swrFn = function () {
        return getNavigationBrandConcepts(customInstance, brand, headers, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets concept search results by the specified query or a concept filter filterParams.
 * @summary searchConcepts
 */
export var getSearchConcepts = function (client, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/searchConcepts", method: 'get', headers: headers, params: params }, options);
};
export var getGetSearchConceptsKey = function (params) {
    return __spreadArray(["/searchConcepts"], (params ? [params] : []), true);
};
/**
 * @summary searchConcepts
 */
export var useGetSearchConcepts = function (headers, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetSearchConceptsKey(params) : null); });
    var swrFn = function () {
        return getSearchConcepts(customInstance, headers, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Returns concepts
 * @summary concepts
 */
export var getConcepts = function (client, globalConceptsQueryDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/concepts",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalConceptsQueryDto,
    }, options);
};
/**
 * GET: Provides concept
 * @summary concepts/{conceptCode}
 */
export var getConcept = function (client, conceptCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/concepts/".concat(conceptCode), method: 'get', headers: headers }, options);
};
export var getGetConceptKey = function (conceptCode) { return ["/concepts/".concat(conceptCode)]; };
/**
 * @summary concepts/{conceptCode}
 */
export var useGetConcept = function (conceptCode, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!conceptCode;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetConceptKey(conceptCode) : null); });
    var swrFn = function () {
        return getConcept(customInstance, conceptCode, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Submits email with backoffice configuration
 * @summary applications/concernReportForm
 */
export var createApplicationsConcernReportForm = function (client, globalConcernReportFormConcernReportFormDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/concernReportForm",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalConcernReportFormConcernReportFormDto,
    }, options);
};
/**
 * POST: Confirms entity (email, phone etc.) by confirmation code
 * @summary customers/{customerId}/confirmation
 */
export var createCustomerConfirmation = function (client, customerId, globalCustomersConfirmationDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/confirmation"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersConfirmationDto,
    }, options);
};
/**
 * Provides information about connected user to WeChat account
 * @summary login/providers/weChat/externalAccount/{unionId}/connectedUser
 */
export var getLoginProvidersWeChatExternalAccountConnectedUser = function (client, unionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/login/providers/weChat/externalAccount/".concat(unionId, "/connectedUser"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetLoginProvidersWeChatExternalAccountConnectedUserKey = function (unionId) {
    return ["/login/providers/weChat/externalAccount/".concat(unionId, "/connectedUser")];
};
/**
 * @summary login/providers/weChat/externalAccount/{unionId}/connectedUser
 */
export var useGetLoginProvidersWeChatExternalAccountConnectedUser = function (unionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!unionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetLoginProvidersWeChatExternalAccountConnectedUserKey(unionId) : null); });
    var swrFn = function () {
        return getLoginProvidersWeChatExternalAccountConnectedUser(customInstance, unionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the titles.
 * @summary consultantTitles
 */
export var getConsultantTitles = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/consultantTitles", method: 'get', headers: headers }, options);
};
export var getGetConsultantTitlesKey = function () { return ["/consultantTitles"]; };
/**
 * @summary consultantTitles
 */
export var useGetConsultantTitles = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetConsultantTitlesKey() : null); });
    var swrFn = function () {
        return getConsultantTitles(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns information about contact details of registration with given ID
 * @summary customerRegistrations/{registrationId}/contactDetails
 */
export var getCustomerRegistrationContactDetails = function (client, registrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customerRegistrations/".concat(registrationId, "/contactDetails"), method: 'get', headers: headers }, options);
};
export var getGetCustomerRegistrationContactDetailsKey = function (registrationId) {
    return ["/customerRegistrations/".concat(registrationId, "/contactDetails")];
};
/**
 * @summary customerRegistrations/{registrationId}/contactDetails
 */
export var useGetCustomerRegistrationContactDetails = function (registrationId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!registrationId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerRegistrationContactDetailsKey(registrationId) : null); });
    var swrFn = function () {
        return getCustomerRegistrationContactDetails(customInstance, registrationId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Modifies information about contact details of registration with given ID
 * @summary customerRegistrations/{registrationId}/contactDetails
 */
export var updateCustomerRegistrationContactDetails = function (client, registrationId, globalCustomerRegistrationsRegistrationContactDetailsDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customerRegistrations/".concat(registrationId, "/contactDetails"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomerRegistrationsRegistrationContactDetailsDto,
    }, options);
};
/**
 * POST: Confirms contact details by confirmation code
 * @summary customerRegistrations/{registrationId}/contactDetails/confirmation
 */
export var createCustomerRegistrationContactDetailsConfirmation = function (client, registrationId, globalCustomerRegistrationsRegistrationContactDetailsConfirmationDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customerRegistrations/".concat(registrationId, "/contactDetails/confirmation"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomerRegistrationsRegistrationContactDetailsConfirmationDto,
    }, options);
};
/**
 * GET: Returns documents for specific custom document
 * @summary customers/{customerId}/customDocuments/{customDocumentId}
 */
export var getCustomerCustomDocument = function (client, customerId, customDocumentId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/customDocuments/").concat(customDocumentId), method: 'get', headers: headers }, options);
};
export var getGetCustomerCustomDocumentKey = function (customerId, customDocumentId) {
    return ["/customers/".concat(customerId, "/customDocuments/").concat(customDocumentId)];
};
/**
 * @summary customers/{customerId}/customDocuments/{customDocumentId}
 */
export var useGetCustomerCustomDocument = function (customerId, customDocumentId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && customDocumentId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerCustomDocumentKey(customerId, customDocumentId) : null); });
    var swrFn = function () {
        return getCustomerCustomDocument(customInstance, customerId, customDocumentId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Change data for specific custom document (temporary document are submitted and will no longer be deleted)
 * @summary customers/{customerId}/customDocuments/{customDocumentId}
 */
export var updateCustomerCustomDocument = function (client, customerId, customDocumentId, globalCustomersCustomDocumentsDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/customDocuments/").concat(customDocumentId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersCustomDocumentsDto,
    }, options);
};
/**
 * Get customer Id by consultant number
 * @summary consultants/{consultantNumber}/customerId
 */
export var getConsultantCustomerId = function (client, consultantNumber, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/consultants/".concat(consultantNumber, "/customerId"), method: 'get', headers: headers }, options);
};
export var getGetConsultantCustomerIdKey = function (consultantNumber) {
    return ["/consultants/".concat(consultantNumber, "/customerId")];
};
/**
 * @summary consultants/{consultantNumber}/customerId
 */
export var useGetConsultantCustomerId = function (consultantNumber, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!consultantNumber;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetConsultantCustomerIdKey(consultantNumber) : null); });
    var swrFn = function () {
        return getConsultantCustomerId(customInstance, consultantNumber, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get consultant number for customer
 * @summary customers/{customerId}/consultantNumber
 */
export var getCustomerConsultantNumber = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/consultantNumber"), method: 'get', headers: headers }, options);
};
export var getGetCustomerConsultantNumberKey = function (customerId) {
    return ["/customers/".concat(customerId, "/consultantNumber")];
};
/**
 * @summary customers/{customerId}/consultantNumber
 */
export var useGetCustomerConsultantNumber = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerConsultantNumberKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerConsultantNumber(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Obsolete
 * @deprecated
 * @summary consultant/{consultantNumber}/customerId
 */
export var getConsultantCustomerIdDeprecated = function (client, consultantNumber, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/consultant/".concat(consultantNumber, "/customerId"), method: 'get', headers: headers }, options);
};
export var getGetConsultantCustomerIdDeprecatedKey = function (consultantNumber) {
    return ["/consultant/".concat(consultantNumber, "/customerId")];
};
/**
 * @deprecated
 * @summary consultant/{consultantNumber}/customerId
 */
export var useGetConsultantCustomerIdDeprecated = function (consultantNumber, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!consultantNumber;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetConsultantCustomerIdDeprecatedKey(consultantNumber) : null); });
    var swrFn = function () {
        return getConsultantCustomerIdDeprecated(customInstance, consultantNumber, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Track the activity
 * @summary customers/{customerId}/activities
 */
export var createCustomerActivity = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/activities"), method: 'post', headers: headers, params: params }, options);
};
/**
 * GET: Get potential and completed activities
 * @summary customers/{customerId}/activities
 */
export var getCustomerActivities = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/activities"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerActivitiesKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/activities")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/activities
 */
export var useGetCustomerActivities = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerActivitiesKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerActivities(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets collection of concept labels for anonymous customer.
 * @summary customers/{customerId}/conceptLabels
 */
export var getCustomerConceptLabels = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/conceptLabels"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerConceptLabelsKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/conceptLabels")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/conceptLabels
 */
export var useGetCustomerConceptLabels = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerConceptLabelsKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerConceptLabels(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets the information about the customer for given customer id
 * @summary customers/{customerId}/info
 */
export var getCustomerInfo = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/info"), method: 'get', headers: headers }, options);
};
export var getGetCustomerInfoKey = function (customerId) {
    return ["/customers/".concat(customerId, "/info")];
};
/**
 * @summary customers/{customerId}/info
 */
export var useGetCustomerInfo = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerInfoKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerInfo(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets the metadata about customer info API
 * @summary customers/{customerId}/infoMetadata
 */
export var getCustomerInfoMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/infoMetadata"), method: 'get', headers: headers }, options);
};
export var getGetCustomerInfoMetadataKey = function (customerId) {
    return ["/customers/".concat(customerId, "/infoMetadata")];
};
/**
 * @summary customers/{customerId}/infoMetadata
 */
export var useGetCustomerInfoMetadata = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerInfoMetadataKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerInfoMetadata(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Welcome program progress of the consultant
 * @summary customers/{customerId}/welcomeProgram
 */
export var getCustomerWelcomeProgram = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/welcomeProgram"), method: 'get', headers: headers }, options);
};
export var getGetCustomerWelcomeProgramKey = function (customerId) {
    return ["/customers/".concat(customerId, "/welcomeProgram")];
};
/**
 * @summary customers/{customerId}/welcomeProgram
 */
export var useGetCustomerWelcomeProgram = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerWelcomeProgramKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerWelcomeProgram(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Activity program progress of the consultant
 * @summary customers/{customerId}/activityProgram
 */
export var getCustomerActivityProgram = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/activityProgram"), method: 'get', headers: headers }, options);
};
export var getGetCustomerActivityProgramKey = function (customerId) {
    return ["/customers/".concat(customerId, "/activityProgram")];
};
/**
 * @summary customers/{customerId}/activityProgram
 */
export var useGetCustomerActivityProgram = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerActivityProgramKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerActivityProgram(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Recruitment campaign data
 * @summary customers/{customerId}/recruitmentCampaign
 */
export var getCustomerRecruitmentCampaign = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/recruitmentCampaign"), method: 'get', headers: headers }, options);
};
export var getGetCustomerRecruitmentCampaignKey = function (customerId) {
    return ["/customers/".concat(customerId, "/recruitmentCampaign")];
};
/**
 * @summary customers/{customerId}/recruitmentCampaign
 */
export var useGetCustomerRecruitmentCampaign = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerRecruitmentCampaignKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerRecruitmentCampaign(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Consultant personal sales for the current period
 * @summary customers/{customerId}/personalSales
 */
export var getCustomerPersonalSales = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/personalSales"), method: 'get', headers: headers }, options);
};
export var getGetCustomerPersonalSalesKey = function (customerId) {
    return ["/customers/".concat(customerId, "/personalSales")];
};
/**
 * @summary customers/{customerId}/personalSales
 */
export var useGetCustomerPersonalSales = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerPersonalSalesKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerPersonalSales(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Consultant personal sales for 3 past periods
 * @summary customers/{customerId}/personalSalesHistory
 */
export var getCustomerPersonalSalesHistory = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/personalSalesHistory"), method: 'get', headers: headers }, options);
};
export var getGetCustomerPersonalSalesHistoryKey = function (customerId) {
    return ["/customers/".concat(customerId, "/personalSalesHistory")];
};
/**
 * @summary customers/{customerId}/personalSalesHistory
 */
export var useGetCustomerPersonalSalesHistory = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerPersonalSalesHistoryKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerPersonalSalesHistory(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get current loyalty program overview
 * @summary customers/{customerId}/loyaltyProgram
 */
export var getCustomerLoyaltyProgram = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/loyaltyProgram"), method: 'get', headers: headers }, options);
};
export var getGetCustomerLoyaltyProgramKey = function (customerId) {
    return ["/customers/".concat(customerId, "/loyaltyProgram")];
};
/**
 * @summary customers/{customerId}/loyaltyProgram
 */
export var useGetCustomerLoyaltyProgram = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerLoyaltyProgramKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerLoyaltyProgram(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns metadata for customer attributes
 * @summary customers/{customerId}/metadata
 */
export var getCustomerMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/metadata"), method: 'get', headers: headers }, options);
};
export var getGetCustomerMetadataKey = function (customerId) {
    return ["/customers/".concat(customerId, "/metadata")];
};
/**
 * @summary customers/{customerId}/metadata
 */
export var useGetCustomerMetadata = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerMetadataKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerMetadata(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Subscribes or returns status of newsletter subscription for given email, origin and source values.
 * @summary customers/{customerId}/newsletterSubscriptions
 */
export var createCustomerNewsletterSubscription = function (client, customerId, globalNewsletterSubscriptionsNewsletterSubscriptionsDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/newsletterSubscriptions"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalNewsletterSubscriptionsNewsletterSubscriptionsDtoBody,
    }, options);
};
/**
 * Gets collection of product labels for a specific customer.
 * @summary customers/{customerId}/productsLabels
 */
export var getCustomerProductsLabels = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/productsLabels"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerProductsLabelsKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/productsLabels")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/productsLabels
 */
export var useGetCustomerProductsLabels = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerProductsLabelsKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerProductsLabels(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns information about customer registration instruction with given ID
 * @summary customerRegistrationInstructions/{registrationId}
 */
export var getCustomerRegistrationInstruction = function (client, registrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customerRegistrationInstructions/".concat(registrationId), method: 'get', headers: headers }, options);
};
export var getGetCustomerRegistrationInstructionKey = function (registrationId) {
    return ["/customerRegistrationInstructions/".concat(registrationId)];
};
/**
 * @summary customerRegistrationInstructions/{registrationId}
 */
export var useGetCustomerRegistrationInstruction = function (registrationId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!registrationId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerRegistrationInstructionKey(registrationId) : null); });
    var swrFn = function () {
        return getCustomerRegistrationInstruction(customInstance, registrationId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Updates a customer registration instruction with given ID
 * @summary customerRegistrationInstructions/{registrationId}
 */
export var updateCustomerRegistrationInstruction = function (client, registrationId, globalCustomerRegistrationInstructionsCustomerRegistrationInstructionDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customerRegistrationInstructions/".concat(registrationId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomerRegistrationInstructionsCustomerRegistrationInstructionDto,
    }, options);
};
/**
 * GET: Returns metadata for customer registration instruction with given ID
 * @summary customerRegistrationInstructions/{registrationId}/metadata
 */
export var getCustomerRegistrationInstructionMetadata = function (client, registrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customerRegistrationInstructions/".concat(registrationId, "/metadata"), method: 'get', headers: headers }, options);
};
export var getGetCustomerRegistrationInstructionMetadataKey = function (registrationId) {
    return ["/customerRegistrationInstructions/".concat(registrationId, "/metadata")];
};
/**
 * @summary customerRegistrationInstructions/{registrationId}/metadata
 */
export var useGetCustomerRegistrationInstructionMetadata = function (registrationId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!registrationId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerRegistrationInstructionMetadataKey(registrationId) : null); });
    var swrFn = function () {
        return getCustomerRegistrationInstructionMetadata(customInstance, registrationId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns information with status of the customer On behalf registration with given ID
 * @summary customerRegistrationInstructions/{registrationId}/onBehalf
 */
export var getCustomerRegistrationInstructionOnBehalf = function (client, registrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customerRegistrationInstructions/".concat(registrationId, "/onBehalf"), method: 'get', headers: headers }, options);
};
export var getGetCustomerRegistrationInstructionOnBehalfKey = function (registrationId) {
    return ["/customerRegistrationInstructions/".concat(registrationId, "/onBehalf")];
};
/**
 * @summary customerRegistrationInstructions/{registrationId}/onBehalf
 */
export var useGetCustomerRegistrationInstructionOnBehalf = function (registrationId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!registrationId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerRegistrationInstructionOnBehalfKey(registrationId) : null); });
    var swrFn = function () {
        return getCustomerRegistrationInstructionOnBehalf(customInstance, registrationId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns information about the status of the customer registration instruction with given ID
 * @summary customerRegistrationInstructions/{registrationId}/status
 */
export var getCustomerRegistrationInstructionStatus = function (client, registrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customerRegistrationInstructions/".concat(registrationId, "/status"), method: 'get', headers: headers }, options);
};
export var getGetCustomerRegistrationInstructionStatusKey = function (registrationId) {
    return ["/customerRegistrationInstructions/".concat(registrationId, "/status")];
};
/**
 * @summary customerRegistrationInstructions/{registrationId}/status
 */
export var useGetCustomerRegistrationInstructionStatus = function (registrationId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!registrationId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerRegistrationInstructionStatusKey(registrationId) : null); });
    var swrFn = function () {
        return getCustomerRegistrationInstructionStatus(customInstance, registrationId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns information about the sponsor selected in the registration process
 * @summary customerRegistrationInstructions/{registrationId}/sponsorInfo
 */
export var getCustomerRegistrationInstructionSponsorInfo = function (client, registrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customerRegistrationInstructions/".concat(registrationId, "/sponsorInfo"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetCustomerRegistrationInstructionSponsorInfoKey = function (registrationId) {
    return ["/customerRegistrationInstructions/".concat(registrationId, "/sponsorInfo")];
};
/**
 * @summary customerRegistrationInstructions/{registrationId}/sponsorInfo
 */
export var useGetCustomerRegistrationInstructionSponsorInfo = function (registrationId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!registrationId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetCustomerRegistrationInstructionSponsorInfoKey(registrationId) : null;
    });
    var swrFn = function () {
        return getCustomerRegistrationInstructionSponsorInfo(customInstance, registrationId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Creates a customer registration instruction and returns its ID
 * @summary customerRegistrationInstructions
 */
export var createCustomerRegistrationInstruction = function (client, globalCustomerRegistrationInstructionsCustomerRegistrationInstructionCreateDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customerRegistrationInstructions",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomerRegistrationInstructionsCustomerRegistrationInstructionCreateDto,
    }, options);
};
/**
 * @summary customers/{customerId}/relationships
 */
export var getCustomerRelationships = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/relationships"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerRelationshipsKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/relationships")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/relationships
 */
export var useGetCustomerRelationships = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerRelationshipsKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerRelationships(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * @summary customers/{customerId}/relationships
 */
export var createCustomerRelationship = function (client, customerId, globalCustomerRelationshipsCustomerRelationshipForInsertDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/relationships"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomerRelationshipsCustomerRelationshipForInsertDto,
    }, options);
};
/**
 * @summary customers/{customerId}/relationships/{relationshipId}
 */
export var updateCustomerRelationship = function (client, customerId, relationshipId, globalCustomerRelationshipsCustomerRelationshipDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/relationships/").concat(relationshipId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomerRelationshipsCustomerRelationshipDto,
    }, options);
};
/**
 * @summary customers/{customerId}/relationships/{relationshipId}
 */
export var deleteCustomerRelationship = function (client, customerId, relationshipId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/relationships/").concat(relationshipId), method: 'delete', headers: headers }, options);
};
/**
 * Returns set of customer terms which are required to be accepted
 * @summary customers/{customerId}/requiredTerms
 */
export var getCustomerRequiredTerms = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/requiredTerms"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerRequiredTermsKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/requiredTerms")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/requiredTerms
 */
export var useGetCustomerRequiredTerms = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerRequiredTermsKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerRequiredTerms(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns customer status by given request query
 * @summary reports/customerStatuses
 */
export var createReportsCustomerStatus = function (client, globalReportsCustomerStatusesRequestDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/reports/customerStatuses",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalReportsCustomerStatusesRequestDto,
    }, options);
};
/**
 * GET: customer status
 * @summary customers/{customerId}/customerStatus
 */
export var getCustomerCustomerStatus = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/customerStatus"), method: 'get', headers: headers }, options);
};
export var getGetCustomerCustomerStatusKey = function (customerId) {
    return ["/customers/".concat(customerId, "/customerStatus")];
};
/**
 * @summary customers/{customerId}/customerStatus
 */
export var useGetCustomerCustomerStatus = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerCustomerStatusKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerCustomerStatus(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: modify customer's status
 * @summary customers/{customerId}/customerStatus
 */
export var updateCustomerCustomerStatus = function (client, customerId, globalCustomersCustomerStatusDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/customerStatus"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersCustomerStatusDto,
    }, options);
};
/**
 * GET: Gets customer status metadata
 * @summary customers/{customerId}/customerStatusMetadata
 */
export var getCustomerCustomerStatusMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/customerStatusMetadata"), method: 'get', headers: headers }, options);
};
export var getGetCustomerCustomerStatusMetadataKey = function (customerId) {
    return ["/customers/".concat(customerId, "/customerStatusMetadata")];
};
/**
 * @summary customers/{customerId}/customerStatusMetadata
 */
export var useGetCustomerCustomerStatusMetadata = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerCustomerStatusMetadataKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerCustomerStatusMetadata(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the title.
 * @summary customers/{customerId}/localConsultantTitle
 */
export var getCustomerLocalConsultantTitle = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/localConsultantTitle"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerLocalConsultantTitleKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/localConsultantTitle")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/localConsultantTitle
 */
export var useGetCustomerLocalConsultantTitle = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerLocalConsultantTitleKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerLocalConsultantTitle(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets documents in folder
 * @summary digitalDocuments
 */
export var getDigitalDocuments = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/digitalDocuments", method: 'get', headers: headers, params: params }, options);
};
export var getGetDigitalDocumentsKey = function (params) {
    return __spreadArray(["/digitalDocuments"], (params ? [params] : []), true);
};
/**
 * @summary digitalDocuments
 */
export var useGetDigitalDocuments = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetDigitalDocumentsKey(params) : null); });
    var swrFn = function () {
        return getDigitalDocuments(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets document by ID
 * @summary digitalDocuments/{id}
 */
export var getDigitalDocument = function (client, id, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/digitalDocuments/".concat(id), method: 'get', headers: headers }, options);
};
export var getGetDigitalDocumentKey = function (id) { return ["/digitalDocuments/".concat(id)]; };
/**
 * @summary digitalDocuments/{id}
 */
export var useGetDigitalDocument = function (id, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!id;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetDigitalDocumentKey(id) : null); });
    var swrFn = function () {
        return getDigitalDocument(customInstance, id, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets document content (direct download) by document ID and content ID
 * @summary digitalDocuments/{id}/contents/{contentId}
 */
export var getDigitalDocumentContent = function (client, id, contentId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/digitalDocuments/".concat(id, "/contents/").concat(contentId),
        method: 'get',
        headers: headers,
        responseType: 'blob',
    }, options);
};
export var getGetDigitalDocumentContentKey = function (id, contentId) {
    return ["/digitalDocuments/".concat(id, "/contents/").concat(contentId)];
};
/**
 * @summary digitalDocuments/{id}/contents/{contentId}
 */
export var useGetDigitalDocumentContent = function (id, contentId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(id && contentId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetDigitalDocumentContentKey(id, contentId) : null); });
    var swrFn = function () {
        return getDigitalDocumentContent(customInstance, id, contentId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets document content (direct download) - latest revision
 * @summary digitalDocuments/{id}/latestContent
 */
export var getDigitalDocumentLatestContent = function (client, id, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/digitalDocuments/".concat(id, "/latestContent"), method: 'get', headers: headers, responseType: 'blob' }, options);
};
export var getGetDigitalDocumentLatestContentKey = function (id) {
    return ["/digitalDocuments/".concat(id, "/latestContent")];
};
/**
 * @summary digitalDocuments/{id}/latestContent
 */
export var useGetDigitalDocumentLatestContent = function (id, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!id;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetDigitalDocumentLatestContentKey(id) : null); });
    var swrFn = function () {
        return getDigitalDocumentLatestContent(customInstance, id, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get customer's delivery address
 * @summary customers/{customerId}/deliveryAddresses/{deliveryAddressId}
 */
export var getCustomerDeliveryAddress = function (client, customerId, deliveryAddressId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/deliveryAddresses/").concat(deliveryAddressId),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetCustomerDeliveryAddressKey = function (customerId, deliveryAddressId) {
    return ["/customers/".concat(customerId, "/deliveryAddresses/").concat(deliveryAddressId)];
};
/**
 * @summary customers/{customerId}/deliveryAddresses/{deliveryAddressId}
 */
export var useGetCustomerDeliveryAddress = function (customerId, deliveryAddressId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && deliveryAddressId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerDeliveryAddressKey(customerId, deliveryAddressId) : null); });
    var swrFn = function () {
        return getCustomerDeliveryAddress(customInstance, customerId, deliveryAddressId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provide delivery channel
 * @summary deliveryChannels/{deliveryChannelId}
 */
export var getDeliveryChannel = function (client, deliveryChannelId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/deliveryChannels/".concat(deliveryChannelId), method: 'get', headers: headers }, options);
};
export var getGetDeliveryChannelKey = function (deliveryChannelId) {
    return ["/deliveryChannels/".concat(deliveryChannelId)];
};
/**
 * @summary deliveryChannels/{deliveryChannelId}
 */
export var useGetDeliveryChannel = function (deliveryChannelId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!deliveryChannelId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetDeliveryChannelKey(deliveryChannelId) : null); });
    var swrFn = function () {
        return getDeliveryChannel(customInstance, deliveryChannelId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provide delivery channel address
 * @summary deliveryChannels/{deliveryChannelId}/address
 */
export var getDeliveryChannelAddress = function (client, deliveryChannelId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/deliveryChannels/".concat(deliveryChannelId, "/address"), method: 'get', headers: headers }, options);
};
export var getGetDeliveryChannelAddressKey = function (deliveryChannelId) {
    return ["/deliveryChannels/".concat(deliveryChannelId, "/address")];
};
/**
 * @summary deliveryChannels/{deliveryChannelId}/address
 */
export var useGetDeliveryChannelAddress = function (deliveryChannelId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!deliveryChannelId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetDeliveryChannelAddressKey(deliveryChannelId) : null); });
    var swrFn = function () {
        return getDeliveryChannelAddress(customInstance, deliveryChannelId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provide delivery channel coordinates
 * @summary deliveryChannels/{deliveryChannelId}/coordinates
 */
export var getDeliveryChannelCoordinates = function (client, deliveryChannelId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/deliveryChannels/".concat(deliveryChannelId, "/coordinates"), method: 'get', headers: headers }, options);
};
export var getGetDeliveryChannelCoordinatesKey = function (deliveryChannelId) {
    return ["/deliveryChannels/".concat(deliveryChannelId, "/coordinates")];
};
/**
 * @summary deliveryChannels/{deliveryChannelId}/coordinates
 */
export var useGetDeliveryChannelCoordinates = function (deliveryChannelId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!deliveryChannelId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetDeliveryChannelCoordinatesKey(deliveryChannelId) : null); });
    var swrFn = function () {
        return getDeliveryChannelCoordinates(customInstance, deliveryChannelId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Find available delivery channel based on search criteria
 * @summary shoppingSessions/{sessionId}/deliveryChannels
 */
export var getShoppingSessionDeliveryChannels = function (client, sessionId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/deliveryChannels"), method: 'get', headers: headers, params: params }, options);
};
export var getGetShoppingSessionDeliveryChannelsKey = function (sessionId, params) { return __spreadArray(["/shoppingSessions/".concat(sessionId, "/deliveryChannels")], (params ? [params] : []), true); };
/**
 * @summary shoppingSessions/{sessionId}/deliveryChannels
 */
export var useGetShoppingSessionDeliveryChannels = function (sessionId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionDeliveryChannelsKey(sessionId, params) : null); });
    var swrFn = function () {
        return getShoppingSessionDeliveryChannels(customInstance, sessionId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Find available pick-up points based on search criteria on the map
 * @summary shoppingSessions/{sessionId}/clusteredPickupPoints
 */
export var getShoppingSessionClusteredPickupPoints = function (client, sessionId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/clusteredPickupPoints"), method: 'get', headers: headers, params: params }, options);
};
export var getGetShoppingSessionClusteredPickupPointsKey = function (sessionId, params) { return __spreadArray(["/shoppingSessions/".concat(sessionId, "/clusteredPickupPoints")], (params ? [params] : []), true); };
/**
 * @summary shoppingSessions/{sessionId}/clusteredPickupPoints
 */
export var useGetShoppingSessionClusteredPickupPoints = function (sessionId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionClusteredPickupPointsKey(sessionId, params) : null); });
    var swrFn = function () {
        return getShoppingSessionClusteredPickupPoints(customInstance, sessionId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets delivery channel by id
 * @summary shoppingSessions/{sessionId}/deliveryChannels/{deliveryChannelId}
 */
export var getShoppingSessionDeliveryChannel = function (client, sessionId, deliveryChannelId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/deliveryChannels/").concat(deliveryChannelId),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetShoppingSessionDeliveryChannelKey = function (sessionId, deliveryChannelId) { return ["/shoppingSessions/".concat(sessionId, "/deliveryChannels/").concat(deliveryChannelId)]; };
/**
 * @summary shoppingSessions/{sessionId}/deliveryChannels/{deliveryChannelId}
 */
export var useGetShoppingSessionDeliveryChannel = function (sessionId, deliveryChannelId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(sessionId && deliveryChannelId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetShoppingSessionDeliveryChannelKey(sessionId, deliveryChannelId) : null;
    });
    var swrFn = function () {
        return getShoppingSessionDeliveryChannel(customInstance, sessionId, deliveryChannelId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides available delivery methods
 * @summary shoppingSessions/{sessionId}/deliveryMethods
 */
export var getShoppingSessionDeliveryMethods = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/deliveryMethods"), method: 'get', headers: headers }, options);
};
export var getGetShoppingSessionDeliveryMethodsKey = function (sessionId) {
    return ["/shoppingSessions/".concat(sessionId, "/deliveryMethods")];
};
/**
 * @summary shoppingSessions/{sessionId}/deliveryMethods
 */
export var useGetShoppingSessionDeliveryMethods = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionDeliveryMethodsKey(sessionId) : null); });
    var swrFn = function () {
        return getShoppingSessionDeliveryMethods(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provide relevant delivery filters
 * @summary shoppingSessions/{sessionId}/deliveryFilters
 */
export var getShoppingSessionDeliveryFilters = function (client, sessionId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/deliveryFilters"), method: 'get', headers: headers, params: params }, options);
};
export var getGetShoppingSessionDeliveryFiltersKey = function (sessionId, params) { return __spreadArray(["/shoppingSessions/".concat(sessionId, "/deliveryFilters")], (params ? [params] : []), true); };
/**
 * @summary shoppingSessions/{sessionId}/deliveryFilters
 */
export var useGetShoppingSessionDeliveryFilters = function (sessionId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionDeliveryFiltersKey(sessionId, params) : null); });
    var swrFn = function () {
        return getShoppingSessionDeliveryFilters(customInstance, sessionId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Find available delivery options
 * @summary shoppingSessions/{sessionId}/deliveryOptions
 */
export var getShoppingSessionDeliveryOptions = function (client, sessionId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/deliveryOptions"), method: 'get', headers: headers, params: params }, options);
};
export var getGetShoppingSessionDeliveryOptionsKey = function (sessionId, params) { return __spreadArray(["/shoppingSessions/".concat(sessionId, "/deliveryOptions")], (params ? [params] : []), true); };
/**
 * @summary shoppingSessions/{sessionId}/deliveryOptions
 */
export var useGetShoppingSessionDeliveryOptions = function (sessionId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionDeliveryOptionsKey(sessionId, params) : null); });
    var swrFn = function () {
        return getShoppingSessionDeliveryOptions(customInstance, sessionId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provide selected delivery channel and address
 * @summary shoppingSessions/{sessionId}/delivery
 */
export var getShoppingSessionDelivery = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/delivery"), method: 'get', headers: headers }, options);
};
export var getGetShoppingSessionDeliveryKey = function (sessionId) {
    return ["/shoppingSessions/".concat(sessionId, "/delivery")];
};
/**
 * @summary shoppingSessions/{sessionId}/delivery
 */
export var useGetShoppingSessionDelivery = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionDeliveryKey(sessionId) : null); });
    var swrFn = function () {
        return getShoppingSessionDelivery(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Update selected delivery channel and address
 * @summary shoppingSessions/{sessionId}/delivery
 */
export var updateShoppingSessionDelivery = function (client, sessionId, globalShoppingDeliverySelectionDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/delivery"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingDeliverySelectionDto,
    }, options);
};
/**
 * Courier can post information about new status of a delivery
 * @summary couriers/{courierId}/wayBillNumbers/{wayBillNumber}/deliveryStatuses
 */
export var createCourierWayBillNumberDeliveryStatus = function (client, courierId, wayBillNumber, globalDeliveryDeliveryStatusDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/couriers/".concat(courierId, "/wayBillNumbers/").concat(wayBillNumber, "/deliveryStatuses"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalDeliveryDeliveryStatusDto,
    }, options);
};
/**
 * Saves customer document.
 * @summary customers/{customerId}/documents
 */
export var createCustomerDocument = function (client, customerId, createCustomerDocumentBody, params, headers, options) {
    var customInstance = client.createFetcher();
    var formData = new FormData();
    if (createCustomerDocumentBody.file !== undefined) {
        formData.append('file', createCustomerDocumentBody.file);
    }
    return customInstance({
        url: "/customers/".concat(customerId, "/documents"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'multipart/form-data' }, headers),
        data: formData,
        params: params,
    }, options);
};
/**
 * Gets customer image by id and optionally resizes it,
if width and height parameters are provided.
Caches result for 7 days.
 * @summary customers/{customerId}/documents/{documentId}/image
 */
export var getCustomerDocumentImage = function (client, customerId, documentId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/documents/").concat(documentId, "/image"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCustomerDocumentImageKey = function (customerId, documentId, params) {
    return __spreadArray(["/customers/".concat(customerId, "/documents/").concat(documentId, "/image")], (params ? [params] : []), true);
};
/**
 * @summary customers/{customerId}/documents/{documentId}/image
 */
export var useGetCustomerDocumentImage = function (customerId, documentId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && documentId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerDocumentImageKey(customerId, documentId, params) : null); });
    var swrFn = function () {
        return getCustomerDocumentImage(customInstance, customerId, documentId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets customer binary document by id.
Caches result for 7 days.
 * @summary customers/{customerId}/documents/{documentId}
 */
export var getCustomerDocument = function (client, customerId, documentId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/documents/").concat(documentId), method: 'get', headers: headers }, options);
};
export var getGetCustomerDocumentKey = function (customerId, documentId) {
    return ["/customers/".concat(customerId, "/documents/").concat(documentId)];
};
/**
 * @summary customers/{customerId}/documents/{documentId}
 */
export var useGetCustomerDocument = function (customerId, documentId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && documentId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerDocumentKey(customerId, documentId) : null); });
    var swrFn = function () {
        return getCustomerDocument(customInstance, customerId, documentId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Delete customers document
 * @summary customers/{customerId}/documents/{documentId}
 */
export var deleteCustomerDocument = function (client, customerId, documentId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/documents/").concat(documentId), method: 'delete', headers: headers }, options);
};
/**
 * Gets the customer documents ids.
 * @summary customers/{customerId}/documents/infos
 */
export var getCustomerDocumentsInfos = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/documents/infos"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerDocumentsInfosKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/documents/infos")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/documents/infos
 */
export var useGetCustomerDocumentsInfos = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerDocumentsInfosKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerDocumentsInfos(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets all available document types
 * @summary documentTypes
 */
export var getDocumentTypes = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/documentTypes", method: 'get', headers: headers }, options);
};
export var getGetDocumentTypesKey = function () { return ["/documentTypes"]; };
/**
 * @summary documentTypes
 */
export var useGetDocumentTypes = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetDocumentTypesKey() : null); });
    var swrFn = function () { return getDocumentTypes(customInstance, headers, requestOptions).then(function (d) { return d.data; }); };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Saves an anonymous (without assigning customer)
 * @summary documents
 */
export var createDocument = function (client, createCustomerDocumentBody, params, headers, options) {
    var customInstance = client.createFetcher();
    var formData = new FormData();
    if (createCustomerDocumentBody.file !== undefined) {
        formData.append('file', createCustomerDocumentBody.file);
    }
    return customInstance({
        url: "/documents",
        method: 'post',
        headers: __assign({ 'Content-Type': 'multipart/form-data' }, headers),
        data: formData,
        params: params,
    }, options);
};
/**
 * Gets anonymous (without assigned customer) image by id and optionally resizes it,
if width and height parameters are provided.
Caches result for 7 days.
 * @summary documents/{documentId}/image
 */
export var getDocumentImage = function (client, documentId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/documents/".concat(documentId, "/image"), method: 'get', headers: headers, params: params }, options);
};
export var getGetDocumentImageKey = function (documentId, params) {
    return __spreadArray(["/documents/".concat(documentId, "/image")], (params ? [params] : []), true);
};
/**
 * @summary documents/{documentId}/image
 */
export var useGetDocumentImage = function (documentId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!documentId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetDocumentImageKey(documentId, params) : null); });
    var swrFn = function () {
        return getDocumentImage(customInstance, documentId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets anonymous (without assigned customer) binary document by id.
Caches result for 7 days.
 * @summary documents/{documentId}
 */
export var getDocument = function (client, documentId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/documents/".concat(documentId), method: 'get', headers: headers }, options);
};
export var getGetDocumentKey = function (documentId) { return ["/documents/".concat(documentId)]; };
/**
 * @summary documents/{documentId}
 */
export var useGetDocument = function (documentId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!documentId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetDocumentKey(documentId) : null); });
    var swrFn = function () {
        return getDocument(customInstance, documentId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the anonymous (without assigned customer) documents info.
 * @summary documents/infos
 */
export var getDocumentsInfos = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/documents/infos", method: 'get', headers: headers, params: params }, options);
};
export var getGetDocumentsInfosKey = function (params) {
    return __spreadArray(["/documents/infos"], (params ? [params] : []), true);
};
/**
 * @summary documents/infos
 */
export var useGetDocumentsInfos = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetDocumentsInfosKey(params) : null); });
    var swrFn = function () {
        return getDocumentsInfos(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get document approvals by filter parameters
 * @summary customers/{customerId}/documentApprovals
 */
export var getCustomerDocumentApprovals = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/documentApprovals"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerDocumentApprovalsKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/documentApprovals")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/documentApprovals
 */
export var useGetCustomerDocumentApprovals = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerDocumentApprovalsKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerDocumentApprovals(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Create document approval
 * @summary customers/{customerId}/documentApprovals
 */
export var createCustomerDocumentApproval = function (client, customerId, globalCustomersDocumentApprovalDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/documentApprovals"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersDocumentApprovalDto,
    }, options);
};
/**
 * Get document approval by ID
 * @summary customers/{customerId}/documentApprovals/{documentApprovalId}
 */
export var getCustomerDocumentApproval = function (client, customerId, documentApprovalId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/documentApprovals/").concat(documentApprovalId),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetCustomerDocumentApprovalKey = function (customerId, documentApprovalId) {
    return ["/customers/".concat(customerId, "/documentApprovals/").concat(documentApprovalId)];
};
/**
 * @summary customers/{customerId}/documentApprovals/{documentApprovalId}
 */
export var useGetCustomerDocumentApproval = function (customerId, documentApprovalId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && documentApprovalId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerDocumentApprovalKey(customerId, documentApprovalId) : null); });
    var swrFn = function () {
        return getCustomerDocumentApproval(customInstance, customerId, documentApprovalId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns customer's DAB card as image stream
 * @summary customers/{customerId}/doubleAdvancementBonusCard
 */
export var getCustomerDoubleAdvancementBonusCard = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/doubleAdvancementBonusCard"), method: 'get', headers: headers }, options);
};
export var getGetCustomerDoubleAdvancementBonusCardKey = function (customerId) {
    return ["/customers/".concat(customerId, "/doubleAdvancementBonusCard")];
};
/**
 * @summary customers/{customerId}/doubleAdvancementBonusCard
 */
export var useGetCustomerDoubleAdvancementBonusCard = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerDoubleAdvancementBonusCardKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerDoubleAdvancementBonusCard(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Downgrades customer.
 * @summary customers/{customerId}/downgradeRequest
 */
export var updateCustomerDowngradeRequest = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/downgradeRequest"), method: 'put', headers: headers }, options);
};
/**
 * GET: Returns downline customers for given customer
 * @summary customers/{customerId}/downlineCustomers
 */
export var getCustomerDownlineCustomers = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/downlineCustomers"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerDownlineCustomersKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/downlineCustomers")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/downlineCustomers
 */
export var useGetCustomerDownlineCustomers = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerDownlineCustomersKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerDownlineCustomers(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get downline performance kpis
 * @summary customers/{customerId}/downlinePerformance
 */
export var getCustomerDownlinePerformance = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/downlinePerformance"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerDownlinePerformanceKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/downlinePerformance")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/downlinePerformance
 */
export var useGetCustomerDownlinePerformance = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerDownlinePerformanceKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerDownlinePerformance(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - provides collection of editorial articles
 * @summary editorialArticles
 */
export var getEditorialArticles = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/editorialArticles", method: 'get', headers: headers, params: params }, options);
};
export var getGetEditorialArticlesKey = function (params) {
    return __spreadArray(["/editorialArticles"], (params ? [params] : []), true);
};
/**
 * @summary editorialArticles
 */
export var useGetEditorialArticles = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetEditorialArticlesKey(params) : null); });
    var swrFn = function () {
        return getEditorialArticles(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get personal editorial pages by query parameters.
 * @summary applications/editorial/personalEditorialPages
 */
export var getApplicationsEditorialPersonalEditorialPages = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/editorial/personalEditorialPages", method: 'get', headers: headers, params: params }, options);
};
export var getGetApplicationsEditorialPersonalEditorialPagesKey = function (params) { return __spreadArray(["/applications/editorial/personalEditorialPages"], (params ? [params] : []), true); };
/**
 * @summary applications/editorial/personalEditorialPages
 */
export var useGetApplicationsEditorialPersonalEditorialPages = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsEditorialPersonalEditorialPagesKey(params) : null); });
    var swrFn = function () {
        return getApplicationsEditorialPersonalEditorialPages(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get personal editorial landing pages by IDs.
 * @summary applications/editorial/personalLandingPages
 */
export var getApplicationsEditorialPersonalLandingPages = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/editorial/personalLandingPages", method: 'get', headers: headers, params: params }, options);
};
export var getGetApplicationsEditorialPersonalLandingPagesKey = function (params) { return __spreadArray(["/applications/editorial/personalLandingPages"], (params ? [params] : []), true); };
/**
 * @summary applications/editorial/personalLandingPages
 */
export var useGetApplicationsEditorialPersonalLandingPages = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsEditorialPersonalLandingPagesKey(params) : null); });
    var swrFn = function () {
        return getApplicationsEditorialPersonalLandingPages(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Localization for EInvoice application
 * @summary applications/eInvoice/localization
 */
export var getApplicationsEInvoiceLocalization = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/eInvoice/localization", method: 'get', headers: headers }, options);
};
export var getGetApplicationsEInvoiceLocalizationKey = function () {
    return ["/applications/eInvoice/localization"];
};
/**
 * @summary applications/eInvoice/localization
 */
export var useGetApplicationsEInvoiceLocalization = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsEInvoiceLocalizationKey() : null); });
    var swrFn = function () {
        return getApplicationsEInvoiceLocalization(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns documents for identity card
 * @summary customers/{customerId}/eInvoiceApproval
 */
export var getCustomerEInvoiceApproval = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/eInvoiceApproval"), method: 'get', headers: headers }, options);
};
export var getGetCustomerEInvoiceApprovalKey = function (customerId) {
    return ["/customers/".concat(customerId, "/eInvoiceApproval")];
};
/**
 * @summary customers/{customerId}/eInvoiceApproval
 */
export var useGetCustomerEInvoiceApproval = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerEInvoiceApprovalKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerEInvoiceApproval(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Change e-invoice approval flag
 * @summary customers/{customerId}/eInvoiceApproval
 */
export var updateCustomerEInvoiceApproval = function (client, customerId, globalCustomersCustomerBooleanDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/eInvoiceApproval"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersCustomerBooleanDtoBody,
    }, options);
};
/**
 * Gets customer emails.
Customer can own only single active and single pending email at the moment.
 * @summary customers/{customerId}/emails
 */
export var getCustomerEmails = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/emails"), method: 'get', headers: headers }, options);
};
export var getGetCustomerEmailsKey = function (customerId) {
    return ["/customers/".concat(customerId, "/emails")];
};
/**
 * @summary customers/{customerId}/emails
 */
export var useGetCustomerEmails = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerEmailsKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerEmails(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Sets new/overrides email for customer.
Customer can own only single active and single pending email at the moment.
Email is stored as pending and waiting for confirmation
 * @summary customers/{customerId}/emails
 */
export var createCustomerEmail = function (client, customerId, globalCustomersEmailDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/emails"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersEmailDto,
    }, options);
};
/**
 * Delete customers active or pending email.
 * @summary customers/{customerId}/emails/{emailAddress}
 */
export var deleteCustomerEmail = function (client, customerId, emailAddress, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/emails/").concat(emailAddress), method: 'delete', headers: headers }, options);
};
/**
 * GET: Gets metadata information for email endpoints of the customer with given customer id
 * @summary customers/{customerId}/emailsMetadata
 */
export var getCustomerEmailsMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/emailsMetadata"), method: 'get', headers: headers }, options);
};
export var getGetCustomerEmailsMetadataKey = function (customerId) {
    return ["/customers/".concat(customerId, "/emailsMetadata")];
};
/**
 * @summary customers/{customerId}/emailsMetadata
 */
export var useGetCustomerEmailsMetadata = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerEmailsMetadataKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerEmailsMetadata(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets the status of verification process for given email and customer id
 * @summary customers/{customerId}/emails/{emailAddress}/verificationRequest
 */
export var getCustomerEmailVerificationRequest = function (client, customerId, emailAddress, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/emails/").concat(emailAddress, "/verificationRequest"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetCustomerEmailVerificationRequestKey = function (customerId, emailAddress) { return ["/customers/".concat(customerId, "/emails/").concat(emailAddress, "/verificationRequest")]; };
/**
 * @summary customers/{customerId}/emails/{emailAddress}/verificationRequest
 */
export var useGetCustomerEmailVerificationRequest = function (customerId, emailAddress, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && emailAddress);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetCustomerEmailVerificationRequestKey(customerId, emailAddress) : null;
    });
    var swrFn = function () {
        return getCustomerEmailVerificationRequest(customInstance, customerId, emailAddress, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Requests resending verification email for customer with given customer id and email address
 * @summary customers/{customerId}/emails/{emailAddress}/verificationRequest
 */
export var updateCustomerEmailVerificationRequest = function (client, customerId, emailAddress, globalCustomersEmailVerificationRequestDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/emails/").concat(emailAddress, "/verificationRequest"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersEmailVerificationRequestDto,
    }, options);
};
/**
 * Get end consumer order by ItemCode
 * @summary endConsumerOrders/{endConsumerOrderId}/items/{itemCode}
 */
export var getEndConsumerOrderItem = function (client, endConsumerOrderId, itemCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/endConsumerOrders/".concat(endConsumerOrderId, "/items/").concat(itemCode), method: 'get', headers: headers }, options);
};
export var getGetEndConsumerOrderItemKey = function (endConsumerOrderId, itemCode) {
    return ["/endConsumerOrders/".concat(endConsumerOrderId, "/items/").concat(itemCode)];
};
/**
 * @summary endConsumerOrders/{endConsumerOrderId}/items/{itemCode}
 */
export var useGetEndConsumerOrderItem = function (endConsumerOrderId, itemCode, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(endConsumerOrderId && itemCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetEndConsumerOrderItemKey(endConsumerOrderId, itemCode) : null); });
    var swrFn = function () {
        return getEndConsumerOrderItem(customInstance, endConsumerOrderId, itemCode, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Update existing item on end consumer order
 * @summary endConsumerOrders/{endConsumerOrderId}/items/{itemCode}
 */
export var updateEndConsumerOrderItem = function (client, endConsumerOrderId, itemCode, globalEndConsumerOrdersEndConsumerOrderItemDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/endConsumerOrders/".concat(endConsumerOrderId, "/items/").concat(itemCode),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalEndConsumerOrdersEndConsumerOrderItemDto,
    }, options);
};
/**
 * Delete/remove item from end consumer order
 * @summary endConsumerOrders/{endConsumerOrderId}/items/{itemCode}
 */
export var deleteEndConsumerOrderItem = function (client, endConsumerOrderId, itemCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/endConsumerOrders/".concat(endConsumerOrderId, "/items/").concat(itemCode),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Add new item to end consumer order
 * @summary endConsumerOrders/{endConsumerOrderId}/items
 */
export var createEndConsumerOrderItem = function (client, endConsumerOrderId, globalEndConsumerOrdersEndConsumerOrderItemDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/endConsumerOrders/".concat(endConsumerOrderId, "/items"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalEndConsumerOrdersEndConsumerOrderItemDto,
    }, options);
};
/**
 * Creates new end consumer order
 * @summary endConsumerOrders
 */
export var createEndConsumerOrder = function (client, globalEndConsumerOrdersEndConsumerOrderDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/endConsumerOrders",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalEndConsumerOrdersEndConsumerOrderDto,
    }, options);
};
/**
 * Get all end consumer orders for given customer ID
 * @summary endConsumerOrders
 */
export var getEndConsumerOrders = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/endConsumerOrders", method: 'get', headers: headers, params: params }, options);
};
export var getGetEndConsumerOrdersKey = function (params) {
    return __spreadArray(["/endConsumerOrders"], (params ? [params] : []), true);
};
/**
 * @summary endConsumerOrders
 */
export var useGetEndConsumerOrders = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetEndConsumerOrdersKey(params) : null); });
    var swrFn = function () {
        return getEndConsumerOrders(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get end consumer order by id
 * @summary endConsumerOrders/{endConsumerOrderId}
 */
export var getEndConsumerOrder = function (client, endConsumerOrderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/endConsumerOrders/".concat(endConsumerOrderId), method: 'get', headers: headers }, options);
};
export var getGetEndConsumerOrderKey = function (endConsumerOrderId) {
    return ["/endConsumerOrders/".concat(endConsumerOrderId)];
};
/**
 * @summary endConsumerOrders/{endConsumerOrderId}
 */
export var useGetEndConsumerOrder = function (endConsumerOrderId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!endConsumerOrderId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetEndConsumerOrderKey(endConsumerOrderId) : null); });
    var swrFn = function () {
        return getEndConsumerOrder(customInstance, endConsumerOrderId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Create approval for end consumer order
 * @summary endConsumerOrders/{endConsumerOrderId}/approval
 */
export var createEndConsumerOrderApproval = function (client, endConsumerOrderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/endConsumerOrders/".concat(endConsumerOrderId, "/approval"), method: 'post', headers: headers }, options);
};
/**
 * Delete approval for end consumer order
 * @summary endConsumerOrders/{endConsumerOrderId}/approval
 */
export var deleteEndConsumerOrderApproval = function (client, endConsumerOrderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/endConsumerOrders/".concat(endConsumerOrderId, "/approval"), method: 'delete', headers: headers }, options);
};
/**
 * GET: Gets the collection of all end consumers of the customer with given customer id
 * @summary customers/{customerId}/endConsumers
 */
export var getCustomerEndConsumers = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/endConsumers"), method: 'get', headers: headers }, options);
};
export var getGetCustomerEndConsumersKey = function (customerId) {
    return ["/customers/".concat(customerId, "/endConsumers")];
};
/**
 * @summary customers/{customerId}/endConsumers
 */
export var useGetCustomerEndConsumers = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerEndConsumersKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerEndConsumers(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Creates new end consumer for the customer with given customer id
 * @summary customers/{customerId}/endConsumers
 */
export var createCustomerEndConsumer = function (client, customerId, globalCustomersEndConsumerDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/endConsumers"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersEndConsumerDtoBody,
    }, options);
};
/**
 * GET: Get specific end consumer of the customer with given customer id
 * @summary customers/{customerId}/endConsumers/{endConsumerId}
 */
export var getCustomerEndConsumer = function (client, customerId, endConsumerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/endConsumers/").concat(endConsumerId), method: 'get', headers: headers }, options);
};
export var getGetCustomerEndConsumerKey = function (customerId, endConsumerId) {
    return ["/customers/".concat(customerId, "/endConsumers/").concat(endConsumerId)];
};
/**
 * @summary customers/{customerId}/endConsumers/{endConsumerId}
 */
export var useGetCustomerEndConsumer = function (customerId, endConsumerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && endConsumerId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerEndConsumerKey(customerId, endConsumerId) : null); });
    var swrFn = function () {
        return getCustomerEndConsumer(customInstance, customerId, endConsumerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Updates end consumer for the customer with given customer id
 * @summary customers/{customerId}/endConsumers/{endConsumerId}
 */
export var updateCustomerEndConsumer = function (client, customerId, endConsumerId, globalCustomersEndConsumerDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/endConsumers/").concat(endConsumerId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersEndConsumerDtoBody,
    }, options);
};
/**
 * DELETE: Removes end consumer for the customer with given customer id
 * @summary customers/{customerId}/endConsumers/{endConsumerId}
 */
export var deleteCustomerEndConsumer = function (client, customerId, endConsumerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/endConsumers/").concat(endConsumerId), method: 'delete', headers: headers }, options);
};
/**
 * GET: Returns metadata information for endConsumer endpoints
 * @summary endConsumersMetadata
 */
export var getEndConsumersMetadata = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/endConsumersMetadata", method: 'get', headers: headers }, options);
};
export var getGetEndConsumersMetadataKey = function () { return ["/endConsumersMetadata"]; };
/**
 * @summary endConsumersMetadata
 */
export var useGetEndConsumersMetadata = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetEndConsumersMetadataKey() : null); });
    var swrFn = function () {
        return getEndConsumersMetadata(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Localization for EndCustomer Referral Discount application
 * @summary applications/endCustomerReferralDiscount/localization
 */
export var getApplicationsEndCustomerReferralDiscountLocalization = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/endCustomerReferralDiscount/localization", method: 'get', headers: headers }, options);
};
export var getGetApplicationsEndCustomerReferralDiscountLocalizationKey = function () {
    return ["/applications/endCustomerReferralDiscount/localization"];
};
/**
 * @summary applications/endCustomerReferralDiscount/localization
 */
export var useGetApplicationsEndCustomerReferralDiscountLocalization = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsEndCustomerReferralDiscountLocalizationKey() : null); });
    var swrFn = function () {
        return getApplicationsEndCustomerReferralDiscountLocalization(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Creates new end customer
 * @summary endCustomers
 */
export var createEndCustomer = function (client, globalCustomersEndCustomerDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/endCustomers",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersEndCustomerDto,
    }, options);
};
/**
 * GET: Gets metadata information for endCustomers endpoints
 * @summary endCustomersMetadata
 */
export var getEndCustomersMetadata = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/endCustomersMetadata", method: 'get', headers: headers }, options);
};
export var getGetEndCustomersMetadataKey = function () { return ["/endCustomersMetadata"]; };
/**
 * @summary endCustomersMetadata
 */
export var useGetEndCustomersMetadata = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetEndCustomersMetadataKey() : null); });
    var swrFn = function () {
        return getEndCustomersMetadata(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets identity server endpoints for communication with identity server (API, OAuth, OpenId)
 * @deprecated
 * @summary system/endpoints/identityServer
 */
export var getSystemEndpointsIdentityServerDeprecated = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/system/endpoints/identityServer", method: 'get', headers: headers }, options);
};
export var getGetSystemEndpointsIdentityServerDeprecatedKey = function () {
    return ["/system/endpoints/identityServer"];
};
/**
 * @deprecated
 * @summary system/endpoints/identityServer
 */
export var useGetSystemEndpointsIdentityServerDeprecated = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetSystemEndpointsIdentityServerDeprecatedKey() : null); });
    var swrFn = function () {
        return getSystemEndpointsIdentityServerDeprecated(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets Online url for specific tenant. It could be used for redirects to oriflame pages
 * @deprecated
 * @summary system/endpoints/online
 */
export var getSystemEndpointsOnlineDeprecated = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/system/endpoints/online", method: 'get', headers: headers }, options);
};
export var getGetSystemEndpointsOnlineDeprecatedKey = function () { return ["/system/endpoints/online"]; };
/**
 * @deprecated
 * @summary system/endpoints/online
 */
export var useGetSystemEndpointsOnlineDeprecated = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetSystemEndpointsOnlineDeprecatedKey() : null); });
    var swrFn = function () {
        return getSystemEndpointsOnlineDeprecated(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets customer eWallet accounts
 * @summary customers/{customerId}/eWalletAccounts
 */
export var getCustomerEWalletAccounts = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/eWalletAccounts"), method: 'get', headers: headers }, options);
};
export var getGetCustomerEWalletAccountsKey = function (customerId) {
    return ["/customers/".concat(customerId, "/eWalletAccounts")];
};
/**
 * @summary customers/{customerId}/eWalletAccounts
 */
export var useGetCustomerEWalletAccounts = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerEWalletAccountsKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerEWalletAccounts(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Creates customer eWallet account
 * @summary customers/{customerId}/eWalletAccounts
 */
export var createCustomerEWalletAccount = function (client, customerId, globalCustomersEWalletAccountDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/eWalletAccounts"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersEWalletAccountDtoBody,
    }, options);
};
/**
 * PUT: Updates customer eWallet account
 * @summary customers/{customerId}/eWalletAccounts/{eWalletAccountId}
 */
export var updateCustomerEWalletAccount = function (client, customerId, eWalletAccountId, globalCustomersEWalletAccountDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/eWalletAccounts/").concat(eWalletAccountId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersEWalletAccountDtoBody,
    }, options);
};
/**
 * DELETE: Removes customer eWallet account by ID
 * @summary customers/{customerId}/eWalletAccounts/{eWalletAccountId}
 */
export var deleteCustomerEWalletAccount = function (client, customerId, eWalletAccountId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/eWalletAccounts/").concat(eWalletAccountId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Gets metadata information for eWallet endpoints of the customer with given customer id
 * @summary customers/{customerId}/eWalletAccountsMetadata
 */
export var getCustomerEWalletAccountsMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/eWalletAccountsMetadata"), method: 'get', headers: headers }, options);
};
export var getGetCustomerEWalletAccountsMetadataKey = function (customerId) {
    return ["/customers/".concat(customerId, "/eWalletAccountsMetadata")];
};
/**
 * @summary customers/{customerId}/eWalletAccountsMetadata
 */
export var useGetCustomerEWalletAccountsMetadata = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerEWalletAccountsMetadataKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerEWalletAccountsMetadata(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get WeChat unionId for customer id
 * @summary customers/{customerId}/externalAccounts/weChat/unionId
 */
export var getCustomerExternalAccountsWeChatUnionId = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/externalAccounts/weChat/unionId"), method: 'get', headers: headers }, options);
};
export var getGetCustomerExternalAccountsWeChatUnionIdKey = function (customerId) {
    return ["/customers/".concat(customerId, "/externalAccounts/weChat/unionId")];
};
/**
 * @summary customers/{customerId}/externalAccounts/weChat/unionId
 */
export var useGetCustomerExternalAccountsWeChatUnionId = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerExternalAccountsWeChatUnionIdKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerExternalAccountsWeChatUnionId(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Retrieves the profiles for external providers (FB, WeChat, VKontakte...)
 * @summary customers/{customerId}/externalProfiles
 */
export var getCustomerExternalProfiles = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/externalProfiles"), method: 'get', headers: headers }, options);
};
export var getGetCustomerExternalProfilesKey = function (customerId) {
    return ["/customers/".concat(customerId, "/externalProfiles")];
};
/**
 * @summary customers/{customerId}/externalProfiles
 */
export var useGetCustomerExternalProfiles = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerExternalProfilesKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerExternalProfiles(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Disconnects external account (FB, WeChat, VKontakte...)
 * @summary customers/{customerId}/externalAccounts/{externalProvider}
 */
export var deleteCustomerExternalAccount = function (client, customerId, externalProvider, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/externalAccounts/").concat(externalProvider),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Gets feature toggle value for current tenant by the feature GUID.
 * @summary featureToggles/{featureId}
 */
export var getFeatureToggle = function (client, featureId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/featureToggles/".concat(featureId), method: 'get', headers: headers }, options);
};
export var getGetFeatureToggleKey = function (featureId) {
    return ["/featureToggles/".concat(featureId)];
};
/**
 * @summary featureToggles/{featureId}
 */
export var useGetFeatureToggle = function (featureId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!featureId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetFeatureToggleKey(featureId) : null); });
    var swrFn = function () {
        return getFeatureToggle(customInstance, featureId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets all feature toggle values for current tenant.
 * @summary featureToggles
 */
export var getFeatureToggles = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/featureToggles", method: 'get', headers: headers }, options);
};
export var getGetFeatureTogglesKey = function () { return ["/featureToggles"]; };
/**
 * @summary featureToggles
 */
export var useGetFeatureToggles = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetFeatureTogglesKey() : null); });
    var swrFn = function () {
        return getFeatureToggles(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get customer's FinancialSet
 * @summary customers/{customerId}/financialSet
 */
export var getCustomerFinancialSet = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/financialSet"), method: 'get', headers: headers }, options);
};
export var getGetCustomerFinancialSetKey = function (customerId) {
    return ["/customers/".concat(customerId, "/financialSet")];
};
/**
 * @summary customers/{customerId}/financialSet
 */
export var useGetCustomerFinancialSet = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerFinancialSetKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerFinancialSet(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets collection of formatted price data for products
 * @summary productsFormattedPrices
 */
export var getProductsFormattedPrices = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/productsFormattedPrices", method: 'get', headers: headers, params: params }, options);
};
export var getGetProductsFormattedPricesKey = function (params) {
    return __spreadArray(["/productsFormattedPrices"], (params ? [params] : []), true);
};
/**
 * @summary productsFormattedPrices
 */
export var useGetProductsFormattedPrices = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetProductsFormattedPricesKey(params) : null); });
    var swrFn = function () {
        return getProductsFormattedPrices(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets collection of formatted price data for concepts
 * @summary conceptsFormattedPrices
 */
export var getConceptsFormattedPrices = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/conceptsFormattedPrices", method: 'get', headers: headers, params: params }, options);
};
export var getGetConceptsFormattedPricesKey = function (params) {
    return __spreadArray(["/conceptsFormattedPrices"], (params ? [params] : []), true);
};
/**
 * @summary conceptsFormattedPrices
 */
export var useGetConceptsFormattedPrices = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetConceptsFormattedPricesKey(params) : null); });
    var swrFn = function () {
        return getConceptsFormattedPrices(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get Front Page Banners
 * @summary applications/oriflameApp/frontPageBanners
 */
export var getApplicationsOriflameAppFrontPageBanners = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/oriflameApp/frontPageBanners", method: 'get', headers: headers, params: params }, options);
};
export var getGetApplicationsOriflameAppFrontPageBannersKey = function (params) { return __spreadArray(["/applications/oriflameApp/frontPageBanners"], (params ? [params] : []), true); };
/**
 * @summary applications/oriflameApp/frontPageBanners
 */
export var useGetApplicationsOriflameAppFrontPageBanners = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsOriflameAppFrontPageBannersKey(params) : null); });
    var swrFn = function () {
        return getApplicationsOriflameAppFrontPageBanners(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get Front Page Banner by ID
 * @summary applications/oriflameApp/frontPageBanners/{frontPageBannerId}
 */
export var getApplicationsOriflameAppFrontPageBanner = function (client, frontPageBannerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/oriflameApp/frontPageBanners/".concat(frontPageBannerId),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetApplicationsOriflameAppFrontPageBannerKey = function (frontPageBannerId, params) {
    return __spreadArray([
        "/applications/oriflameApp/frontPageBanners/".concat(frontPageBannerId)
    ], (params ? [params] : []), true);
};
/**
 * @summary applications/oriflameApp/frontPageBanners/{frontPageBannerId}
 */
export var useGetApplicationsOriflameAppFrontPageBanner = function (frontPageBannerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!frontPageBannerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetApplicationsOriflameAppFrontPageBannerKey(frontPageBannerId, params)
            : null;
    });
    var swrFn = function () {
        return getApplicationsOriflameAppFrontPageBanner(customInstance, frontPageBannerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - provides content for the Benefit Banner for segmented customer.
 * @summary applications/frontpage/customers/{customerId}/benefitBanner
 */
export var getApplicationsFrontpageCustomerBenefitBanner = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/frontpage/customers/".concat(customerId, "/benefitBanner"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetApplicationsFrontpageCustomerBenefitBannerKey = function (customerId) {
    return ["/applications/frontpage/customers/".concat(customerId, "/benefitBanner")];
};
/**
 * @summary applications/frontpage/customers/{customerId}/benefitBanner
 */
export var useGetApplicationsFrontpageCustomerBenefitBanner = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsFrontpageCustomerBenefitBannerKey(customerId) : null); });
    var swrFn = function () {
        return getApplicationsFrontpageCustomerBenefitBanner(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns Genesys widget configuration
 * @summary applications/genesysWidget
 */
export var getApplicationsGenesysWidget = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/genesysWidget", method: 'get', headers: headers }, options);
};
export var getGetApplicationsGenesysWidgetKey = function () { return ["/applications/genesysWidget"]; };
/**
 * @summary applications/genesysWidget
 */
export var useGetApplicationsGenesysWidget = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsGenesysWidgetKey() : null); });
    var swrFn = function () {
        return getApplicationsGenesysWidget(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: granted credit
 * @summary customers/{customerId}/grantedCredit
 */
export var getCustomerGrantedCredit = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/grantedCredit"), method: 'get', headers: headers }, options);
};
export var getGetCustomerGrantedCreditKey = function (customerId) {
    return ["/customers/".concat(customerId, "/grantedCredit")];
};
/**
 * @summary customers/{customerId}/grantedCredit
 */
export var useGetCustomerGrantedCredit = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerGrantedCreditKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerGrantedCredit(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: granted credit limit
 * @summary customers/{customerId}/grantedCredit
 */
export var updateCustomerGrantedCredit = function (client, customerId, globalCustomersGrantedCreditDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/grantedCredit"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersGrantedCreditDto,
    }, options);
};
/**
 * GET: guarantee Credit
 * @summary customers/{customerId}/guaranteeCredit
 */
export var getCustomerGuaranteeCredit = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/guaranteeCredit"), method: 'get', headers: headers }, options);
};
export var getGetCustomerGuaranteeCreditKey = function (customerId) {
    return ["/customers/".concat(customerId, "/guaranteeCredit")];
};
/**
 * @summary customers/{customerId}/guaranteeCredit
 */
export var useGetCustomerGuaranteeCredit = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerGuaranteeCreditKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerGuaranteeCredit(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Localization for guarantee credit application
 * @summary applications/guaranteeCredit/localization
 */
export var getApplicationsGuaranteeCreditLocalization = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/guaranteeCredit/localization", method: 'get', headers: headers }, options);
};
export var getGetApplicationsGuaranteeCreditLocalizationKey = function () {
    return ["/applications/guaranteeCredit/localization"];
};
/**
 * @summary applications/guaranteeCredit/localization
 */
export var useGetApplicationsGuaranteeCreditLocalization = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsGuaranteeCreditLocalizationKey() : null); });
    var swrFn = function () {
        return getApplicationsGuaranteeCreditLocalization(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Configuration for guarantee credit application
 * @summary applications/guaranteeCredit/grantedCreditConfiguration
 */
export var getApplicationsGuaranteeCreditGrantedCreditConfiguration = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/guaranteeCredit/grantedCreditConfiguration", method: 'get', headers: headers }, options);
};
export var getGetApplicationsGuaranteeCreditGrantedCreditConfigurationKey = function () {
    return ["/applications/guaranteeCredit/grantedCreditConfiguration"];
};
/**
 * @summary applications/guaranteeCredit/grantedCreditConfiguration
 */
export var useGetApplicationsGuaranteeCreditGrantedCreditConfiguration = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsGuaranteeCreditGrantedCreditConfigurationKey() : null); });
    var swrFn = function () {
        return getApplicationsGuaranteeCreditGrantedCreditConfiguration(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: guarantee credit customers
 * @summary applications/guaranteeCredit/customers
 */
export var getApplicationsGuaranteeCreditCustomers = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/guaranteeCredit/customers", method: 'get', headers: headers, params: params }, options);
};
export var getGetApplicationsGuaranteeCreditCustomersKey = function (params) { return __spreadArray(["/applications/guaranteeCredit/customers"], (params ? [params] : []), true); };
/**
 * @summary applications/guaranteeCredit/customers
 */
export var useGetApplicationsGuaranteeCreditCustomers = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsGuaranteeCreditCustomersKey(params) : null); });
    var swrFn = function () {
        return getApplicationsGuaranteeCreditCustomers(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides home delivery addresses of the customer and related delivery channels (couriers)
 * @summary shoppingSessions/{sessionId}/homeDeliveryOptions
 */
export var getShoppingSessionHomeDeliveryOptions = function (client, sessionId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/homeDeliveryOptions"), method: 'get', headers: headers, params: params }, options);
};
export var getGetShoppingSessionHomeDeliveryOptionsKey = function (sessionId, params) { return __spreadArray(["/shoppingSessions/".concat(sessionId, "/homeDeliveryOptions")], (params ? [params] : []), true); };
/**
 * @summary shoppingSessions/{sessionId}/homeDeliveryOptions
 */
export var useGetShoppingSessionHomeDeliveryOptions = function (sessionId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionHomeDeliveryOptionsKey(sessionId, params) : null); });
    var swrFn = function () {
        return getShoppingSessionHomeDeliveryOptions(customInstance, sessionId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns documents for identity card
 * @summary customers/{customerId}/identityCard
 */
export var getCustomerIdentityCard = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/identityCard"), method: 'get', headers: headers }, options);
};
export var getGetCustomerIdentityCardKey = function (customerId) {
    return ["/customers/".concat(customerId, "/identityCard")];
};
/**
 * @summary customers/{customerId}/identityCard
 */
export var useGetCustomerIdentityCard = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerIdentityCardKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerIdentityCard(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Change documents for identity card (temporary document are submitted and will no longer be deleted)
 * @summary customers/{customerId}/identityCard
 */
export var updateCustomerIdentityCard = function (client, customerId, globalCustomersIdentityCardDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/identityCard"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersIdentityCardDto,
    }, options);
};
/**
 * Returns anonymous (unregistered) customer notifications.
 * @summary inAppNotifications
 */
export var getInAppNotifications = function (client, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/inAppNotifications", method: 'get', headers: headers, params: params }, options);
};
export var getGetInAppNotificationsKey = function (params) {
    return __spreadArray(["/inAppNotifications"], (params ? [params] : []), true);
};
/**
 * @summary inAppNotifications
 */
export var useGetInAppNotifications = function (headers, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetInAppNotificationsKey(params) : null); });
    var swrFn = function () {
        return getInAppNotifications(customInstance, headers, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns anonymous (unregistered) customer notifications. This method should be used to get most recent updates including new notifications.
 * @summary inAppNotificationUpdates
 */
export var getInAppNotificationUpdates = function (client, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/inAppNotificationUpdates", method: 'get', headers: headers, params: params }, options);
};
export var getGetInAppNotificationUpdatesKey = function (params) {
    return __spreadArray(["/inAppNotificationUpdates"], (params ? [params] : []), true);
};
/**
 * @summary inAppNotificationUpdates
 */
export var useGetInAppNotificationUpdates = function (headers, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetInAppNotificationUpdatesKey(params) : null); });
    var swrFn = function () {
        return getInAppNotificationUpdates(customInstance, headers, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns client notifications.
 * @summary customers/{customerId}/inAppNotifications
 */
export var getCustomerInAppNotifications = function (client, customerId, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/inAppNotifications"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerInAppNotificationsKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/inAppNotifications")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/inAppNotifications
 */
export var useGetCustomerInAppNotifications = function (customerId, headers, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerInAppNotificationsKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerInAppNotifications(customInstance, customerId, headers, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Deletes all notifications of customer prior to due/current date.
 * @summary customers/{customerId}/inAppNotifications
 */
export var deleteCustomerInAppNotifications = function (client, customerId, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/inAppNotifications"), method: 'delete', headers: headers, params: params }, options);
};
/**
 * Returns client notifications. This method should be used to get most recent updates including new notifications.
 * @summary customers/{customerId}/inAppNotificationUpdates
 */
export var getCustomerInAppNotificationUpdates = function (client, customerId, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/inAppNotificationUpdates"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerInAppNotificationUpdatesKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/inAppNotificationUpdates")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/inAppNotificationUpdates
 */
export var useGetCustomerInAppNotificationUpdates = function (customerId, headers, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerInAppNotificationUpdatesKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerInAppNotificationUpdates(customInstance, customerId, headers, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Marks given notification as viewed.
 * @summary customers/{customerId}/inAppNotifications/{notificationId}/viewed
 */
export var createCustomerInAppNotificationViewed = function (client, customerId, notificationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/inAppNotifications/").concat(notificationId, "/viewed"),
        method: 'post',
        headers: headers,
    }, options);
};
/**
 * Marks all notifications of customer prior to due/current date as viewed.
 * @summary customers/{customerId}/inAppNotifications/viewed
 */
export var createCustomerInAppNotificationsViewed = function (client, customerId, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/inAppNotifications/viewed"), method: 'post', headers: headers, params: params }, options);
};
/**
 * Deletes given notification.
 * @summary customers/{customerId}/inAppNotifications/{notificationId}
 */
export var deleteCustomerInAppNotification = function (client, customerId, notificationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/inAppNotifications/").concat(notificationId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Undo delete given notification.
 * @summary customers/{customerId}/inAppNotifications/{notificationId}/undelete
 */
export var createCustomerInAppNotificationUndelete = function (client, customerId, notificationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/inAppNotifications/").concat(notificationId, "/undelete"),
        method: 'post',
        headers: headers,
    }, options);
};
/**
 * Marks all notifications of customer prior to due/current date as seen.
 * @summary customers/{customerId}/inAppNotifications/seen
 */
export var createCustomerInAppNotificationsSeen = function (client, customerId, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/inAppNotifications/seen"), method: 'post', headers: headers, params: params }, options);
};
/**
 * Marks given notification as seen.
 * @summary customers/{customerId}/inAppNotifications/{notificationId}/seen
 */
export var createCustomerInAppNotificationSeen = function (client, customerId, notificationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/inAppNotifications/").concat(notificationId, "/seen"),
        method: 'post',
        headers: headers,
    }, options);
};
/**
 * Returns count of unseen notifications
 * @summary customers/{customerId}/unseenNotificationsCount
 */
export var getCustomerUnseenNotificationsCount = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/unseenNotificationsCount"), method: 'get', headers: headers }, options);
};
export var getGetCustomerUnseenNotificationsCountKey = function (customerId) {
    return ["/customers/".concat(customerId, "/unseenNotificationsCount")];
};
/**
 * @summary customers/{customerId}/unseenNotificationsCount
 */
export var useGetCustomerUnseenNotificationsCount = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerUnseenNotificationsCountKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerUnseenNotificationsCount(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets collection of Ingredients for given ingredient Names. If collection of ingredients is empty
all ingredients are returned
 * @summary ingredients
 */
export var getIngredients = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/ingredients", method: 'get', headers: headers, params: params }, options);
};
export var getGetIngredientsKey = function (params) {
    return __spreadArray(["/ingredients"], (params ? [params] : []), true);
};
/**
 * @summary ingredients
 */
export var useGetIngredients = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetIngredientsKey(params) : null); });
    var swrFn = function () {
        return getIngredients(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets Ingredient for given name
 * @summary ingredients/{ingredientName}
 */
export var getIngredient = function (client, ingredientName, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/ingredients/".concat(ingredientName), method: 'get', headers: headers }, options);
};
export var getGetIngredientKey = function (ingredientName) {
    return ["/ingredients/".concat(ingredientName)];
};
/**
 * @summary ingredients/{ingredientName}
 */
export var useGetIngredient = function (ingredientName, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!ingredientName;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetIngredientKey(ingredientName) : null); });
    var swrFn = function () {
        return getIngredient(customInstance, ingredientName, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: international info
 * @summary customers/{customerId}/internationalInfo
 */
export var getCustomerInternationalInfo = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/internationalInfo"), method: 'get', headers: headers }, options);
};
export var getGetCustomerInternationalInfoKey = function (customerId) {
    return ["/customers/".concat(customerId, "/internationalInfo")];
};
/**
 * @summary customers/{customerId}/internationalInfo
 */
export var useGetCustomerInternationalInfo = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerInternationalInfoKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerInternationalInfo(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets Invite Friend profile for the customer with given customer id
 * @summary customers/{customerId}/inviteFriendProfile
 */
export var getCustomerInviteFriendProfile = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/inviteFriendProfile"), method: 'get', headers: headers }, options);
};
export var getGetCustomerInviteFriendProfileKey = function (customerId) {
    return ["/customers/".concat(customerId, "/inviteFriendProfile")];
};
/**
 * @summary customers/{customerId}/inviteFriendProfile
 */
export var useGetCustomerInviteFriendProfile = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerInviteFriendProfileKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerInviteFriendProfile(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns selected value for Job title
 * @summary customers/{customerId}/jobTitle
 */
export var getCustomerJobTitle = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/jobTitle"), method: 'get', headers: headers }, options);
};
export var getGetCustomerJobTitleKey = function (customerId) {
    return ["/customers/".concat(customerId, "/jobTitle")];
};
/**
 * @summary customers/{customerId}/jobTitle
 */
export var useGetCustomerJobTitle = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerJobTitleKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerJobTitle(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Change selected value for Job title
 * @summary customers/{customerId}/jobTitle
 */
export var updateCustomerJobTitle = function (client, customerId, globalCustomersCustomerSelectionDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/jobTitle"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersCustomerSelectionDtoBody,
    }, options);
};
/**
 * GET: Returns joining fee info and html content
 * @deprecated
 * @summary joiningFeeDialog/html
 */
export var getJoiningFeeDialogHtmlDeprecated = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/joiningFeeDialog/html", method: 'get', headers: headers }, options);
};
export var getGetJoiningFeeDialogHtmlDeprecatedKey = function () { return ["/joiningFeeDialog/html"]; };
/**
 * @deprecated
 * @summary joiningFeeDialog/html
 */
export var useGetJoiningFeeDialogHtmlDeprecated = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetJoiningFeeDialogHtmlDeprecatedKey() : null); });
    var swrFn = function () {
        return getJoiningFeeDialogHtmlDeprecated(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns legal information of registration with given ID
 * @summary customerRegistrations/{registrationId}/legalDetails
 */
export var getCustomerRegistrationLegalDetails = function (client, registrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customerRegistrations/".concat(registrationId, "/legalDetails"), method: 'get', headers: headers }, options);
};
export var getGetCustomerRegistrationLegalDetailsKey = function (registrationId) {
    return ["/customerRegistrations/".concat(registrationId, "/legalDetails")];
};
/**
 * @summary customerRegistrations/{registrationId}/legalDetails
 */
export var useGetCustomerRegistrationLegalDetails = function (registrationId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!registrationId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerRegistrationLegalDetailsKey(registrationId) : null); });
    var swrFn = function () {
        return getCustomerRegistrationLegalDetails(customInstance, registrationId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Modifies legal information of registration with given ID
 * @summary customerRegistrations/{registrationId}/legalDetails
 */
export var updateCustomerRegistrationLegalDetails = function (client, registrationId, globalCustomerRegistrationsRegistrationLegalDetailsDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customerRegistrations/".concat(registrationId, "/legalDetails"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomerRegistrationsRegistrationLegalDetailsDto,
    }, options);
};
/**
 * GET: Returns legal document with given area manager filled in
 * @summary customers/{customerId}/legalDocument
 */
export var getCustomerLegalDocument = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/legalDocument"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerLegalDocumentKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/legalDocument")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/legalDocument
 */
export var useGetCustomerLegalDocument = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerLegalDocumentKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerLegalDocument(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * @summary deliveryChannels/{deliveryChannelId}/schedules
 */
export var getDeliveryChannelSchedules = function (client, deliveryChannelId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/deliveryChannels/".concat(deliveryChannelId, "/schedules"), method: 'get', headers: headers }, options);
};
export var getGetDeliveryChannelSchedulesKey = function (deliveryChannelId) {
    return ["/deliveryChannels/".concat(deliveryChannelId, "/schedules")];
};
/**
 * @summary deliveryChannels/{deliveryChannelId}/schedules
 */
export var useGetDeliveryChannelSchedules = function (deliveryChannelId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!deliveryChannelId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetDeliveryChannelSchedulesKey(deliveryChannelId) : null); });
    var swrFn = function () {
        return getDeliveryChannelSchedules(customInstance, deliveryChannelId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns information about Online login status - disabled?
 * @summary login/status
 */
export var getLoginStatus = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/login/status", method: 'get', headers: headers }, options);
};
export var getGetLoginStatusKey = function () { return ["/login/status"]; };
/**
 * @summary login/status
 */
export var useGetLoginStatus = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetLoginStatusKey() : null); });
    var swrFn = function () { return getLoginStatus(customInstance, headers, requestOptions).then(function (d) { return d.data; }); };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Lookup for addresses by ID
 * @deprecated
 * @summary addressNodes/{nodeId}
 */
export var getAddressNodeDeprecated = function (client, nodeId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/addressNodes/".concat(nodeId), method: 'get', headers: headers, params: params }, options);
};
export var getGetAddressNodeDeprecatedKey = function (nodeId, params) { return __spreadArray(["/addressNodes/".concat(nodeId)], (params ? [params] : []), true); };
/**
 * @deprecated
 * @summary addressNodes/{nodeId}
 */
export var useGetAddressNodeDeprecated = function (nodeId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!nodeId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetAddressNodeDeprecatedKey(nodeId, params) : null); });
    var swrFn = function () {
        return getAddressNodeDeprecated(customInstance, nodeId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns single search result item by ID. Use 'GET addressSuggestions' to find results.
 * @summary addressSearchResults/{addressSearchResultId}
 */
export var getAddressSearchResult = function (client, addressSearchResultId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/addressSearchResults/".concat(addressSearchResultId), method: 'get', headers: headers, params: params }, options);
};
export var getGetAddressSearchResultKey = function (addressSearchResultId, params) { return __spreadArray(["/addressSearchResults/".concat(addressSearchResultId)], (params ? [params] : []), true); };
/**
 * @summary addressSearchResults/{addressSearchResultId}
 */
export var useGetAddressSearchResult = function (addressSearchResultId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!addressSearchResultId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetAddressSearchResultKey(addressSearchResultId, params) : null); });
    var swrFn = function () {
        return getAddressSearchResult(customInstance, addressSearchResultId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Lookup for address suggestions by filter
 * @summary addressSuggestions
 */
export var getAddressSuggestions = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/addressSuggestions", method: 'get', headers: headers, params: params }, options);
};
export var getGetAddressSuggestionsKey = function (params) {
    return __spreadArray(["/addressSuggestions"], (params ? [params] : []), true);
};
/**
 * @summary addressSuggestions
 */
export var useGetAddressSuggestions = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetAddressSuggestionsKey(params) : null); });
    var swrFn = function () {
        return getAddressSuggestions(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the looks.
 * @summary applications/makeupwizard/looks
 */
export var getApplicationsMakeupwizardLooks = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/makeupwizard/looks", method: 'get', headers: headers }, options);
};
export var getGetApplicationsMakeupwizardLooksKey = function () {
    return ["/applications/makeupwizard/looks"];
};
/**
 * @summary applications/makeupwizard/looks
 */
export var useGetApplicationsMakeupwizardLooks = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsMakeupwizardLooksKey() : null); });
    var swrFn = function () {
        return getApplicationsMakeupwizardLooks(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the look tags.
 * @summary applications/makeupwizard/looktags
 */
export var getApplicationsMakeupwizardLooktags = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/makeupwizard/looktags", method: 'get', headers: headers }, options);
};
export var getGetApplicationsMakeupwizardLooktagsKey = function () {
    return ["/applications/makeupwizard/looktags"];
};
/**
 * @summary applications/makeupwizard/looktags
 */
export var useGetApplicationsMakeupwizardLooktags = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsMakeupwizardLooktagsKey() : null); });
    var swrFn = function () {
        return getApplicationsMakeupwizardLooktags(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the localization.
 * @summary applications/makeupwizard/localization
 */
export var getApplicationsMakeupwizardLocalization = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/makeupwizard/localization", method: 'get', headers: headers }, options);
};
export var getGetApplicationsMakeupwizardLocalizationKey = function () {
    return ["/applications/makeupwizard/localization"];
};
/**
 * @summary applications/makeupwizard/localization
 */
export var useGetApplicationsMakeupwizardLocalization = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsMakeupwizardLocalizationKey() : null); });
    var swrFn = function () {
        return getApplicationsMakeupwizardLocalization(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the Makeup Wizard Categories
 * @summary applications/makeupwizard/categories
 */
export var getApplicationsMakeupwizardCategories = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/makeupwizard/categories", method: 'get', headers: headers }, options);
};
export var getGetApplicationsMakeupwizardCategoriesKey = function () {
    return ["/applications/makeupwizard/categories"];
};
/**
 * @summary applications/makeupwizard/categories
 */
export var useGetApplicationsMakeupwizardCategories = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsMakeupwizardCategoriesKey() : null); });
    var swrFn = function () {
        return getApplicationsMakeupwizardCategories(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the welcome screen steps.
 * @summary applications/makeupwizard/welcomeScreenSteps
 */
export var getApplicationsMakeupwizardWelcomeScreenSteps = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/makeupwizard/welcomeScreenSteps", method: 'get', headers: headers }, options);
};
export var getGetApplicationsMakeupwizardWelcomeScreenStepsKey = function () {
    return ["/applications/makeupwizard/welcomeScreenSteps"];
};
/**
 * @summary applications/makeupwizard/welcomeScreenSteps
 */
export var useGetApplicationsMakeupwizardWelcomeScreenSteps = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsMakeupwizardWelcomeScreenStepsKey() : null); });
    var swrFn = function () {
        return getApplicationsMakeupwizardWelcomeScreenSteps(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides manager seminars for the selected customer.
 * @summary commissionPlanTypes/successPlan/customers/{customerId}/managerSeminars
 */
export var getCommissionPlanTypesSuccessPlanCustomerManagerSeminars = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/commissionPlanTypes/successPlan/customers/".concat(customerId, "/managerSeminars"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCommissionPlanTypesSuccessPlanCustomerManagerSeminarsKey = function (customerId, params) {
    return __spreadArray([
        "/commissionPlanTypes/successPlan/customers/".concat(customerId, "/managerSeminars")
    ], (params ? [params] : []), true);
};
/**
 * @summary commissionPlanTypes/successPlan/customers/{customerId}/managerSeminars
 */
export var useGetCommissionPlanTypesSuccessPlanCustomerManagerSeminars = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetCommissionPlanTypesSuccessPlanCustomerManagerSeminarsKey(customerId, params)
            : null;
    });
    var swrFn = function () {
        return getCommissionPlanTypesSuccessPlanCustomerManagerSeminars(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns selected value for marital status
 * @summary customers/{customerId}/maritalStatus
 */
export var getCustomerMaritalStatus = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/maritalStatus"), method: 'get', headers: headers }, options);
};
export var getGetCustomerMaritalStatusKey = function (customerId) {
    return ["/customers/".concat(customerId, "/maritalStatus")];
};
/**
 * @summary customers/{customerId}/maritalStatus
 */
export var useGetCustomerMaritalStatus = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerMaritalStatusKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerMaritalStatus(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Change selected value for marital status
 * @summary customers/{customerId}/maritalStatus
 */
export var updateCustomerMaritalStatus = function (client, customerId, globalCustomersCustomerSelectionDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/maritalStatus"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersCustomerSelectionDtoBody,
    }, options);
};
/**
 * Get title qualification parameters
 * @summary commissionPlans/matureMarket/titleQualifications
 */
export var getCommissionPlansMatureMarketTitleQualifications = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/commissionPlans/matureMarket/titleQualifications", method: 'get', headers: headers }, options);
};
export var getGetCommissionPlansMatureMarketTitleQualificationsKey = function () {
    return ["/commissionPlans/matureMarket/titleQualifications"];
};
/**
 * @summary commissionPlans/matureMarket/titleQualifications
 */
export var useGetCommissionPlansMatureMarketTitleQualifications = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCommissionPlansMatureMarketTitleQualificationsKey() : null); });
    var swrFn = function () {
        return getCommissionPlansMatureMarketTitleQualifications(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get personal menu data
 * @summary customers/{customerId}/menu
 */
export var getCustomerMenu = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/menu"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerMenuKey = function (customerId, params) {
    return __spreadArray(["/customers/".concat(customerId, "/menu")], (params ? [params] : []), true);
};
/**
 * @summary customers/{customerId}/menu
 */
export var useGetCustomerMenu = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerMenuKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerMenu(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets links for all existing mobile applications.
 * @deprecated
 * @summary mobileAppsLinks
 */
export var getMobileAppsLinksDeprecated = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/mobileAppsLinks", method: 'get', headers: headers }, options);
};
export var getGetMobileAppsLinksDeprecatedKey = function () { return ["/mobileAppsLinks"]; };
/**
 * @deprecated
 * @summary mobileAppsLinks
 */
export var useGetMobileAppsLinksDeprecated = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetMobileAppsLinksDeprecatedKey() : null); });
    var swrFn = function () {
        return getMobileAppsLinksDeprecated(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns configuration of MV7.
 * @summary applications/mv7/configuration
 */
export var getApplicationsMv7Configuration = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/mv7/configuration", method: 'get', headers: headers }, options);
};
export var getGetApplicationsMv7ConfigurationKey = function () {
    return ["/applications/mv7/configuration"];
};
/**
 * @summary applications/mv7/configuration
 */
export var useGetApplicationsMv7Configuration = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsMv7ConfigurationKey() : null); });
    var swrFn = function () {
        return getApplicationsMv7Configuration(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns customer's MyBenefits card as image stream
 * @summary customers/{customerId}/myBenefitsCard
 */
export var getCustomerMyBenefitsCard = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/myBenefitsCard"), method: 'get', headers: headers }, options);
};
export var getGetCustomerMyBenefitsCardKey = function (customerId) {
    return ["/customers/".concat(customerId, "/myBenefitsCard")];
};
/**
 * @summary customers/{customerId}/myBenefitsCard
 */
export var useGetCustomerMyBenefitsCard = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerMyBenefitsCardKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerMyBenefitsCard(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - Returns collection of Custom Links from My Page
 * @summary applications/oriflameapp/myPage
 */
export var getApplicationsOriflameappMyPage = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/oriflameapp/myPage", method: 'get', headers: headers }, options);
};
export var getGetApplicationsOriflameappMyPageKey = function () {
    return ["/applications/oriflameapp/myPage"];
};
/**
 * @summary applications/oriflameapp/myPage
 */
export var useGetApplicationsOriflameappMyPage = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsOriflameappMyPageKey() : null); });
    var swrFn = function () {
        return getApplicationsOriflameappMyPage(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get category navigation tree or subtree.
 * @summary navigationCategories/{category}
 */
export var getNavigationCategory = function (client, category, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/navigationCategories/".concat(category), method: 'get', headers: headers, params: params }, options);
};
export var getGetNavigationCategoryKey = function (category, params) { return __spreadArray(["/navigationCategories/".concat(category)], (params ? [params] : []), true); };
/**
 * @summary navigationCategories/{category}
 */
export var useGetNavigationCategory = function (category, headers, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!category;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetNavigationCategoryKey(category, params) : null); });
    var swrFn = function () {
        return getNavigationCategory(customInstance, category, headers, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get brand navigation tree or subtree.
 * @summary navigationBrands/{brand}
 */
export var getNavigationBrand = function (client, brand, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/navigationBrands/".concat(brand), method: 'get', headers: headers, params: params }, options);
};
export var getGetNavigationBrandKey = function (brand, params) {
    return __spreadArray(["/navigationBrands/".concat(brand)], (params ? [params] : []), true);
};
/**
 * @summary navigationBrands/{brand}
 */
export var useGetNavigationBrand = function (brand, headers, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!brand;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetNavigationBrandKey(brand, params) : null); });
    var swrFn = function () {
        return getNavigationBrand(customInstance, brand, headers, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets products grouped by concept search results by the specified category. This endpoint implements category navigation and search functionality.
 * @summary applications/navigation/categories/{category}/concepts
 */
export var getApplicationsNavigationCategoryConcepts = function (client, category, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/navigation/categories/".concat(category, "/concepts"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetApplicationsNavigationCategoryConceptsKey = function (category, params) {
    return __spreadArray([
        "/applications/navigation/categories/".concat(category, "/concepts")
    ], (params ? [params] : []), true);
};
/**
 * @summary applications/navigation/categories/{category}/concepts
 */
export var useGetApplicationsNavigationCategoryConcepts = function (category, headers, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!category;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsNavigationCategoryConceptsKey(category, params) : null); });
    var swrFn = function () {
        return getApplicationsNavigationCategoryConcepts(customInstance, category, headers, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets products grouped by concept search results by the specified brand. This endpoint implements  brand navigation and search functionality.
 * @summary applications/navigation/brands/{brand}/concepts
 */
export var getApplicationsNavigationBrandConcepts = function (client, brand, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/navigation/brands/".concat(brand, "/concepts"), method: 'get', headers: headers, params: params }, options);
};
export var getGetApplicationsNavigationBrandConceptsKey = function (brand, params) { return __spreadArray(["/applications/navigation/brands/".concat(brand, "/concepts")], (params ? [params] : []), true); };
/**
 * @summary applications/navigation/brands/{brand}/concepts
 */
export var useGetApplicationsNavigationBrandConcepts = function (brand, headers, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!brand;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsNavigationBrandConceptsKey(brand, params) : null); });
    var swrFn = function () {
        return getApplicationsNavigationBrandConcepts(customInstance, brand, headers, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets products grouped by concept search results by the specified searchTerm or a concept filter filterParams.
 * @summary applications/navigation/concepts
 */
export var getApplicationsNavigationConcepts = function (client, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/navigation/concepts", method: 'get', headers: headers, params: params }, options);
};
export var getGetApplicationsNavigationConceptsKey = function (params) { return __spreadArray(["/applications/navigation/concepts"], (params ? [params] : []), true); };
/**
 * @summary applications/navigation/concepts
 */
export var useGetApplicationsNavigationConcepts = function (headers, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsNavigationConceptsKey(params) : null); });
    var swrFn = function () {
        return getApplicationsNavigationConcepts(customInstance, headers, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get navigation items for specific type
 * @summary applications/navigation/navigations/{navigationType}
 */
export var getApplicationsNavigationNavigation = function (client, navigationType, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/navigation/navigations/".concat(navigationType),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetApplicationsNavigationNavigationKey = function (navigationType, params) {
    return __spreadArray(["/applications/navigation/navigations/".concat(navigationType)], (params ? [params] : []), true);
};
/**
 * @summary applications/navigation/navigations/{navigationType}
 */
export var useGetApplicationsNavigationNavigation = function (navigationType, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!navigationType;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsNavigationNavigationKey(navigationType, params) : null); });
    var swrFn = function () {
        return getApplicationsNavigationNavigation(customInstance, navigationType, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Sends search signal - it is created on specific action.
 * @summary applications/navigation/signal
 */
export var createApplicationsNavigationSignal = function (client, globalProductQuerySignalsDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/navigation/signal",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalProductQuerySignalsDto,
    }, options);
};
/**
 * Sends search signals bulk - it is created on specific action.
 * @summary applications/navigation/signalsBulk
 */
export var createApplicationsNavigationSignalsBulk = function (client, globalProductQuerySignalsBulkDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/navigation/signalsBulk",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalProductQuerySignalsBulkDto,
    }, options);
};
/**
 * Get navigation items of specific type for customer
 * @summary applications/navigation/customers/{customerId}/navigations/{navigationType}
 */
export var getApplicationsNavigationCustomerNavigation = function (client, customerId, navigationType, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/navigation/customers/".concat(customerId, "/navigations/").concat(navigationType),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetApplicationsNavigationCustomerNavigationKey = function (customerId, navigationType, params) {
    return __spreadArray([
        "/applications/navigation/customers/".concat(customerId, "/navigations/").concat(navigationType)
    ], (params ? [params] : []), true);
};
/**
 * @summary applications/navigation/customers/{customerId}/navigations/{navigationType}
 */
export var useGetApplicationsNavigationCustomerNavigation = function (customerId, navigationType, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && navigationType);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetApplicationsNavigationCustomerNavigationKey(customerId, navigationType, params)
            : null;
    });
    var swrFn = function () {
        return getApplicationsNavigationCustomerNavigation(customInstance, customerId, navigationType, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets the information about the customer for given customer id
 * @summary applications/navigation/customers/{customerId}/info
 */
export var getApplicationsNavigationCustomerInfo = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/navigation/customers/".concat(customerId, "/info"), method: 'get', headers: headers }, options);
};
export var getGetApplicationsNavigationCustomerInfoKey = function (customerId) {
    return ["/applications/navigation/customers/".concat(customerId, "/info")];
};
/**
 * @summary applications/navigation/customers/{customerId}/info
 */
export var useGetApplicationsNavigationCustomerInfo = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsNavigationCustomerInfoKey(customerId) : null); });
    var swrFn = function () {
        return getApplicationsNavigationCustomerInfo(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides top news for specific customer
 * @summary customers/{customerId}/news/top
 */
export var createCustomerNewsTop = function (client, customerId, globalSharedPagingDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/news/top"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalSharedPagingDto,
    }, options);
};
/**
 * Subscribes or returns status of newsletter subscription for given email, origin and source values.
 * @summary newsletterSubscriptions
 */
export var createNewsletterSubscription = function (client, globalNewsletterSubscriptionsNewsletterSubscriptionsDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/newsletterSubscriptions",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalNewsletterSubscriptionsNewsletterSubscriptionsDtoBody,
    }, options);
};
/**
 * GET: Returns nominee (e.g. spouse name)
 * @summary customers/{customerId}/nominee
 */
export var getCustomerNominee = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/nominee"), method: 'get', headers: headers }, options);
};
export var getGetCustomerNomineeKey = function (customerId) {
    return ["/customers/".concat(customerId, "/nominee")];
};
/**
 * @summary customers/{customerId}/nominee
 */
export var useGetCustomerNominee = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerNomineeKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerNominee(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Change nominee (e.g. spouse name)
 * @summary customers/{customerId}/nominee
 */
export var updateCustomerNominee = function (client, customerId, globalCustomersNomineeDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/nominee"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersNomineeDto,
    }, options);
};
/**
 * Relays mobile (inapp+push) notification delivery.
 * @summary relayNotifications/mobile
 */
export var createRelayNotificationsMobile = function (client, globalNotificationsMobileNotificationDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/relayNotifications/mobile",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalNotificationsMobileNotificationDto,
    }, options);
};
/**
 * Relays mobile (inapp+push) notification delivery. This is new version of api which allows send one notification with many recipients in one call.
 * @summary relayNotifications/mobileBulk
 */
export var createRelayNotificationsMobileBulk = function (client, globalNotificationsBulkMobileNotificationDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/relayNotifications/mobileBulk",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalNotificationsBulkMobileNotificationDto,
    }, options);
};
/**
 * Update or create new customer notification.
 * @summary customers/{customerId}/notifications
 */
export var createCustomerNotification = function (client, customerId, globalNotificationsCustomerNotificationDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/notifications"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalNotificationsCustomerNotificationDto,
    }, options);
};
/**
 * Delete customer notification.
 * @summary customers/{customerId}/notifications/{notificationId}
 */
export var deleteCustomerNotification = function (client, customerId, notificationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/notifications/").concat(notificationId), method: 'delete', headers: headers }, options);
};
/**
 * Returns single customer notification.
 * @summary customers/{customerId}/notifications/{notificationId}
 */
export var getCustomerNotification = function (client, customerId, notificationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/notifications/").concat(notificationId), method: 'get', headers: headers }, options);
};
export var getGetCustomerNotificationKey = function (customerId, notificationId) {
    return ["/customers/".concat(customerId, "/notifications/").concat(notificationId)];
};
/**
 * @summary customers/{customerId}/notifications/{notificationId}
 */
export var useGetCustomerNotification = function (customerId, notificationId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && notificationId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerNotificationKey(customerId, notificationId) : null); });
    var swrFn = function () {
        return getCustomerNotification(customInstance, customerId, notificationId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Send customer notification.
 * @summary customers/{customerId}/notifications/{notificationId}/send
 */
export var createCustomerNotificationSend = function (client, customerId, notificationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/notifications/").concat(notificationId, "/send"),
        method: 'post',
        headers: headers,
    }, options);
};
/**
 * Recall customer notification.
 * @summary customers/{customerId}/notifications/{notificationId}/recall
 */
export var createCustomerNotificationRecall = function (client, customerId, notificationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/notifications/").concat(notificationId, "/recall"),
        method: 'post',
        headers: headers,
    }, options);
};
/**
 * Search for customer's notifications by criteria.
 * @summary customers/{customerId}/notifications/search
 */
export var createCustomerNotificationsSearch = function (client, customerId, globalNotificationsCustomerNotificationSearchRequestDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/notifications/search"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalNotificationsCustomerNotificationSearchRequestDto,
    }, options);
};
/**
 * Returns target collection
 * @summary customers/notifications/targets
 */
export var getCustomersNotificationsTargets = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/notifications/targets", method: 'get', headers: headers }, options);
};
export var getGetCustomersNotificationsTargetsKey = function () {
    return ["/customers/notifications/targets"];
};
/**
 * @summary customers/notifications/targets
 */
export var useGetCustomersNotificationsTargets = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomersNotificationsTargetsKey() : null); });
    var swrFn = function () {
        return getCustomersNotificationsTargets(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns categories collection
 * @summary notificationCategories
 */
export var getNotificationCategories = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/notificationCategories", method: 'get', headers: headers, params: params }, options);
};
export var getGetNotificationCategoriesKey = function (params) {
    return __spreadArray(["/notificationCategories"], (params ? [params] : []), true);
};
/**
 * @summary notificationCategories
 */
export var useGetNotificationCategories = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetNotificationCategoriesKey(params) : null); });
    var swrFn = function () {
        return getNotificationCategories(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Return single customer attribute by attribute type
 * @deprecated
 * @summary customers/{customerId}/customerAttributes/{customerAttributeTypeId}
 */
export var getCustomerCustomerAttributeDeprecated = function (client, customerId, customerAttributeTypeId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/customerAttributes/").concat(customerAttributeTypeId),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetCustomerCustomerAttributeDeprecatedKey = function (customerId, customerAttributeTypeId) { return ["/customers/".concat(customerId, "/customerAttributes/").concat(customerAttributeTypeId)]; };
/**
 * @deprecated
 * @summary customers/{customerId}/customerAttributes/{customerAttributeTypeId}
 */
export var useGetCustomerCustomerAttributeDeprecated = function (customerId, customerAttributeTypeId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && customerAttributeTypeId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetCustomerCustomerAttributeDeprecatedKey(customerId, customerAttributeTypeId)
            : null;
    });
    var swrFn = function () {
        return getCustomerCustomerAttributeDeprecated(customInstance, customerId, customerAttributeTypeId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Updates single customer attribute by attribute type
 * @deprecated
 * @summary customers/{customerId}/customerAttributes/{customerAttributeTypeId}
 */
export var updateCustomerCustomerAttributeDeprecated = function (client, customerId, customerAttributeTypeId, globalCustomersAttributeDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/customerAttributes/").concat(customerAttributeTypeId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersAttributeDto,
    }, options);
};
/**
 * Gets all customer attributes
 * @deprecated
 * @summary customers/{customerId}/customerAttributes
 */
export var getCustomerCustomerAttributesDeprecated = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/customerAttributes"), method: 'get', headers: headers }, options);
};
export var getGetCustomerCustomerAttributesDeprecatedKey = function (customerId) {
    return ["/customers/".concat(customerId, "/customerAttributes")];
};
/**
 * @deprecated
 * @summary customers/{customerId}/customerAttributes
 */
export var useGetCustomerCustomerAttributesDeprecated = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerCustomerAttributesDeprecatedKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerCustomerAttributesDeprecated(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get list of chosen products of the offer
 * @summary shoppingSessions/{sessionId}/offers/{offerId}/choices
 */
export var getShoppingSessionOfferChoices = function (client, sessionId, offerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/offers/").concat(offerId, "/choices"), method: 'get', headers: headers }, options);
};
export var getGetShoppingSessionOfferChoicesKey = function (sessionId, offerId) {
    return ["/shoppingSessions/".concat(sessionId, "/offers/").concat(offerId, "/choices")];
};
/**
 * @summary shoppingSessions/{sessionId}/offers/{offerId}/choices
 */
export var useGetShoppingSessionOfferChoices = function (sessionId, offerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(sessionId && offerId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionOfferChoicesKey(sessionId, offerId) : null); });
    var swrFn = function () {
        return getShoppingSessionOfferChoices(customInstance, sessionId, offerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Update chosen products of the offer
 * @summary shoppingSessions/{sessionId}/offers/{offerId}/choices
 */
export var updateShoppingSessionOfferChoices = function (client, sessionId, offerId, globalShoppingOfferChoicesDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/offers/").concat(offerId, "/choices"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingOfferChoicesDto,
    }, options);
};
/**
 * DELETE: Remove all chosen products of the offer
 * @summary shoppingSessions/{sessionId}/offers/{offerId}/choices
 */
export var deleteShoppingSessionOfferChoices = function (client, sessionId, offerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/offers/").concat(offerId, "/choices"), method: 'delete', headers: headers }, options);
};
/**
 * POST: Add new chosen offer item
 * @summary shoppingSessions/{sessionId}/offers/{offerId}/choices
 */
export var createShoppingSessionOfferChoice = function (client, sessionId, offerId, globalShoppingOfferChoiceDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/offers/").concat(offerId, "/choices"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingOfferChoiceDtoBody,
    }, options);
};
/**
 * GET: Get chosen offer item by product code
 * @summary shoppingSessions/{sessionId}/offers/{offerId}/choices/{itemCode}
 */
export var getShoppingSessionOfferChoice = function (client, sessionId, offerId, itemCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/offers/").concat(offerId, "/choices/").concat(itemCode),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetShoppingSessionOfferChoiceKey = function (sessionId, offerId, itemCode) { return ["/shoppingSessions/".concat(sessionId, "/offers/").concat(offerId, "/choices/").concat(itemCode)]; };
/**
 * @summary shoppingSessions/{sessionId}/offers/{offerId}/choices/{itemCode}
 */
export var useGetShoppingSessionOfferChoice = function (sessionId, offerId, itemCode, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(sessionId && offerId && itemCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionOfferChoiceKey(sessionId, offerId, itemCode) : null); });
    var swrFn = function () {
        return getShoppingSessionOfferChoice(customInstance, sessionId, offerId, itemCode, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Modify requested quantity of chosen offer item
 * @summary shoppingSessions/{sessionId}/offers/{offerId}/choices/{itemCode}
 */
export var updateShoppingSessionOfferChoice = function (client, sessionId, offerId, itemCode, globalShoppingOfferChoiceDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/offers/").concat(offerId, "/choices/").concat(itemCode),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingOfferChoiceDtoBody,
    }, options);
};
/**
 * DELETE: Remove previously chosen offer item
 * @summary shoppingSessions/{sessionId}/offers/{offerId}/choices/{itemCode}
 */
export var deleteShoppingSessionOfferChoice = function (client, sessionId, offerId, itemCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/offers/").concat(offerId, "/choices/").concat(itemCode),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Get list of offered products
 * @summary shoppingSessions/{sessionId}/offers/{offerId}/offerItems
 */
export var getShoppingSessionOfferOfferItems = function (client, sessionId, offerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/offers/").concat(offerId, "/offerItems"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetShoppingSessionOfferOfferItemsKey = function (sessionId, offerId, params) {
    return __spreadArray([
        "/shoppingSessions/".concat(sessionId, "/offers/").concat(offerId, "/offerItems")
    ], (params ? [params] : []), true);
};
/**
 * @summary shoppingSessions/{sessionId}/offers/{offerId}/offerItems
 */
export var useGetShoppingSessionOfferOfferItems = function (sessionId, offerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(sessionId && offerId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetShoppingSessionOfferOfferItemsKey(sessionId, offerId, params) : null;
    });
    var swrFn = function () {
        return getShoppingSessionOfferOfferItems(customInstance, sessionId, offerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get list of shopping offers evaluated for current shopping bag
 * @summary shoppingSessions/{sessionId}/offers
 */
export var getShoppingSessionOffers = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/offers"), method: 'get', headers: headers }, options);
};
export var getGetShoppingSessionOffersKey = function (sessionId) {
    return ["/shoppingSessions/".concat(sessionId, "/offers")];
};
/**
 * @summary shoppingSessions/{sessionId}/offers
 */
export var useGetShoppingSessionOffers = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionOffersKey(sessionId) : null); });
    var swrFn = function () {
        return getShoppingSessionOffers(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Creates new feedback from customer
 * @summary customers/{customerId}/onBehalfFeedback
 */
export var createCustomerOnBehalfFeedback = function (client, customerId, globalCustomersOnBehalfFeedbackCreateDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/onBehalfFeedback"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersOnBehalfFeedbackCreateDto,
    }, options);
};
/**
 * POST: Send on behalf order notification to customer
 * @summary orders/{orderId}/onBehalfOrderNotification
 */
export var createOrderOnBehalfOrderNotification = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/onBehalfOrderNotification"), method: 'post', headers: headers }, options);
};
/**
 * POST: Send on behalf registration notification to customer
 * @summary customers/{customerId}/onBehalfRegistrationNotification
 */
export var createCustomerOnBehalfRegistrationNotification = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/onBehalfRegistrationNotification"), method: 'post', headers: headers }, options);
};
/**
 * GET: Returns data for onboarding
 * @summary customers/{customerId}/onboarding
 */
export var getCustomerOnboarding = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/onboarding"), method: 'get', headers: headers }, options);
};
export var getGetCustomerOnboardingKey = function (customerId) {
    return ["/customers/".concat(customerId, "/onboarding")];
};
/**
 * @summary customers/{customerId}/onboarding
 */
export var useGetCustomerOnboarding = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerOnboardingKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerOnboarding(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Submits data for onboarding process
 * @summary customers/{customerId}/onboarding
 */
export var updateCustomerOnboarding = function (client, customerId, globalOnboardingOnboardingDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/onboarding"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalOnboardingOnboardingDto,
    }, options);
};
/**
 * GET: Returns document delivery address for onboarding
 * @summary customers/{customerId}/onboardingDocumentDeliveryAddress
 */
export var getCustomerOnboardingDocumentDeliveryAddress = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/onboardingDocumentDeliveryAddress"), method: 'get', headers: headers }, options);
};
export var getGetCustomerOnboardingDocumentDeliveryAddressKey = function (customerId) {
    return ["/customers/".concat(customerId, "/onboardingDocumentDeliveryAddress")];
};
/**
 * @summary customers/{customerId}/onboardingDocumentDeliveryAddress
 */
export var useGetCustomerOnboardingDocumentDeliveryAddress = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerOnboardingDocumentDeliveryAddressKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerOnboardingDocumentDeliveryAddress(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Updates document delivery address for onboarding process
 * @summary customers/{customerId}/onboardingDocumentDeliveryAddress
 */
export var updateCustomerOnboardingDocumentDeliveryAddress = function (client, customerId, globalOnboardingOnboardingDocumentDeliveryAddressDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/onboardingDocumentDeliveryAddress"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalOnboardingOnboardingDocumentDeliveryAddressDto,
    }, options);
};
/**
 * GET: Returns metadata information about onboarding
 * @summary customers/{customerId}/onboardingMetadata
 */
export var getCustomerOnboardingMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/onboardingMetadata"), method: 'get', headers: headers }, options);
};
export var getGetCustomerOnboardingMetadataKey = function (customerId) {
    return ["/customers/".concat(customerId, "/onboardingMetadata")];
};
/**
 * @summary customers/{customerId}/onboardingMetadata
 */
export var useGetCustomerOnboardingMetadata = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerOnboardingMetadataKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerOnboardingMetadata(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides information whether the customer has passed the onboarding test.
 * @summary customers/{customerId}/onboardingTest
 */
export var getCustomerOnboardingTest = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/onboardingTest"), method: 'get', headers: headers }, options);
};
export var getGetCustomerOnboardingTestKey = function (customerId) {
    return ["/customers/".concat(customerId, "/onboardingTest")];
};
/**
 * @summary customers/{customerId}/onboardingTest
 */
export var useGetCustomerOnboardingTest = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerOnboardingTestKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerOnboardingTest(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Provides the possibility to pass the onboarding test.
 * @summary customers/{customerId}/onboardingTest
 */
export var updateCustomerOnboardingTest = function (client, customerId, globalCustomersOnboardingTestDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/onboardingTest"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersOnboardingTestDto,
    }, options);
};
/**
 * Simulates behavior of a standard GET endpoint from Online API with authorization and without any further logic
 * @summary tests/smallSizeResponse/online
 */
export var getTestsSmallSizeResponseOnline = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tests/smallSizeResponse/online", method: 'get', headers: headers }, options);
};
export var getGetTestsSmallSizeResponseOnlineKey = function () {
    return ["/tests/smallSizeResponse/online"];
};
/**
 * @summary tests/smallSizeResponse/online
 */
export var useGetTestsSmallSizeResponseOnline = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTestsSmallSizeResponseOnlineKey() : null); });
    var swrFn = function () {
        return getTestsSmallSizeResponseOnline(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Simulates behavior of a standard GET endpoint from Online API with authorization and without any further logic
 * @summary tests/mediumSizeResponse/online
 */
export var getTestsMediumSizeResponseOnline = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tests/mediumSizeResponse/online", method: 'get', headers: headers }, options);
};
export var getGetTestsMediumSizeResponseOnlineKey = function () {
    return ["/tests/mediumSizeResponse/online"];
};
/**
 * @summary tests/mediumSizeResponse/online
 */
export var useGetTestsMediumSizeResponseOnline = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTestsMediumSizeResponseOnlineKey() : null); });
    var swrFn = function () {
        return getTestsMediumSizeResponseOnline(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Simulates behavior of a standard GET endpoint from Online API with authorization and without any further logic
 * @summary tests/bigSizeResponse/online
 */
export var getTestsBigSizeResponseOnline = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tests/bigSizeResponse/online", method: 'get', headers: headers }, options);
};
export var getGetTestsBigSizeResponseOnlineKey = function () { return ["/tests/bigSizeResponse/online"]; };
/**
 * @summary tests/bigSizeResponse/online
 */
export var useGetTestsBigSizeResponseOnline = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTestsBigSizeResponseOnlineKey() : null); });
    var swrFn = function () {
        return getTestsBigSizeResponseOnline(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Place new order
 * @summary shoppingSessions/{sessionId}/order
 */
export var createShoppingSessionOrder = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/order"), method: 'post', headers: headers }, options);
};
/**
 * GET:  Returns key performance indicators based on order history of the customer
Some information may be omitted based on market settings and customer type.
 * @summary applications/orderHistory/customers/{customerId}/kpi
 */
export var getApplicationsOrderHistoryCustomerKpi = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/orderHistory/customers/".concat(customerId, "/kpi"), method: 'get', headers: headers }, options);
};
export var getGetApplicationsOrderHistoryCustomerKpiKey = function (customerId) {
    return ["/applications/orderHistory/customers/".concat(customerId, "/kpi")];
};
/**
 * @summary applications/orderHistory/customers/{customerId}/kpi
 */
export var useGetApplicationsOrderHistoryCustomerKpi = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsOrderHistoryCustomerKpiKey(customerId) : null); });
    var swrFn = function () {
        return getApplicationsOrderHistoryCustomerKpi(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Configuration for Order history
 * @summary applications/orderHistory/customers/{customerId}/configuration
 */
export var getApplicationsOrderHistoryCustomerConfiguration = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/orderHistory/customers/".concat(customerId, "/configuration"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetApplicationsOrderHistoryCustomerConfigurationKey = function (customerId) {
    return ["/applications/orderHistory/customers/".concat(customerId, "/configuration")];
};
/**
 * @summary applications/orderHistory/customers/{customerId}/configuration
 */
export var useGetApplicationsOrderHistoryCustomerConfiguration = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsOrderHistoryCustomerConfigurationKey(customerId) : null); });
    var swrFn = function () {
        return getApplicationsOrderHistoryCustomerConfiguration(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns order items for given orders from one customer.
 * @summary orderItems
 */
export var getOrderItems = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orderItems", method: 'get', headers: headers, params: params }, options);
};
export var getGetOrderItemsKey = function (params) {
    return __spreadArray(["/orderItems"], (params ? [params] : []), true);
};
/**
 * @summary orderItems
 */
export var useGetOrderItems = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetOrderItemsKey(params) : null); });
    var swrFn = function () {
        return getOrderItems(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets a list of orders for a specified customerId, with the possibility of filtering only desired status, and paging.
You can additionally filter by a search phrase, and choose to include WeChat orders.
History type switches between returning orders in the Current + past 3 periods; or the entire history (2 years).

If paging parameters are not provided, no paging is applied and full history for given time period is returned.
 * @summary orders
 */
export var getOrders = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders", method: 'get', headers: headers, params: params }, options);
};
export var getGetOrdersKey = function (params) {
    return __spreadArray(["/orders"], (params ? [params] : []), true);
};
/**
 * @summary orders
 */
export var useGetOrders = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetOrdersKey(params) : null); });
    var swrFn = function () {
        return getOrders(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Place new order
 * @summary orders
 */
export var createOrder = function (client, globalShoppingOrderDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/orders",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingOrderDto,
    }, options);
};
/**
 * GET: Get specific order of a customer
 * @summary orders/{orderId}
 */
export var getOrder = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId), method: 'get', headers: headers }, options);
};
export var getGetOrderKey = function (orderId) { return ["/orders/".concat(orderId)]; };
/**
 * @summary orders/{orderId}
 */
export var useGetOrder = function (orderId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!orderId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetOrderKey(orderId) : null); });
    var swrFn = function () {
        return getOrder(customInstance, orderId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * DELETE : cancel order if cancellation is allowed
 * @summary orders/{orderId}
 */
export var deleteOrder = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId), method: 'delete', headers: headers }, options);
};
/**
 * GET: Get order items
 * @summary orders/{orderId}/orderItems
 */
export var getOrderOrderItems = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/orderItems"), method: 'get', headers: headers }, options);
};
export var getGetOrderOrderItemsKey = function (orderId) {
    return ["/orders/".concat(orderId, "/orderItems")];
};
/**
 * @summary orders/{orderId}/orderItems
 */
export var useGetOrderOrderItems = function (orderId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!orderId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetOrderOrderItemsKey(orderId) : null); });
    var swrFn = function () {
        return getOrderOrderItems(customInstance, orderId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get operation principals
 * @summary orders/{orderId}/operationPrincipals
 */
export var getOrderOperationPrincipals = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/operationPrincipals"), method: 'get', headers: headers }, options);
};
export var getGetOrderOperationPrincipalsKey = function (orderId) {
    return ["/orders/".concat(orderId, "/operationPrincipals")];
};
/**
 * @summary orders/{orderId}/operationPrincipals
 */
export var useGetOrderOperationPrincipals = function (orderId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!orderId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetOrderOperationPrincipalsKey(orderId) : null); });
    var swrFn = function () {
        return getOrderOperationPrincipals(customInstance, orderId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get last unpaid order for specific customer
 * @summary customers/{customerId}/orders/lastUnpaid
 */
export var getCustomerOrdersLastUnpaid = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/orders/lastUnpaid"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerOrdersLastUnpaidKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/orders/lastUnpaid")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/orders/lastUnpaid
 */
export var useGetCustomerOrdersLastUnpaid = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerOrdersLastUnpaidKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerOrdersLastUnpaid(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Approve order placed on behalf of customer
 * @summary orders/{orderId}/approval
 */
export var updateOrderApproval = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/approval"), method: 'put', headers: headers }, options);
};
/**
 * GET: Provide availability of order cancel operation
 * @summary orders/{orderId}/cancellation
 */
export var getOrderCancellation = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/cancellation"), method: 'get', headers: headers }, options);
};
export var getGetOrderCancellationKey = function (orderId) {
    return ["/orders/".concat(orderId, "/cancellation")];
};
/**
 * @summary orders/{orderId}/cancellation
 */
export var useGetOrderCancellation = function (orderId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!orderId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetOrderCancellationKey(orderId) : null); });
    var swrFn = function () {
        return getOrderCancellation(customInstance, orderId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get realtime order trackings
 * @summary orders/{orderId}/realtimeOrderTracking
 */
export var getOrderRealtimeOrderTracking = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/realtimeOrderTracking"), method: 'get', headers: headers }, options);
};
export var getGetOrderRealtimeOrderTrackingKey = function (orderId) {
    return ["/orders/".concat(orderId, "/realtimeOrderTracking")];
};
/**
 * @summary orders/{orderId}/realtimeOrderTracking
 */
export var useGetOrderRealtimeOrderTracking = function (orderId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!orderId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetOrderRealtimeOrderTrackingKey(orderId) : null); });
    var swrFn = function () {
        return getOrderRealtimeOrderTracking(customInstance, orderId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provide selected payment provider
 * @summary orders/{orderId}/paymentProvider
 */
export var getOrderPaymentProvider = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/paymentProvider"), method: 'get', headers: headers }, options);
};
export var getGetOrderPaymentProviderKey = function (orderId) {
    return ["/orders/".concat(orderId, "/paymentProvider")];
};
/**
 * @summary orders/{orderId}/paymentProvider
 */
export var useGetOrderPaymentProvider = function (orderId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!orderId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetOrderPaymentProviderKey(orderId) : null); });
    var swrFn = function () {
        return getOrderPaymentProvider(customInstance, orderId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Update selected payment provider
 * @summary orders/{orderId}/paymentProvider
 */
export var updateOrderPaymentProvider = function (client, orderId, globalShoppingOrderPaymentProviderDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/orders/".concat(orderId, "/paymentProvider"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingOrderPaymentProviderDto,
    }, options);
};
/**
 * GET: Returns order summary.
 * @summary orders/{orderId}/summary
 */
export var getOrderSummary = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/summary"), method: 'get', headers: headers }, options);
};
export var getGetOrderSummaryKey = function (orderId) { return ["/orders/".concat(orderId, "/summary")]; };
/**
 * @summary orders/{orderId}/summary
 */
export var useGetOrderSummary = function (orderId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!orderId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetOrderSummaryKey(orderId) : null); });
    var swrFn = function () {
        return getOrderSummary(customInstance, orderId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns a list of all discounts applied to the order.
 * @summary orders/{orderId}/discounts
 */
export var getOrderDiscounts = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/discounts"), method: 'get', headers: headers }, options);
};
export var getGetOrderDiscountsKey = function (orderId) {
    return ["/orders/".concat(orderId, "/discounts")];
};
/**
 * @summary orders/{orderId}/discounts
 */
export var useGetOrderDiscounts = function (orderId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!orderId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetOrderDiscountsKey(orderId) : null); });
    var swrFn = function () {
        return getOrderDiscounts(customInstance, orderId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns a list of documents related to the order.
 * @summary orders/{orderId}/documents
 */
export var getOrderDocuments = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/documents"), method: 'get', headers: headers }, options);
};
export var getGetOrderDocumentsKey = function (orderId) {
    return ["/orders/".concat(orderId, "/documents")];
};
/**
 * @summary orders/{orderId}/documents
 */
export var useGetOrderDocuments = function (orderId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!orderId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetOrderDocumentsKey(orderId) : null); });
    var swrFn = function () {
        return getOrderDocuments(customInstance, orderId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets the collection of all end consumers from a given order.
 * @summary orders/{orderId}/endConsumers
 */
export var getOrderEndConsumers = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/endConsumers"), method: 'get', headers: headers }, options);
};
export var getGetOrderEndConsumersKey = function (orderId) {
    return ["/orders/".concat(orderId, "/endConsumers")];
};
/**
 * @summary orders/{orderId}/endConsumers
 */
export var useGetOrderEndConsumers = function (orderId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!orderId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetOrderEndConsumersKey(orderId) : null); });
    var swrFn = function () {
        return getOrderEndConsumers(customInstance, orderId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns a list of order statuses and the total sum of orders per each status.
 * @summary orderStatuses
 */
export var getOrderStatuses = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orderStatuses", method: 'get', headers: headers, params: params }, options);
};
export var getGetOrderStatusesKey = function (params) {
    return __spreadArray(["/orderStatuses"], (params ? [params] : []), true);
};
/**
 * @summary orderStatuses
 */
export var useGetOrderStatuses = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetOrderStatusesKey(params) : null); });
    var swrFn = function () {
        return getOrderStatuses(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns order navigation information (e.g. order detail page URL)
 * @summary orders/{orderId}/navigation
 */
export var getOrderNavigation = function (client, orderId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/navigation"), method: 'get', headers: headers, params: params }, options);
};
export var getGetOrderNavigationKey = function (orderId, params) {
    return __spreadArray(["/orders/".concat(orderId, "/navigation")], (params ? [params] : []), true);
};
/**
 * @summary orders/{orderId}/navigation
 */
export var useGetOrderNavigation = function (orderId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!orderId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetOrderNavigationKey(orderId, params) : null); });
    var swrFn = function () {
        return getOrderNavigation(customInstance, orderId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET:  Returns financial aggregates for a given order such as debt, fees, discounts and BPs.
Some information may be omitted based on market settings and customer type.
 * @summary applications/orderSummary/orders/{orderId}/summary
 */
export var getApplicationsOrderSummaryOrderSummary = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/orderSummary/orders/".concat(orderId, "/summary"), method: 'get', headers: headers }, options);
};
export var getGetApplicationsOrderSummaryOrderSummaryKey = function (orderId) {
    return ["/applications/orderSummary/orders/".concat(orderId, "/summary")];
};
/**
 * @summary applications/orderSummary/orders/{orderId}/summary
 */
export var useGetApplicationsOrderSummaryOrderSummary = function (orderId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!orderId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsOrderSummaryOrderSummaryKey(orderId) : null); });
    var swrFn = function () {
        return getApplicationsOrderSummaryOrderSummary(customInstance, orderId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns customer oriflame card in PDF format
 * @summary customers/{customerId}/oriflameCard
 */
export var getCustomerOriflameCard = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/oriflameCard"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerOriflameCardKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/oriflameCard")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/oriflameCard
 */
export var useGetCustomerOriflameCard = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerOriflameCardKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerOriflameCard(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get OutdatedBrowserInfo localization.
 * @summary applications/outdatedBrowserInfo/localization
 */
export var getApplicationsOutdatedBrowserInfoLocalization = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/outdatedBrowserInfo/localization", method: 'get', headers: headers }, options);
};
export var getGetApplicationsOutdatedBrowserInfoLocalizationKey = function () {
    return ["/applications/outdatedBrowserInfo/localization"];
};
/**
 * @summary applications/outdatedBrowserInfo/localization
 */
export var useGetApplicationsOutdatedBrowserInfoLocalization = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsOutdatedBrowserInfoLocalizationKey() : null); });
    var swrFn = function () {
        return getApplicationsOutdatedBrowserInfoLocalization(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns if customer has access to the specified page.
 * @summary customers/{customerId}/pages/{pageId}/access
 */
export var getCustomerPageAccess = function (client, customerId, pageId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/pages/").concat(pageId, "/access"), method: 'get', headers: headers }, options);
};
export var getGetCustomerPageAccessKey = function (customerId, pageId) {
    return ["/customers/".concat(customerId, "/pages/").concat(pageId, "/access")];
};
/**
 * @summary customers/{customerId}/pages/{pageId}/access
 */
export var useGetCustomerPageAccess = function (customerId, pageId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && pageId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerPageAccessKey(customerId, pageId) : null); });
    var swrFn = function () {
        return getCustomerPageAccess(customInstance, customerId, pageId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns data for parental consent for secureId
 * @summary parentalConsents/{parentalConsentId}
 */
export var getParentalConsent = function (client, parentalConsentId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/parentalConsents/".concat(parentalConsentId), method: 'get', headers: headers }, options);
};
export var getGetParentalConsentKey = function (parentalConsentId) {
    return ["/parentalConsents/".concat(parentalConsentId)];
};
/**
 * @summary parentalConsents/{parentalConsentId}
 */
export var useGetParentalConsent = function (parentalConsentId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!parentalConsentId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetParentalConsentKey(parentalConsentId) : null); });
    var swrFn = function () {
        return getParentalConsent(customInstance, parentalConsentId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Updates parental consent for secureId
 * @summary parentalConsents/{parentalConsentId}
 */
export var updateParentalConsent = function (client, parentalConsentId, globalParentalConsentParentalConsentDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/parentalConsents/".concat(parentalConsentId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalParentalConsentParentalConsentDto,
    }, options);
};
/**
 * GET: Returns parental consent metadata for secureId
 * @summary parentalConsents/{parentalConsentId}/metadata
 */
export var getParentalConsentMetadata = function (client, parentalConsentId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/parentalConsents/".concat(parentalConsentId, "/metadata"), method: 'get', headers: headers }, options);
};
export var getGetParentalConsentMetadataKey = function (parentalConsentId) {
    return ["/parentalConsents/".concat(parentalConsentId, "/metadata")];
};
/**
 * @summary parentalConsents/{parentalConsentId}/metadata
 */
export var useGetParentalConsentMetadata = function (parentalConsentId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!parentalConsentId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetParentalConsentMetadataKey(parentalConsentId) : null); });
    var swrFn = function () {
        return getParentalConsentMetadata(customInstance, parentalConsentId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides payment method based on id
 * @summary paymentMethods/{paymentMethodId}
 */
export var getPaymentMethod = function (client, paymentMethodId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/paymentMethods/".concat(paymentMethodId), method: 'get', headers: headers }, options);
};
export var getGetPaymentMethodKey = function (paymentMethodId) {
    return ["/paymentMethods/".concat(paymentMethodId)];
};
/**
 * @summary paymentMethods/{paymentMethodId}
 */
export var useGetPaymentMethod = function (paymentMethodId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!paymentMethodId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPaymentMethodKey(paymentMethodId) : null); });
    var swrFn = function () {
        return getPaymentMethod(customInstance, paymentMethodId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides payment methods
 * @summary orders/{orderId}/paymentMethods
 */
export var getOrderPaymentMethods = function (client, orderId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/paymentMethods"), method: 'get', headers: headers, params: params }, options);
};
export var getGetOrderPaymentMethodsKey = function (orderId, params) { return __spreadArray(["/orders/".concat(orderId, "/paymentMethods")], (params ? [params] : []), true); };
/**
 * @summary orders/{orderId}/paymentMethods
 */
export var useGetOrderPaymentMethods = function (orderId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!orderId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetOrderPaymentMethodsKey(orderId, params) : null); });
    var swrFn = function () {
        return getOrderPaymentMethods(customInstance, orderId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides payment methods
 * @summary shoppingSessions/{sessionId}/paymentMethods
 */
export var getShoppingSessionPaymentMethods = function (client, sessionId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/paymentMethods"), method: 'get', headers: headers, params: params }, options);
};
export var getGetShoppingSessionPaymentMethodsKey = function (sessionId, params) { return __spreadArray(["/shoppingSessions/".concat(sessionId, "/paymentMethods")], (params ? [params] : []), true); };
/**
 * @summary shoppingSessions/{sessionId}/paymentMethods
 */
export var useGetShoppingSessionPaymentMethods = function (sessionId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionPaymentMethodsKey(sessionId, params) : null); });
    var swrFn = function () {
        return getShoppingSessionPaymentMethods(customInstance, sessionId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides payment providers
 * @summary shoppingSessions/{sessionId}/paymentProviders
 */
export var getShoppingSessionPaymentProviders = function (client, sessionId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/paymentProviders"), method: 'get', headers: headers, params: params }, options);
};
export var getGetShoppingSessionPaymentProvidersKey = function (sessionId, params) { return __spreadArray(["/shoppingSessions/".concat(sessionId, "/paymentProviders")], (params ? [params] : []), true); };
/**
 * @summary shoppingSessions/{sessionId}/paymentProviders
 */
export var useGetShoppingSessionPaymentProviders = function (sessionId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionPaymentProvidersKey(sessionId, params) : null); });
    var swrFn = function () {
        return getShoppingSessionPaymentProviders(customInstance, sessionId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides payment provider
 * @summary shoppingSessions/{sessionId}/paymentProviders/{paymentProviderId}
 */
export var getShoppingSessionPaymentProvider = function (client, sessionId, paymentProviderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/paymentProviders/").concat(paymentProviderId),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetShoppingSessionPaymentProviderKey = function (sessionId, paymentProviderId) { return ["/shoppingSessions/".concat(sessionId, "/paymentProviders/").concat(paymentProviderId)]; };
/**
 * @summary shoppingSessions/{sessionId}/paymentProviders/{paymentProviderId}
 */
export var useGetShoppingSessionPaymentProvider = function (sessionId, paymentProviderId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(sessionId && paymentProviderId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetShoppingSessionPaymentProviderKey(sessionId, paymentProviderId) : null;
    });
    var swrFn = function () {
        return getShoppingSessionPaymentProvider(customInstance, sessionId, paymentProviderId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get payment provider
 * @summary paymentProviders/{paymentProviderId}
 */
export var getPaymentProvider = function (client, paymentProviderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/paymentProviders/".concat(paymentProviderId), method: 'get', headers: headers }, options);
};
export var getGetPaymentProviderKey = function (paymentProviderId) {
    return ["/paymentProviders/".concat(paymentProviderId)];
};
/**
 * @summary paymentProviders/{paymentProviderId}
 */
export var useGetPaymentProvider = function (paymentProviderId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!paymentProviderId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPaymentProviderKey(paymentProviderId) : null); });
    var swrFn = function () {
        return getPaymentProvider(customInstance, paymentProviderId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides payment providers
 * @summary orders/{orderId}/paymentProviders
 */
export var getOrderPaymentProviders = function (client, orderId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/paymentProviders"), method: 'get', headers: headers, params: params }, options);
};
export var getGetOrderPaymentProvidersKey = function (orderId, params) { return __spreadArray(["/orders/".concat(orderId, "/paymentProviders")], (params ? [params] : []), true); };
/**
 * @summary orders/{orderId}/paymentProviders
 */
export var useGetOrderPaymentProviders = function (orderId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!orderId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetOrderPaymentProvidersKey(orderId, params) : null); });
    var swrFn = function () {
        return getOrderPaymentProviders(customInstance, orderId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Initialization of the online payment process, returns the parameters that are needed for further processing by the payment provider
 * @summary customer/{customerId}/order/{orderId}/paymentData
 */
export var createCustomerOrderPaymentDatum = function (client, customerId, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customer/".concat(customerId, "/order/").concat(orderId, "/paymentData"), method: 'post', headers: headers }, options);
};
/**
 * POST: Initialization of the shared online payment process, returns the parameters that are needed for further processing by the payment provider
 * @summary customer/{customerId}/order/{orderId}/sharedPaymentData
 */
export var createCustomerOrderSharedPaymentDatum = function (client, customerId, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customer/".concat(customerId, "/order/").concat(orderId, "/sharedPaymentData"), method: 'post', headers: headers }, options);
};
/**
 * GET: Returns information about online payment
 * @summary onlinePayments/{onlinePaymentId}
 */
export var getOnlinePayment = function (client, onlinePaymentId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/onlinePayments/".concat(onlinePaymentId), method: 'get', headers: headers }, options);
};
export var getGetOnlinePaymentKey = function (onlinePaymentId) {
    return ["/onlinePayments/".concat(onlinePaymentId)];
};
/**
 * @summary onlinePayments/{onlinePaymentId}
 */
export var useGetOnlinePayment = function (onlinePaymentId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!onlinePaymentId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetOnlinePaymentKey(onlinePaymentId) : null); });
    var swrFn = function () {
        return getOnlinePayment(customInstance, onlinePaymentId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provide selected payment
 * @summary shoppingSessions/{sessionId}/payment
 */
export var getShoppingSessionPayment = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/payment"), method: 'get', headers: headers }, options);
};
export var getGetShoppingSessionPaymentKey = function (sessionId) {
    return ["/shoppingSessions/".concat(sessionId, "/payment")];
};
/**
 * @summary shoppingSessions/{sessionId}/payment
 */
export var useGetShoppingSessionPayment = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionPaymentKey(sessionId) : null); });
    var swrFn = function () {
        return getShoppingSessionPayment(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Update selected payment
 * @summary shoppingSessions/{sessionId}/payment
 */
export var updateShoppingSessionPayment = function (client, sessionId, globalShoppingPaymentDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/payment"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingPaymentDto,
    }, options);
};
/**
 * PUT: Creates a new payment transaction in PayU system (PaymentOS)
 * @summary paymentProviders/payu/payments/{onlinePaymentId}/transaction
 */
export var updatePaymentProvidersPayuPaymentTransaction = function (client, onlinePaymentId, globalPaymentsPayUPaymentRequestDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/paymentProviders/payu/payments/".concat(onlinePaymentId, "/transaction"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalPaymentsPayUPaymentRequestDto,
    }, options);
};
/**
 * GET: Gets status of payment transaction identified by online payment id.
 * @summary paymentProviders/payu/payments/{onlinePaymentId}/response
 */
export var getPaymentProvidersPayuPaymentResponse = function (client, onlinePaymentId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/paymentProviders/payu/payments/".concat(onlinePaymentId, "/response"), method: 'get', headers: headers }, options);
};
export var getGetPaymentProvidersPayuPaymentResponseKey = function (onlinePaymentId) {
    return ["/paymentProviders/payu/payments/".concat(onlinePaymentId, "/response")];
};
/**
 * @summary paymentProviders/payu/payments/{onlinePaymentId}/response
 */
export var useGetPaymentProvidersPayuPaymentResponse = function (onlinePaymentId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!onlinePaymentId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPaymentProvidersPayuPaymentResponseKey(onlinePaymentId) : null); });
    var swrFn = function () {
        return getPaymentProvidersPayuPaymentResponse(customInstance, onlinePaymentId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * DELETE: PayU - Remove customer's stored payment method in PayU system (PaymentsOS)
 * @summary customers/{customerId}/paymentProviders/payu/paymentMethods/{paymentMethodToken}
 */
export var deleteCustomerPaymentProvidersPayuPaymentMethod = function (client, customerId, paymentMethodToken, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/paymentProviders/payu/paymentMethods/").concat(paymentMethodToken),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Get international info about PBS (e.g. home country)
 * @summary personalBeautyStores/{name}/internationalInfo
 */
export var getPersonalBeautyStoreInternationalInfo = function (client, name, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/personalBeautyStores/".concat(name, "/internationalInfo"), method: 'get', headers: headers }, options);
};
export var getGetPersonalBeautyStoreInternationalInfoKey = function (name) {
    return ["/personalBeautyStores/".concat(name, "/internationalInfo")];
};
/**
 * @summary personalBeautyStores/{name}/internationalInfo
 */
export var useGetPersonalBeautyStoreInternationalInfo = function (name, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!name;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPersonalBeautyStoreInternationalInfoKey(name) : null); });
    var swrFn = function () {
        return getPersonalBeautyStoreInternationalInfo(customInstance, name, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns result of evaluation if the order can be paid and number of pending payments
 * @summary orders/{orderId}/pendingPaymentsResult
 */
export var getOrderPendingPaymentsResult = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/pendingPaymentsResult"), method: 'get', headers: headers }, options);
};
export var getGetOrderPendingPaymentsResultKey = function (orderId) {
    return ["/orders/".concat(orderId, "/pendingPaymentsResult")];
};
/**
 * @summary orders/{orderId}/pendingPaymentsResult
 */
export var useGetOrderPendingPaymentsResult = function (orderId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!orderId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetOrderPendingPaymentsResultKey(orderId) : null); });
    var swrFn = function () {
        return getOrderPendingPaymentsResult(customInstance, orderId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns pending registration
 * @summary pendingRegistrations/{pendingRegistrationId}
 */
export var getPendingRegistration = function (client, pendingRegistrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/pendingRegistrations/".concat(pendingRegistrationId), method: 'get', headers: headers }, options);
};
export var getGetPendingRegistrationKey = function (pendingRegistrationId) {
    return ["/pendingRegistrations/".concat(pendingRegistrationId)];
};
/**
 * @summary pendingRegistrations/{pendingRegistrationId}
 */
export var useGetPendingRegistration = function (pendingRegistrationId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!pendingRegistrationId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPendingRegistrationKey(pendingRegistrationId) : null); });
    var swrFn = function () {
        return getPendingRegistration(customInstance, pendingRegistrationId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Updates pending registration
 * @summary pendingRegistrations/{pendingRegistrationId}
 */
export var updatePendingRegistration = function (client, pendingRegistrationId, globalPendingRegistrationsPendingRegistrationDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/pendingRegistrations/".concat(pendingRegistrationId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalPendingRegistrationsPendingRegistrationDtoBody,
    }, options);
};
/**
 * POST: Creates new pending registration
 * @summary pendingRegistrations
 */
export var createPendingRegistration = function (client, globalPendingRegistrationsPendingRegistrationDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/pendingRegistrations",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalPendingRegistrationsPendingRegistrationDtoBody,
    }, options);
};
/**
 * GET: Returns settings and metadata for pending registration
 * @summary pendingRegistrationsMetadata
 */
export var getPendingRegistrationsMetadata = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/pendingRegistrationsMetadata", method: 'get', headers: headers }, options);
};
export var getGetPendingRegistrationsMetadataKey = function () {
    return ["/pendingRegistrationsMetadata"];
};
/**
 * @summary pendingRegistrationsMetadata
 */
export var useGetPendingRegistrationsMetadata = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPendingRegistrationsMetadataKey() : null); });
    var swrFn = function () {
        return getPendingRegistrationsMetadata(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET period information based on given period code
 * @summary periods/{periodCode}
 */
export var getPeriod = function (client, periodCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/periods/".concat(periodCode), method: 'get', headers: headers }, options);
};
export var getGetPeriodKey = function (periodCode) { return ["/periods/".concat(periodCode)]; };
/**
 * @summary periods/{periodCode}
 */
export var useGetPeriod = function (periodCode, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!periodCode;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPeriodKey(periodCode) : null); });
    var swrFn = function () {
        return getPeriod(customInstance, periodCode, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET periods information based on given offsets
 * @summary periods
 */
export var getPeriods = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/periods", method: 'get', headers: headers, params: params }, options);
};
export var getGetPeriodsKey = function (params) {
    return __spreadArray(["/periods"], (params ? [params] : []), true);
};
/**
 * @summary periods
 */
export var useGetPeriods = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPeriodsKey(params) : null); });
    var swrFn = function () {
        return getPeriods(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET current period information
 * @summary periods/currentPeriod
 */
export var getPeriodsCurrentPeriod = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/periods/currentPeriod", method: 'get', headers: headers }, options);
};
export var getGetPeriodsCurrentPeriodKey = function () { return ["/periods/currentPeriod"]; };
/**
 * @summary periods/currentPeriod
 */
export var useGetPeriodsCurrentPeriod = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPeriodsCurrentPeriodKey() : null); });
    var swrFn = function () {
        return getPeriodsCurrentPeriod(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provide status of period tasks
 * @summary periods/{periodCode}/tasks
 */
export var getPeriodTasks = function (client, periodCode, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/periods/".concat(periodCode, "/tasks"), method: 'get', headers: headers, params: params }, options);
};
export var getGetPeriodTasksKey = function (periodCode, params) {
    return __spreadArray(["/periods/".concat(periodCode, "/tasks")], (params ? [params] : []), true);
};
/**
 * @summary periods/{periodCode}/tasks
 */
export var useGetPeriodTasks = function (periodCode, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!periodCode;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPeriodTasksKey(periodCode, params) : null); });
    var swrFn = function () {
        return getPeriodTasks(customInstance, periodCode, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: provide status of period task
 * @summary periods/{periodCode}/tasks/{taskId}
 */
export var getPeriodTask = function (client, periodCode, taskId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/periods/".concat(periodCode, "/tasks/").concat(taskId), method: 'get', headers: headers }, options);
};
export var getGetPeriodTaskKey = function (periodCode, taskId) {
    return ["/periods/".concat(periodCode, "/tasks/").concat(taskId)];
};
/**
 * @summary periods/{periodCode}/tasks/{taskId}
 */
export var useGetPeriodTask = function (periodCode, taskId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(periodCode && taskId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPeriodTaskKey(periodCode, taskId) : null); });
    var swrFn = function () {
        return getPeriodTask(customInstance, periodCode, taskId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Returns concepts permissions
 * @summary concepts/permissions
 */
export var getConceptsPermissions = function (client, globalConceptsPermissionsQueryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/concepts/permissions",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalConceptsPermissionsQueryDtoBody,
    }, options);
};
/**
 * GET: Provides concept permissions
 * @summary concepts/{conceptCode}/permission
 */
export var getConceptPermission = function (client, conceptCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/concepts/".concat(conceptCode, "/permission"), method: 'get', headers: headers }, options);
};
export var getGetConceptPermissionKey = function (conceptCode) {
    return ["/concepts/".concat(conceptCode, "/permission")];
};
/**
 * @summary concepts/{conceptCode}/permission
 */
export var useGetConceptPermission = function (conceptCode, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!conceptCode;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetConceptPermissionKey(conceptCode) : null); });
    var swrFn = function () {
        return getConceptPermission(customInstance, conceptCode, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Returns concepts permissions
 * @summary customers/{customerId}/concepts/permissions
 */
export var getCustomerConceptsPermissions = function (client, customerId, globalConceptsPermissionsQueryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/concepts/permissions"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalConceptsPermissionsQueryDtoBody,
    }, options);
};
/**
 * GET: Provides concept permissions
 * @summary customers/{customerId}/concepts/{conceptCode}/permission
 */
export var getCustomerConceptPermission = function (client, customerId, conceptCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/concepts/").concat(conceptCode, "/permission"), method: 'get', headers: headers }, options);
};
export var getGetCustomerConceptPermissionKey = function (customerId, conceptCode) {
    return ["/customers/".concat(customerId, "/concepts/").concat(conceptCode, "/permission")];
};
/**
 * @summary customers/{customerId}/concepts/{conceptCode}/permission
 */
export var useGetCustomerConceptPermission = function (customerId, conceptCode, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && conceptCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerConceptPermissionKey(customerId, conceptCode) : null); });
    var swrFn = function () {
        return getCustomerConceptPermission(customInstance, customerId, conceptCode, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Returns products permissions
 * @summary products/permissions
 */
export var getProductsPermissions = function (client, globalProductsPermissionsQueryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/products/permissions",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalProductsPermissionsQueryDtoBody,
    }, options);
};
/**
 * GET: Provides product permissions
 * @summary products/{productCode}/permission
 */
export var getProductPermission = function (client, productCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/products/".concat(productCode, "/permission"), method: 'get', headers: headers }, options);
};
export var getGetProductPermissionKey = function (productCode) {
    return ["/products/".concat(productCode, "/permission")];
};
/**
 * @summary products/{productCode}/permission
 */
export var useGetProductPermission = function (productCode, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!productCode;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetProductPermissionKey(productCode) : null); });
    var swrFn = function () {
        return getProductPermission(customInstance, productCode, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides product permissions
 * @summary customers/{customerId}/products/{productCode}/permission
 */
export var getCustomerProductPermission = function (client, customerId, productCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/products/").concat(productCode, "/permission"), method: 'get', headers: headers }, options);
};
export var getGetCustomerProductPermissionKey = function (customerId, productCode) {
    return ["/customers/".concat(customerId, "/products/").concat(productCode, "/permission")];
};
/**
 * @summary customers/{customerId}/products/{productCode}/permission
 */
export var useGetCustomerProductPermission = function (customerId, productCode, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && productCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerProductPermissionKey(customerId, productCode) : null); });
    var swrFn = function () {
        return getCustomerProductPermission(customInstance, customerId, productCode, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Returns products permissions
 * @summary customers/{customerId}/products/permissions
 */
export var getCustomerProductsPermissions = function (client, customerId, globalProductsPermissionsQueryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/products/permissions"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalProductsPermissionsQueryDtoBody,
    }, options);
};
/**
 * Provides permissions for customer
 * @summary customer/{customerId}/roles/permissions
 */
export var getCustomerRolesPermissions = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customer/".concat(customerId, "/roles/permissions"), method: 'get', headers: headers }, options);
};
export var getGetCustomerRolesPermissionsKey = function (customerId) {
    return ["/customer/".concat(customerId, "/roles/permissions")];
};
/**
 * @summary customer/{customerId}/roles/permissions
 */
export var useGetCustomerRolesPermissions = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerRolesPermissionsKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerRolesPermissions(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Personal Beauty Store information
 * @summary customers/{customerId}/personalBeautyStore
 */
export var getCustomerPersonalBeautyStore = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/personalBeautyStore"), method: 'get', headers: headers }, options);
};
export var getGetCustomerPersonalBeautyStoreKey = function (customerId) {
    return ["/customers/".concat(customerId, "/personalBeautyStore")];
};
/**
 * @summary customers/{customerId}/personalBeautyStore
 */
export var useGetCustomerPersonalBeautyStore = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerPersonalBeautyStoreKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerPersonalBeautyStore(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Create Personal Beauty Store
 * @summary customers/{customerId}/personalBeautyStore
 */
export var createCustomerPersonalBeautyStore = function (client, customerId, globalCustomersPersonalBeautyStoreDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/personalBeautyStore"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersPersonalBeautyStoreDtoBody,
    }, options);
};
/**
 * PUT: Modify Personal Beauty Store
 * @summary customers/{customerId}/personalBeautyStore
 */
export var updateCustomerPersonalBeautyStore = function (client, customerId, globalCustomersPersonalBeautyStoreDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/personalBeautyStore"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersPersonalBeautyStoreDtoBody,
    }, options);
};
/**
 * GET: Checks if is allowed to create Personal Beauty Store
 * @summary customers/{customerId}/personalBeautyStore/metadata
 */
export var getCustomerPersonalBeautyStoreMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/personalBeautyStore/metadata"), method: 'get', headers: headers }, options);
};
export var getGetCustomerPersonalBeautyStoreMetadataKey = function (customerId) {
    return ["/customers/".concat(customerId, "/personalBeautyStore/metadata")];
};
/**
 * @summary customers/{customerId}/personalBeautyStore/metadata
 */
export var useGetCustomerPersonalBeautyStoreMetadata = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerPersonalBeautyStoreMetadataKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerPersonalBeautyStoreMetadata(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets PBS profile for the customer with given customer id
 * @summary customers/{customerId}/personalBeautyStore/profile
 */
export var getCustomerPersonalBeautyStoreProfile = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/personalBeautyStore/profile"), method: 'get', headers: headers }, options);
};
export var getGetCustomerPersonalBeautyStoreProfileKey = function (customerId) {
    return ["/customers/".concat(customerId, "/personalBeautyStore/profile")];
};
/**
 * @summary customers/{customerId}/personalBeautyStore/profile
 */
export var useGetCustomerPersonalBeautyStoreProfile = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerPersonalBeautyStoreProfileKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerPersonalBeautyStoreProfile(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets PBS store of customer's sponsor.
 * @summary customers/{customerId}/SponsorPersonalBeautyStore
 */
export var getCustomerSponsorPersonalBeautyStore = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/SponsorPersonalBeautyStore"), method: 'get', headers: headers }, options);
};
export var getGetCustomerSponsorPersonalBeautyStoreKey = function (customerId) {
    return ["/customers/".concat(customerId, "/SponsorPersonalBeautyStore")];
};
/**
 * @summary customers/{customerId}/SponsorPersonalBeautyStore
 */
export var useGetCustomerSponsorPersonalBeautyStore = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerSponsorPersonalBeautyStoreKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerSponsorPersonalBeautyStore(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides personal beauty store link
 * @summary customers/{customerId}/personalBeautyStore/dynamiclink
 */
export var getCustomerPersonalBeautyStoreDynamiclink = function (client, customerId, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/personalBeautyStore/dynamiclink"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCustomerPersonalBeautyStoreDynamiclinkKey = function (customerId, params) {
    return __spreadArray([
        "/customers/".concat(customerId, "/personalBeautyStore/dynamiclink")
    ], (params ? [params] : []), true);
};
/**
 * @summary customers/{customerId}/personalBeautyStore/dynamiclink
 */
export var useGetCustomerPersonalBeautyStoreDynamiclink = function (customerId, headers, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetCustomerPersonalBeautyStoreDynamiclinkKey(customerId, params) : null;
    });
    var swrFn = function () {
        return getCustomerPersonalBeautyStoreDynamiclink(customInstance, customerId, headers, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get Personal Beauty Store configuration
 * @summary personalBeautyStoreConfiguration
 */
export var getPersonalBeautyStoreConfiguration = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/personalBeautyStoreConfiguration", method: 'get', headers: headers }, options);
};
export var getGetPersonalBeautyStoreConfigurationKey = function () {
    return ["/personalBeautyStoreConfiguration"];
};
/**
 * @summary personalBeautyStoreConfiguration
 */
export var useGetPersonalBeautyStoreConfiguration = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPersonalBeautyStoreConfigurationKey() : null); });
    var swrFn = function () {
        return getPersonalBeautyStoreConfiguration(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get Personal Beauty Store details
 * @summary personalBeautyStores/{name}
 */
export var getPersonalBeautyStore = function (client, name, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/personalBeautyStores/".concat(name), method: 'get', headers: headers }, options);
};
export var getGetPersonalBeautyStoreKey = function (name) {
    return ["/personalBeautyStores/".concat(name)];
};
/**
 * @summary personalBeautyStores/{name}
 */
export var useGetPersonalBeautyStore = function (name, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!name;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPersonalBeautyStoreKey(name) : null); });
    var swrFn = function () {
        return getPersonalBeautyStore(customInstance, name, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns information about personal details of registration with given ID
 * @summary customerRegistrations/{registrationId}/personalDetails
 */
export var getCustomerRegistrationPersonalDetails = function (client, registrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customerRegistrations/".concat(registrationId, "/personalDetails"), method: 'get', headers: headers }, options);
};
export var getGetCustomerRegistrationPersonalDetailsKey = function (registrationId) {
    return ["/customerRegistrations/".concat(registrationId, "/personalDetails")];
};
/**
 * @summary customerRegistrations/{registrationId}/personalDetails
 */
export var useGetCustomerRegistrationPersonalDetails = function (registrationId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!registrationId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerRegistrationPersonalDetailsKey(registrationId) : null); });
    var swrFn = function () {
        return getCustomerRegistrationPersonalDetails(customInstance, registrationId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Modifies information about personal details of registration with given ID
 * @summary customerRegistrations/{registrationId}/personalDetails
 */
export var updateCustomerRegistrationPersonalDetails = function (client, registrationId, globalCustomerRegistrationsRegistrationPersonalDetailsDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customerRegistrations/".concat(registrationId, "/personalDetails"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomerRegistrationsRegistrationPersonalDetailsDto,
    }, options);
};
/**
 * GET: Returns documents for personal document
 * @summary customers/{customerId}/personalDocument
 */
export var getCustomerPersonalDocument = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/personalDocument"), method: 'get', headers: headers }, options);
};
export var getGetCustomerPersonalDocumentKey = function (customerId) {
    return ["/customers/".concat(customerId, "/personalDocument")];
};
/**
 * @summary customers/{customerId}/personalDocument
 */
export var useGetCustomerPersonalDocument = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerPersonalDocumentKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerPersonalDocument(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Change documents for personal document (temporary document are submitted and will no longer be deleted)
 * @summary customers/{customerId}/personalDocument
 */
export var updateCustomerPersonalDocument = function (client, customerId, globalCustomersCustomerDocumentsDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/personalDocument"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersCustomerDocumentsDto,
    }, options);
};
/**
 * Gets OriSales menu items which will be merged with Online ones in personal menu application.
 * @summary applications/personalMenu/orisalesMenu
 */
export var getApplicationsPersonalMenuOrisalesMenu = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/personalMenu/orisalesMenu", method: 'get', headers: headers }, options);
};
export var getGetApplicationsPersonalMenuOrisalesMenuKey = function () {
    return ["/applications/personalMenu/orisalesMenu"];
};
/**
 * @summary applications/personalMenu/orisalesMenu
 */
export var useGetApplicationsPersonalMenuOrisalesMenu = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsPersonalMenuOrisalesMenuKey() : null); });
    var swrFn = function () {
        return getApplicationsPersonalMenuOrisalesMenu(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Purchase personal nutrition pack
 * @summary shoppingSessions/{sessionId}/personalNutrition
 */
export var updateShoppingSessionPersonalNutrition = function (client, sessionId, globalShoppingPersonalNutritionComponentsDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/personalNutrition"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingPersonalNutritionComponentsDto,
    }, options);
};
/**
 * GET: Get personal performance kpis
 * @summary customers/{customerId}/personalPerformance
 */
export var getCustomerPersonalPerformance = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/personalPerformance"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerPersonalPerformanceKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/personalPerformance")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/personalPerformance
 */
export var useGetCustomerPersonalPerformance = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerPersonalPerformanceKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerPersonalPerformance(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the localization.
 * @summary applications/personalProductsList/localization
 */
export var getApplicationsPersonalProductsListLocalization = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/personalProductsList/localization", method: 'get', headers: headers }, options);
};
export var getGetApplicationsPersonalProductsListLocalizationKey = function () {
    return ["/applications/personalProductsList/localization"];
};
/**
 * @summary applications/personalProductsList/localization
 */
export var useGetApplicationsPersonalProductsListLocalization = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsPersonalProductsListLocalizationKey() : null); });
    var swrFn = function () {
        return getApplicationsPersonalProductsListLocalization(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the configuration.
 * @summary applications/personalProductsList/configuration
 */
export var getApplicationsPersonalProductsListConfiguration = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/personalProductsList/configuration", method: 'get', headers: headers }, options);
};
export var getGetApplicationsPersonalProductsListConfigurationKey = function () {
    return ["/applications/personalProductsList/configuration"];
};
/**
 * @summary applications/personalProductsList/configuration
 */
export var useGetApplicationsPersonalProductsListConfiguration = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsPersonalProductsListConfigurationKey() : null); });
    var swrFn = function () {
        return getApplicationsPersonalProductsListConfiguration(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get personal subscription
 * @summary personalSubscriptions/{personalSubscriptionId}
 */
export var getPersonalSubscription = function (client, personalSubscriptionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/personalSubscriptions/".concat(personalSubscriptionId), method: 'get', headers: headers }, options);
};
export var getGetPersonalSubscriptionKey = function (personalSubscriptionId) {
    return ["/personalSubscriptions/".concat(personalSubscriptionId)];
};
/**
 * @summary personalSubscriptions/{personalSubscriptionId}
 */
export var useGetPersonalSubscription = function (personalSubscriptionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!personalSubscriptionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPersonalSubscriptionKey(personalSubscriptionId) : null); });
    var swrFn = function () {
        return getPersonalSubscription(customInstance, personalSubscriptionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Update personal subscription
 * @summary personalSubscriptions/{personalSubscriptionId}
 */
export var updatePersonalSubscription = function (client, personalSubscriptionId, globalCustomersPersonalSubscriptionDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/personalSubscriptions/".concat(personalSubscriptionId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersPersonalSubscriptionDto,
    }, options);
};
/**
 * DELETE: Cancel personal subscription
 * @summary personalSubscriptions/{personalSubscriptionId}
 */
export var deletePersonalSubscription = function (client, personalSubscriptionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/personalSubscriptions/".concat(personalSubscriptionId), method: 'delete', headers: headers }, options);
};
/**
 * PUT: Update plan for personal subscription update
 * @summary personalSubscriptions/{personalSubscriptionId}/plan
 */
export var updatePersonalSubscriptionPlan = function (client, personalSubscriptionId, globalCustomersPersonalSubscriptionPlanDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/personalSubscriptions/".concat(personalSubscriptionId, "/plan"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersPersonalSubscriptionPlanDto,
    }, options);
};
/**
 * GET: Provide plan for personal subscription update
 * @summary personalSubscriptions/{personalSubscriptionId}/plan
 */
export var getPersonalSubscriptionPlan = function (client, personalSubscriptionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/personalSubscriptions/".concat(personalSubscriptionId, "/plan"), method: 'get', headers: headers }, options);
};
export var getGetPersonalSubscriptionPlanKey = function (personalSubscriptionId) {
    return ["/personalSubscriptions/".concat(personalSubscriptionId, "/plan")];
};
/**
 * @summary personalSubscriptions/{personalSubscriptionId}/plan
 */
export var useGetPersonalSubscriptionPlan = function (personalSubscriptionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!personalSubscriptionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPersonalSubscriptionPlanKey(personalSubscriptionId) : null); });
    var swrFn = function () {
        return getPersonalSubscriptionPlan(customInstance, personalSubscriptionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Create shopping session with subscribed products
 * @summary personalSubscriptions/{personalSubscriptionId}/shoppingSession
 */
export var createPersonalSubscriptionShoppingSession = function (client, personalSubscriptionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/personalSubscriptions/".concat(personalSubscriptionId, "/shoppingSession"),
        method: 'post',
        headers: headers,
    }, options);
};
/**
 * POST: Subscribe product or personal nutrition set
 * @summary shoppingSessions/{sessionId}/personalSubscriptions
 */
export var createShoppingSessionPersonalSubscription = function (client, sessionId, globalShoppingPersonalSubscriptionDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/personalSubscriptions"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingPersonalSubscriptionDto,
    }, options);
};
/**
 * PUT: Ship together
 * @summary shoppingSessions/{sessionId}/personalSubscriptions
 */
export var updateShoppingSessionPersonalSubscriptions = function (client, sessionId, globalShoppingPersonalSubscriptionsDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/personalSubscriptions"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingPersonalSubscriptionsDto,
    }, options);
};
/**
 * GET: New, pending or dropped personal subscriptions
 * @summary shoppingSessions/{sessionId}/personalSubscriptions
 */
export var getShoppingSessionPersonalSubscriptions = function (client, sessionId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/personalSubscriptions"), method: 'get', headers: headers, params: params }, options);
};
export var getGetShoppingSessionPersonalSubscriptionsKey = function (sessionId, params) { return __spreadArray(["/shoppingSessions/".concat(sessionId, "/personalSubscriptions")], (params ? [params] : []), true); };
/**
 * @summary shoppingSessions/{sessionId}/personalSubscriptions
 */
export var useGetShoppingSessionPersonalSubscriptions = function (sessionId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionPersonalSubscriptionsKey(sessionId, params) : null); });
    var swrFn = function () {
        return getShoppingSessionPersonalSubscriptions(customInstance, sessionId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Query personal subscriptions
 * @summary personalSubscriptions
 */
export var getPersonalSubscriptions = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/personalSubscriptions", method: 'get', headers: headers, params: params }, options);
};
export var getGetPersonalSubscriptionsKey = function (params) {
    return __spreadArray(["/personalSubscriptions"], (params ? [params] : []), true);
};
/**
 * @summary personalSubscriptions
 */
export var useGetPersonalSubscriptions = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPersonalSubscriptionsKey(params) : null); });
    var swrFn = function () {
        return getPersonalSubscriptions(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Modify personal subscriptions
 * @summary personalSubscriptions
 */
export var updatePersonalSubscriptions = function (client, globalCustomersPersonalSubscriptionsDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/personalSubscriptions",
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersPersonalSubscriptionsDto,
    }, options);
};
/**
 * GET: Gets the telephones of customer with given customer id
 * @summary customers/{customerId}/phones
 */
export var getCustomerPhones = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/phones"), method: 'get', headers: headers }, options);
};
export var getGetCustomerPhonesKey = function (customerId) {
    return ["/customers/".concat(customerId, "/phones")];
};
/**
 * @summary customers/{customerId}/phones
 */
export var useGetCustomerPhones = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerPhonesKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerPhones(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Creates a telephone for given customer id
 * @summary customers/{customerId}/phones
 */
export var createCustomerPhone = function (client, customerId, globalCustomersPhoneDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/phones"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersPhoneDtoBody,
    }, options);
};
/**
 * PUT: Updates the telephone with given telephone id
 * @summary customers/{customerId}/phones/{telephoneId}
 */
export var updateCustomerPhone = function (client, customerId, telephoneId, globalCustomersPhoneDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/phones/").concat(telephoneId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersPhoneDtoBody,
    }, options);
};
/**
 * DELETE: Deletes a telephone with given telephone id
 * @summary customers/{customerId}/phones/{telephoneId}
 */
export var deleteCustomerPhone = function (client, customerId, telephoneId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/phones/").concat(telephoneId), method: 'delete', headers: headers }, options);
};
/**
 * GET: Gets metadata information for phone endpoints of the customer with given customer id
 * @summary customers/{customerId}/phonesMetadata
 */
export var getCustomerPhonesMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/phonesMetadata"), method: 'get', headers: headers }, options);
};
export var getGetCustomerPhonesMetadataKey = function (customerId) {
    return ["/customers/".concat(customerId, "/phonesMetadata")];
};
/**
 * @summary customers/{customerId}/phonesMetadata
 */
export var useGetCustomerPhonesMetadata = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerPhonesMetadataKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerPhonesMetadata(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets the status of verification process for given telephone id and customer id
 * @summary customers/{customerId}/phones/{telephoneId}/verificationRequest
 */
export var getCustomerPhoneVerificationRequest = function (client, customerId, telephoneId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/phones/").concat(telephoneId, "/verificationRequest"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetCustomerPhoneVerificationRequestKey = function (customerId, telephoneId) { return ["/customers/".concat(customerId, "/phones/").concat(telephoneId, "/verificationRequest")]; };
/**
 * @summary customers/{customerId}/phones/{telephoneId}/verificationRequest
 */
export var useGetCustomerPhoneVerificationRequest = function (customerId, telephoneId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && telephoneId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerPhoneVerificationRequestKey(customerId, telephoneId) : null); });
    var swrFn = function () {
        return getCustomerPhoneVerificationRequest(customInstance, customerId, telephoneId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Requests resending verification code for customer with a given telephone id and customer id
 * @summary customers/{customerId}/phones/{telephoneId}/verificationRequest
 */
export var updateCustomerPhoneVerificationRequest = function (client, customerId, telephoneId, globalCustomersTelephoneVerificationRequestDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/phones/").concat(telephoneId, "/verificationRequest"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersTelephoneVerificationRequestDto,
    }, options);
};
/**
 * GET: Returns preferences
 * @summary customers/{customerId}/preferences
 */
export var getCustomerPreferences = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/preferences"), method: 'get', headers: headers }, options);
};
export var getGetCustomerPreferencesKey = function (customerId) {
    return ["/customers/".concat(customerId, "/preferences")];
};
/**
 * @summary customers/{customerId}/preferences
 */
export var useGetCustomerPreferences = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerPreferencesKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerPreferences(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Change preferences values
 * @summary customers/{customerId}/preferences
 */
export var updateCustomerPreferences = function (client, customerId, globalCustomersCustomerPreferencesDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/preferences"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersCustomerPreferencesDto,
    }, options);
};
/**
 * GET: Returns metadata for preferences
 * @summary customers/{customerId}/preferencesMetadata
 */
export var getCustomerPreferencesMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/preferencesMetadata"), method: 'get', headers: headers }, options);
};
export var getGetCustomerPreferencesMetadataKey = function (customerId) {
    return ["/customers/".concat(customerId, "/preferencesMetadata")];
};
/**
 * @summary customers/{customerId}/preferencesMetadata
 */
export var useGetCustomerPreferencesMetadata = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerPreferencesMetadataKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerPreferencesMetadata(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns prerequisites for checkout process
 * @summary customers/{customerId}/checkoutPrerequisites
 */
export var getCustomerCheckoutPrerequisites = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/checkoutPrerequisites"), method: 'get', headers: headers }, options);
};
export var getGetCustomerCheckoutPrerequisitesKey = function (customerId) {
    return ["/customers/".concat(customerId, "/checkoutPrerequisites")];
};
/**
 * @summary customers/{customerId}/checkoutPrerequisites
 */
export var useGetCustomerCheckoutPrerequisites = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerCheckoutPrerequisitesKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerCheckoutPrerequisites(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Provides information about concept price
 * @summary concepts/prices
 */
export var getConceptsPrices = function (client, globalConceptsConceptPricesQueryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/concepts/prices",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalConceptsConceptPricesQueryDtoBody,
    }, options);
};
/**
 * GET: Provides information about concept price
 * @summary concepts/{conceptCode}/price
 */
export var getConceptPrice = function (client, conceptCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/concepts/".concat(conceptCode, "/price"), method: 'get', headers: headers }, options);
};
export var getGetConceptPriceKey = function (conceptCode) {
    return ["/concepts/".concat(conceptCode, "/price")];
};
/**
 * @summary concepts/{conceptCode}/price
 */
export var useGetConceptPrice = function (conceptCode, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!conceptCode;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetConceptPriceKey(conceptCode) : null); });
    var swrFn = function () {
        return getConceptPrice(customInstance, conceptCode, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Provides information about concept price
 * @summary customers/{customerId}/concepts/prices
 */
export var getCustomerConceptsPrices = function (client, customerId, globalConceptsConceptPricesQueryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/concepts/prices"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalConceptsConceptPricesQueryDtoBody,
    }, options);
};
/**
 * GET: Provides information about concept price
 * @summary customers/{customerId}/concepts/{conceptCode}/price
 */
export var getCustomerConceptPrice = function (client, customerId, conceptCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/concepts/").concat(conceptCode, "/price"), method: 'get', headers: headers }, options);
};
export var getGetCustomerConceptPriceKey = function (customerId, conceptCode) {
    return ["/customers/".concat(customerId, "/concepts/").concat(conceptCode, "/price")];
};
/**
 * @summary customers/{customerId}/concepts/{conceptCode}/price
 */
export var useGetCustomerConceptPrice = function (customerId, conceptCode, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && conceptCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerConceptPriceKey(customerId, conceptCode) : null); });
    var swrFn = function () {
        return getCustomerConceptPrice(customInstance, customerId, conceptCode, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Provides information about product price
 * @summary products/prices
 */
export var getProductsPrices = function (client, globalProductsProductPricesQueryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/products/prices",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalProductsProductPricesQueryDtoBody,
    }, options);
};
/**
 * GET: Provides information about product price
 * @summary customers/{customerId}/products/{productCode}/price
 */
export var getCustomerProductPrice = function (client, customerId, productCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/products/").concat(productCode, "/price"), method: 'get', headers: headers }, options);
};
export var getGetCustomerProductPriceKey = function (customerId, productCode) {
    return ["/customers/".concat(customerId, "/products/").concat(productCode, "/price")];
};
/**
 * @summary customers/{customerId}/products/{productCode}/price
 */
export var useGetCustomerProductPrice = function (customerId, productCode, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && productCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerProductPriceKey(customerId, productCode) : null); });
    var swrFn = function () {
        return getCustomerProductPrice(customInstance, customerId, productCode, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Provides information about product price
 * @summary customers/{customerId}/products/prices
 */
export var getCustomerProductsPrices = function (client, customerId, globalProductsProductPricesQueryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/products/prices"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalProductsProductPricesQueryDtoBody,
    }, options);
};
/**
 * Gets single product bundle by product code
 * @summary productBundles/{productCode}
 */
export var getProductBundle = function (client, productCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/productBundles/".concat(productCode), method: 'get', headers: headers }, options);
};
export var getGetProductBundleKey = function (productCode) {
    return ["/productBundles/".concat(productCode)];
};
/**
 * @summary productBundles/{productCode}
 */
export var useGetProductBundle = function (productCode, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!productCode;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetProductBundleKey(productCode) : null); });
    var swrFn = function () {
        return getProductBundle(customInstance, productCode, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets collection of product bundles
 * @summary productBundles
 */
export var getProductBundles = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/productBundles", method: 'get', headers: headers, params: params }, options);
};
export var getGetProductBundlesKey = function (params) {
    return __spreadArray(["/productBundles"], (params ? [params] : []), true);
};
/**
 * @summary productBundles
 */
export var useGetProductBundles = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetProductBundlesKey(params) : null); });
    var swrFn = function () {
        return getProductBundles(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides collection of Product Labels' contents.
 * @summary productLabelsContent
 */
export var getProductLabelsContent = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/productLabelsContent", method: 'get', headers: headers }, options);
};
export var getGetProductLabelsContentKey = function () { return ["/productLabelsContent"]; };
/**
 * @summary productLabelsContent
 */
export var useGetProductLabelsContent = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetProductLabelsContentKey() : null); });
    var swrFn = function () {
        return getProductLabelsContent(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get product list specified by productListId.
 * @summary productListTypes/{productListType}/productLists/{productListId}
 */
export var getProductListTypeProductList = function (client, productListType, productListId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/productListTypes/".concat(productListType, "/productLists/").concat(productListId),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetProductListTypeProductListKey = function (productListType, productListId) { return ["/productListTypes/".concat(productListType, "/productLists/").concat(productListId)]; };
/**
 * @summary productListTypes/{productListType}/productLists/{productListId}
 */
export var useGetProductListTypeProductList = function (productListType, productListId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(productListType && productListId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetProductListTypeProductListKey(productListType, productListId) : null;
    });
    var swrFn = function () {
        return getProductListTypeProductList(customInstance, productListType, productListId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets all product lists for specified customer of specified productListType.
 * @summary customers/{customerId}/productListTypes/{productListType}/productLists
 */
export var getCustomerProductListTypeProductLists = function (client, customerId, productListType, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/productListTypes/").concat(productListType, "/productLists"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetCustomerProductListTypeProductListsKey = function (customerId, productListType) { return ["/customers/".concat(customerId, "/productListTypes/").concat(productListType, "/productLists")]; };
/**
 * @summary customers/{customerId}/productListTypes/{productListType}/productLists
 */
export var useGetCustomerProductListTypeProductLists = function (customerId, productListType, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && productListType);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetCustomerProductListTypeProductListsKey(customerId, productListType) : null;
    });
    var swrFn = function () {
        return getCustomerProductListTypeProductLists(customInstance, customerId, productListType, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Creates new product list for specified customer of provided productListType.
 * @summary customers/{customerId}/productListTypes/{productListType}/productLists
 */
export var createCustomerProductListTypeProductList = function (client, customerId, productListType, globalSharedProductListDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/productListTypes/").concat(productListType, "/productLists"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalSharedProductListDtoBody,
    }, options);
};
/**
 * Gets one product list of type productListType specified by productListId.
 * @summary customers/{customerId}/productListTypes/{productListType}/productLists/{productListId}
 */
export var getCustomerProductListTypeProductList = function (client, customerId, productListType, productListId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/productListTypes/").concat(productListType, "/productLists/").concat(productListId),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetCustomerProductListTypeProductListKey = function (customerId, productListType, productListId) {
    return [
        "/customers/".concat(customerId, "/productListTypes/").concat(productListType, "/productLists/").concat(productListId),
    ];
};
/**
 * @summary customers/{customerId}/productListTypes/{productListType}/productLists/{productListId}
 */
export var useGetCustomerProductListTypeProductList = function (customerId, productListType, productListId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && productListType && productListId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetCustomerProductListTypeProductListKey(customerId, productListType, productListId)
            : null;
    });
    var swrFn = function () {
        return getCustomerProductListTypeProductList(customInstance, customerId, productListType, productListId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Updates  product list of type productListType specified by productListId.
 * @summary customers/{customerId}/productListTypes/{productListType}/productLists/{productListId}
 */
export var updateCustomerProductListTypeProductList = function (client, customerId, productListType, productListId, globalSharedProductListDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/productListTypes/").concat(productListType, "/productLists/").concat(productListId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalSharedProductListDtoBody,
    }, options);
};
/**
 * Delete product list of type productListType specified by productListId.
 * @summary customers/{customerId}/productListTypes/{productListType}/productLists/{productListId}
 */
export var deleteCustomerProductListTypeProductList = function (client, customerId, productListType, productListId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/productListTypes/").concat(productListType, "/productLists/").concat(productListId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Deletes product item of specified code from product list.
 * @summary customers/{customerId}/ProductListTypes/{productListType}/ProductLists/{productListId}/Items/{itemCode}
 */
export var deleteCustomerProductListTypeProductListItem = function (client, customerId, productListType, productListId, itemCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/ProductListTypes/").concat(productListType, "/ProductLists/").concat(productListId, "/Items/").concat(itemCode),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Add one item of specified item code to product list.
 * @summary customers/{customerId}/ProductListTypes/{productListType}/ProductLists/{productListId}/Items
 */
export var createCustomerProductListTypeProductListItem = function (client, customerId, productListType, productListId, globalSharedProductListItemDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/ProductListTypes/").concat(productListType, "/ProductLists/").concat(productListId, "/Items"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalSharedProductListItemDto,
    }, options);
};
/**
 * Provides personal product list link.
 * @summary customers/{customerId}/productListTypes/{productListType}/productLists/{productListId}/dynamiclink
 */
export var getCustomerProductListTypeProductListDynamiclink = function (client, customerId, productListId, headers, params, productListType, options) {
    if (productListType === void 0) { productListType = 'Personal'; }
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/productListTypes/").concat(productListType, "/productLists/").concat(productListId, "/dynamiclink"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCustomerProductListTypeProductListDynamiclinkKey = function (customerId, productListId, params, productListType) {
    if (productListType === void 0) { productListType = 'Personal'; }
    return __spreadArray([
        "/customers/".concat(customerId, "/productListTypes/").concat(productListType, "/productLists/").concat(productListId, "/dynamiclink")
    ], (params ? [params] : []), true);
};
/**
 * @summary customers/{customerId}/productListTypes/{productListType}/productLists/{productListId}/dynamiclink
 */
export var useGetCustomerProductListTypeProductListDynamiclink = function (customerId, productListId, headers, params, productListType, options) {
    var _a;
    if (productListType === void 0) { productListType = 'Personal'; }
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && productListType && productListId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetCustomerProductListTypeProductListDynamiclinkKey(customerId, productListId, params, productListType)
            : null;
    });
    var swrFn = function () {
        return getCustomerProductListTypeProductListDynamiclink(customInstance, customerId, productListId, headers, params, productListType, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get product listing specified by productListingPageId
 * @summary applications/productListing/listings
 */
export var getApplicationsProductListingListings = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/productListing/listings", method: 'get', headers: headers, params: params }, options);
};
export var getGetApplicationsProductListingListingsKey = function (params) { return __spreadArray(["/applications/productListing/listings"], (params ? [params] : []), true); };
/**
 * @summary applications/productListing/listings
 */
export var useGetApplicationsProductListingListings = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsProductListingListingsKey(params) : null); });
    var swrFn = function () {
        return getApplicationsProductListingListings(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides collection of Product Listing Promo Banners
 * @summary applications/productListing/promoBanners
 */
export var getApplicationsProductListingPromoBanners = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/productListing/promoBanners", method: 'get', headers: headers, params: params }, options);
};
export var getGetApplicationsProductListingPromoBannersKey = function (params) { return __spreadArray(["/applications/productListing/promoBanners"], (params ? [params] : []), true); };
/**
 * @summary applications/productListing/promoBanners
 */
export var useGetApplicationsProductListingPromoBanners = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsProductListingPromoBannersKey(params) : null); });
    var swrFn = function () {
        return getApplicationsProductListingPromoBanners(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets product search results by the specified query or a product filter filterParams.
 * @summary searchProducts
 */
export var getSearchProducts = function (client, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/searchProducts", method: 'get', headers: headers, params: params }, options);
};
export var getGetSearchProductsKey = function (params) {
    return __spreadArray(["/searchProducts"], (params ? [params] : []), true);
};
/**
 * @summary searchProducts
 */
export var useGetSearchProducts = function (headers, params, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetSearchProductsKey(params) : null); });
    var swrFn = function () {
        return getSearchProducts(customInstance, headers, params, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Provides products
 * @summary products
 */
export var getProducts = function (client, globalProductsQueryDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/products",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalProductsQueryDto,
    }, options);
};
/**
 * GET: Provides product
 * @summary products/{productCode}
 */
export var getProduct = function (client, productCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/products/".concat(productCode), method: 'get', headers: headers }, options);
};
export var getGetProductKey = function (productCode) { return ["/products/".concat(productCode)]; };
/**
 * @summary products/{productCode}
 */
export var useGetProduct = function (productCode, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!productCode;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetProductKey(productCode) : null); });
    var swrFn = function () {
        return getProduct(customInstance, productCode, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the products expected inbounds
 * @summary productsExpectedInbounds
 */
export var getProductsExpectedInbounds = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/productsExpectedInbounds", method: 'get', headers: headers, params: params }, options);
};
export var getGetProductsExpectedInboundsKey = function (params) {
    return __spreadArray(["/productsExpectedInbounds"], (params ? [params] : []), true);
};
/**
 * @summary productsExpectedInbounds
 */
export var useGetProductsExpectedInbounds = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetProductsExpectedInboundsKey(params) : null); });
    var swrFn = function () {
        return getProductsExpectedInbounds(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the products ingredients
 * @summary productsIngredients
 */
export var getProductsIngredients = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/productsIngredients", method: 'get', headers: headers, params: params }, options);
};
export var getGetProductsIngredientsKey = function (params) {
    return __spreadArray(["/productsIngredients"], (params ? [params] : []), true);
};
/**
 * @summary productsIngredients
 */
export var useGetProductsIngredients = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetProductsIngredientsKey(params) : null); });
    var swrFn = function () {
        return getProductsIngredients(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets collection of product labels for anonymous customer.
 * @summary productsLabels
 */
export var getProductsLabels = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/productsLabels", method: 'get', headers: headers, params: params }, options);
};
export var getGetProductsLabelsKey = function (params) {
    return __spreadArray(["/productsLabels"], (params ? [params] : []), true);
};
/**
 * @summary productsLabels
 */
export var useGetProductsLabels = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetProductsLabelsKey(params) : null); });
    var swrFn = function () {
        return getProductsLabels(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets products replacements for specific customer.
 * @summary customers/{customerId}/productsReplacements
 */
export var getCustomerProductsReplacements = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/productsReplacements"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerProductsReplacementsKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/productsReplacements")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/productsReplacements
 */
export var useGetCustomerProductsReplacements = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerProductsReplacementsKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerProductsReplacements(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Collection of products by search criteria
 * @summary applications/shoppingBag/products
 */
export var getApplicationsShoppingBagProducts = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/shoppingBag/products", method: 'get', headers: headers, params: params }, options);
};
export var getGetApplicationsShoppingBagProductsKey = function (params) { return __spreadArray(["/applications/shoppingBag/products"], (params ? [params] : []), true); };
/**
 * @summary applications/shoppingBag/products
 */
export var useGetApplicationsShoppingBagProducts = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsShoppingBagProductsKey(params) : null); });
    var swrFn = function () {
        return getApplicationsShoppingBagProducts(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets the customer profile of the customer with given customer id
 * @summary customers/{customerId}/profile
 */
export var getCustomerProfile = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/profile"), method: 'get', headers: headers }, options);
};
export var getGetCustomerProfileKey = function (customerId) {
    return ["/customers/".concat(customerId, "/profile")];
};
/**
 * @summary customers/{customerId}/profile
 */
export var useGetCustomerProfile = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerProfileKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerProfile(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Updates the customer profile of the customer with given customer id
 * @summary customers/{customerId}/profile
 */
export var updateCustomerProfile = function (client, customerId, globalCustomersProfileDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/profile"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersProfileDto,
    }, options);
};
/**
 * GET: Gets metadata information for profile endpoints of the customer with given customer id
 * @summary customers/{customerId}/profileMetadata
 */
export var getCustomerProfileMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/profileMetadata"), method: 'get', headers: headers }, options);
};
export var getGetCustomerProfileMetadataKey = function (customerId) {
    return ["/customers/".concat(customerId, "/profileMetadata")];
};
/**
 * @summary customers/{customerId}/profileMetadata
 */
export var useGetCustomerProfileMetadata = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerProfileMetadataKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerProfileMetadata(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets information about completeness of user's profile
 * @summary customers/{customerId}/profileCompleteness
 */
export var getCustomerProfileCompleteness = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/profileCompleteness"), method: 'get', headers: headers }, options);
};
export var getGetCustomerProfileCompletenessKey = function (customerId) {
    return ["/customers/".concat(customerId, "/profileCompleteness")];
};
/**
 * @summary customers/{customerId}/profileCompleteness
 */
export var useGetCustomerProfileCompleteness = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerProfileCompletenessKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerProfileCompleteness(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets configuration for user's profile completeness
 * @summary customers/{customerId}/profileCompletenessMetadata
 */
export var getCustomerProfileCompletenessMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/profileCompletenessMetadata"), method: 'get', headers: headers }, options);
};
export var getGetCustomerProfileCompletenessMetadataKey = function (customerId) {
    return ["/customers/".concat(customerId, "/profileCompletenessMetadata")];
};
/**
 * @summary customers/{customerId}/profileCompletenessMetadata
 */
export var useGetCustomerProfileCompletenessMetadata = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerProfileCompletenessMetadataKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerProfileCompletenessMetadata(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Configuration for profile sections for customer
 * @summary customers/{customerId}/applications/profile/configurations/sections
 */
export var getCustomerApplicationsProfileConfigurationsSections = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/applications/profile/configurations/sections"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetCustomerApplicationsProfileConfigurationsSectionsKey = function (customerId) {
    return ["/customers/".concat(customerId, "/applications/profile/configurations/sections")];
};
/**
 * @summary customers/{customerId}/applications/profile/configurations/sections
 */
export var useGetCustomerApplicationsProfileConfigurationsSections = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetCustomerApplicationsProfileConfigurationsSectionsKey(customerId) : null;
    });
    var swrFn = function () {
        return getCustomerApplicationsProfileConfigurationsSections(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns information about all profile approvals for customer
 * @summary customers/{customerId}/profileApproval
 */
export var getCustomerProfileApproval = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/profileApproval"), method: 'get', headers: headers }, options);
};
export var getGetCustomerProfileApprovalKey = function (customerId) {
    return ["/customers/".concat(customerId, "/profileApproval")];
};
/**
 * @summary customers/{customerId}/profileApproval
 */
export var useGetCustomerProfileApproval = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerProfileApprovalKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerProfileApproval(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns document for profile image
 * @summary customers/{customerId}/profileImage
 */
export var getCustomerProfileImage = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/profileImage"), method: 'get', headers: headers }, options);
};
export var getGetCustomerProfileImageKey = function (customerId) {
    return ["/customers/".concat(customerId, "/profileImage")];
};
/**
 * @summary customers/{customerId}/profileImage
 */
export var useGetCustomerProfileImage = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerProfileImageKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerProfileImage(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Change documents for profile image (temporary document are submitted and will no longer be deleted)
 * @summary customers/{customerId}/profileImage
 */
export var updateCustomerProfileImage = function (client, customerId, globalCustomersProfileImageDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/profileImage"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersProfileImageDto,
    }, options);
};
/**
 * GET: Returns profile image of given customer
 * @summary customers/{customerId}/profileImages/{documentId}
 */
export var getCustomerProfileImageDocument = function (client, customerId, documentId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/profileImages/").concat(documentId), method: 'get', headers: headers }, options);
};
export var getGetCustomerProfileImageDocumentKey = function (customerId, documentId) {
    return ["/customers/".concat(customerId, "/profileImages/").concat(documentId)];
};
/**
 * @summary customers/{customerId}/profileImages/{documentId}
 */
export var useGetCustomerProfileImageDocument = function (customerId, documentId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && documentId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerProfileImageDocumentKey(customerId, documentId) : null); });
    var swrFn = function () {
        return getCustomerProfileImageDocument(customInstance, customerId, documentId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns metadata for profile image
 * @summary customers/{customerId}/profileImageMetadata
 */
export var getCustomerProfileImageMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/profileImageMetadata"), method: 'get', headers: headers }, options);
};
export var getGetCustomerProfileImageMetadataKey = function (customerId) {
    return ["/customers/".concat(customerId, "/profileImageMetadata")];
};
/**
 * @summary customers/{customerId}/profileImageMetadata
 */
export var useGetCustomerProfileImageMetadata = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerProfileImageMetadataKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerProfileImageMetadata(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provide a specific promotion
 * @summary promotions/{promotionId}
 */
export var getPromotion = function (client, promotionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/promotions/".concat(promotionId), method: 'get', headers: headers }, options);
};
export var getGetPromotionKey = function (promotionId) { return ["/promotions/".concat(promotionId)]; };
/**
 * @summary promotions/{promotionId}
 */
export var useGetPromotion = function (promotionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!promotionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPromotionKey(promotionId) : null); });
    var swrFn = function () {
        return getPromotion(customInstance, promotionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets best offers banners
 * @summary promotionBestOffersBanners
 */
export var getPromotionBestOffersBanners = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/promotionBestOffersBanners", method: 'get', headers: headers, params: params }, options);
};
export var getGetPromotionBestOffersBannersKey = function (params) {
    return __spreadArray(["/promotionBestOffersBanners"], (params ? [params] : []), true);
};
/**
 * @summary promotionBestOffersBanners
 */
export var useGetPromotionBestOffersBanners = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPromotionBestOffersBannersKey(params) : null); });
    var swrFn = function () {
        return getPromotionBestOffersBanners(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets whats new type banners
 * @summary promotionWhatsNewBanners
 */
export var getPromotionWhatsNewBanners = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/promotionWhatsNewBanners", method: 'get', headers: headers, params: params }, options);
};
export var getGetPromotionWhatsNewBannersKey = function (params) {
    return __spreadArray(["/promotionWhatsNewBanners"], (params ? [params] : []), true);
};
/**
 * @summary promotionWhatsNewBanners
 */
export var useGetPromotionWhatsNewBanners = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPromotionWhatsNewBannersKey(params) : null); });
    var swrFn = function () {
        return getPromotionWhatsNewBanners(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets hero banners
 * @summary promotionHeroBanners
 */
export var getPromotionHeroBanners = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/promotionHeroBanners", method: 'get', headers: headers, params: params }, options);
};
export var getGetPromotionHeroBannersKey = function (params) {
    return __spreadArray(["/promotionHeroBanners"], (params ? [params] : []), true);
};
/**
 * @summary promotionHeroBanners
 */
export var useGetPromotionHeroBanners = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPromotionHeroBannersKey(params) : null); });
    var swrFn = function () {
        return getPromotionHeroBanners(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets campaign banners
 * @summary promotionCampaignBanners
 */
export var getPromotionCampaignBanners = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/promotionCampaignBanners", method: 'get', headers: headers, params: params }, options);
};
export var getGetPromotionCampaignBannersKey = function (params) {
    return __spreadArray(["/promotionCampaignBanners"], (params ? [params] : []), true);
};
/**
 * @summary promotionCampaignBanners
 */
export var useGetPromotionCampaignBanners = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPromotionCampaignBannersKey(params) : null); });
    var swrFn = function () {
        return getPromotionCampaignBanners(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets category banners
 * @summary promotionCategoryBanners
 */
export var getPromotionCategoryBanners = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/promotionCategoryBanners", method: 'get', headers: headers, params: params }, options);
};
export var getGetPromotionCategoryBannersKey = function (params) {
    return __spreadArray(["/promotionCategoryBanners"], (params ? [params] : []), true);
};
/**
 * @summary promotionCategoryBanners
 */
export var useGetPromotionCategoryBanners = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPromotionCategoryBannersKey(params) : null); });
    var swrFn = function () {
        return getPromotionCategoryBanners(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets current promotions
 * @summary digitalPromotions
 */
export var getDigitalPromotions = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/digitalPromotions", method: 'get', headers: headers, params: params }, options);
};
export var getGetDigitalPromotionsKey = function (params) {
    return __spreadArray(["/digitalPromotions"], (params ? [params] : []), true);
};
/**
 * @summary digitalPromotions
 */
export var useGetDigitalPromotions = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetDigitalPromotionsKey(params) : null); });
    var swrFn = function () {
        return getDigitalPromotions(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provide all valid promotions
 * @summary promotions
 */
export var getPromotions = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/promotions", method: 'get', headers: headers }, options);
};
export var getGetPromotionsKey = function () { return ["/promotions"]; };
/**
 * @summary promotions
 */
export var useGetPromotions = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetPromotionsKey() : null); });
    var swrFn = function () { return getPromotions(customInstance, headers, requestOptions).then(function (d) { return d.data; }); };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Creates or updates push notification installation for anonymous customer
 * @summary pushNotifications/installations
 */
export var createPushNotificationsInstallation = function (client, globalNotificationsInstallationRequestDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/pushNotifications/installations",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalNotificationsInstallationRequestDtoBody,
    }, options);
};
/**
 * Creates or updates push notification installation for logged in customer
 * @summary customers/{customerId}/pushNotifications/installations
 */
export var createCustomerPushNotificationsInstallation = function (client, customerId, globalNotificationsInstallationRequestDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/pushNotifications/installations"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalNotificationsInstallationRequestDtoBody,
    }, options);
};
/**
 * Deletes installation
 * @summary customers/{customerId}/pushNotifications/installations/{installationId}
 */
export var deleteCustomerPushNotificationsInstallation = function (client, customerId, installationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/pushNotifications/installations/").concat(installationId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Create or update device registration in Push notification center to possible to deliver the push notification to this device.
            
Deprecated for Cumulus Markets: Please use route /pushNotifications/installations or /customers/{customerId}/pushNotifications/installations instead
 * @summary pushNotifications/registrations
 */
export var createPushNotificationsRegistration = function (client, globalNotificationsPushRegistrationDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/pushNotifications/registrations",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalNotificationsPushRegistrationDto,
    }, options);
};
/**
 * Unregister device from application by registration ID
            
Deprecated for Cumulus Markets
 * @summary pushNotifications/applications/{applicationKey}/registrationId/{registrationId}
 */
export var deletePushNotificationsApplicationRegistrationId = function (client, applicationKey, registrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/pushNotifications/applications/".concat(applicationKey, "/registrationId/").concat(registrationId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Unregister device from application by device token
            
Deprecated for Cumulus Markets
 * @summary pushNotifications/applications/{applicationKey}/deviceToken/{deviceToken}
 */
export var deletePushNotificationsApplicationDeviceToken = function (client, applicationKey, deviceToken, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/pushNotifications/applications/".concat(applicationKey, "/deviceToken/").concat(deviceToken),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Localization for RealTime Order Tracking application
 * @summary applications/realTimeOrderTracking/localization
 */
export var getApplicationsRealTimeOrderTrackingLocalization = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/realTimeOrderTracking/localization", method: 'get', headers: headers }, options);
};
export var getGetApplicationsRealTimeOrderTrackingLocalizationKey = function () {
    return ["/applications/realTimeOrderTracking/localization"];
};
/**
 * @summary applications/realTimeOrderTracking/localization
 */
export var useGetApplicationsRealTimeOrderTrackingLocalization = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsRealTimeOrderTrackingLocalizationKey() : null); });
    var swrFn = function () {
        return getApplicationsRealTimeOrderTrackingLocalization(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get stored payment cards
 * @summary customers/{customerId}/recurringPaymentCards
 */
export var getCustomerRecurringPaymentCards = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/recurringPaymentCards"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerRecurringPaymentCardsKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/recurringPaymentCards")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/recurringPaymentCards
 */
export var useGetCustomerRecurringPaymentCards = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerRecurringPaymentCardsKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerRecurringPaymentCards(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Delete stored payment card
 * @summary customers/{customerId}/recurringPaymentCards/{recurringPaymentCardId}
 */
export var deleteCustomerRecurringPaymentCard = function (client, customerId, recurringPaymentCardId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/recurringPaymentCards/").concat(recurringPaymentCardId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Gets metadata information for recurring payment card endpoints of the customer with given customer id
 * @summary customers/{customerId}/recurringPaymentCardsMetadata
 */
export var getCustomerRecurringPaymentCardsMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/recurringPaymentCardsMetadata"), method: 'get', headers: headers }, options);
};
export var getGetCustomerRecurringPaymentCardsMetadataKey = function (customerId) {
    return ["/customers/".concat(customerId, "/recurringPaymentCardsMetadata")];
};
/**
 * @summary customers/{customerId}/recurringPaymentCardsMetadata
 */
export var useGetCustomerRecurringPaymentCardsMetadata = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerRecurringPaymentCardsMetadataKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerRecurringPaymentCardsMetadata(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provide assigned referral
 * @summary shoppingSessions/{sessionId}/referral
 */
export var getShoppingSessionReferral = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/referral"), method: 'get', headers: headers }, options);
};
export var getGetShoppingSessionReferralKey = function (sessionId) {
    return ["/shoppingSessions/".concat(sessionId, "/referral")];
};
/**
 * @summary shoppingSessions/{sessionId}/referral
 */
export var useGetShoppingSessionReferral = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionReferralKey(sessionId) : null); });
    var swrFn = function () {
        return getShoppingSessionReferral(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Assign referral invitation
 * @summary shoppingSessions/{sessionId}/referral
 */
export var createShoppingSessionReferral = function (client, sessionId, globalShoppingReferralDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/referral"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingReferralDto,
    }, options);
};
/**
 * POST: Performs consultant registration done by sponsor, SPO or customer service
 * @summary customers/{customerId}/consultants
 */
export var createCustomerConsultant = function (client, customerId, globalCustomersConsultantRegistrationDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/consultants"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersConsultantRegistrationDto,
    }, options);
};
/**
 * POST: Performs self registration for consultant
 * @summary consultants
 */
export var createConsultant = function (client, globalCustomersSelfRegistrationDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/consultants",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersSelfRegistrationDto,
    }, options);
};
/**
 * Return metadata for registration done by sponsor
 * @summary customers/{customerId}/consultantsMetadata
 */
export var getCustomerConsultantsMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/consultantsMetadata"), method: 'get', headers: headers }, options);
};
export var getGetCustomerConsultantsMetadataKey = function (customerId) {
    return ["/customers/".concat(customerId, "/consultantsMetadata")];
};
/**
 * @summary customers/{customerId}/consultantsMetadata
 */
export var useGetCustomerConsultantsMetadata = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerConsultantsMetadataKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerConsultantsMetadata(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Return metadata for registration done by sponsor
 * @summary consultantsMetadata
 */
export var getConsultantsMetadata = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/consultantsMetadata", method: 'get', headers: headers }, options);
};
export var getGetConsultantsMetadataKey = function () { return ["/consultantsMetadata"]; };
/**
 * @summary consultantsMetadata
 */
export var useGetConsultantsMetadata = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetConsultantsMetadataKey() : null); });
    var swrFn = function () {
        return getConsultantsMetadata(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns customer's registration info
 * @summary customers/{customerId}/registrationInfo
 */
export var getCustomerRegistrationInfo = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/registrationInfo"), method: 'get', headers: headers }, options);
};
export var getGetCustomerRegistrationInfoKey = function (customerId) {
    return ["/customers/".concat(customerId, "/registrationInfo")];
};
/**
 * @summary customers/{customerId}/registrationInfo
 */
export var useGetCustomerRegistrationInfo = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerRegistrationInfoKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerRegistrationInfo(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns information about registration order for given customer
 * @summary customers/{customerId}/registrationOrder
 */
export var getCustomerRegistrationOrder = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/registrationOrder"), method: 'get', headers: headers }, options);
};
export var getGetCustomerRegistrationOrderKey = function (customerId) {
    return ["/customers/".concat(customerId, "/registrationOrder")];
};
/**
 * @summary customers/{customerId}/registrationOrder
 */
export var useGetCustomerRegistrationOrder = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerRegistrationOrderKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerRegistrationOrder(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Creates order returns its ID
 * @summary customers/{customerId}/registrationOrder
 */
export var createCustomerRegistrationOrder = function (client, customerId, globalCustomersRegistrationOrderDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/registrationOrder"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersRegistrationOrderDto,
    }, options);
};
/**
 * GET: Returns information about registration with given ID
 * @summary customerRegistrations/{registrationId}
 */
export var getCustomerRegistration = function (client, registrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customerRegistrations/".concat(registrationId), method: 'get', headers: headers }, options);
};
export var getGetCustomerRegistrationKey = function (registrationId) {
    return ["/customerRegistrations/".concat(registrationId)];
};
/**
 * @summary customerRegistrations/{registrationId}
 */
export var useGetCustomerRegistration = function (registrationId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!registrationId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerRegistrationKey(registrationId) : null); });
    var swrFn = function () {
        return getCustomerRegistration(customInstance, registrationId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Updates a registration
 * @summary customerRegistrations/{registrationId}
 */
export var updateCustomerRegistration = function (client, registrationId, globalCustomerRegistrationsRegistrationDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customerRegistrations/".concat(registrationId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomerRegistrationsRegistrationDtoBody,
    }, options);
};
/**
 * GET: Returns information about registration with given customer ID
 * @summary customerRegistrations/customers/{customerId}
 */
export var getCustomerRegistrationsCustomer = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customerRegistrations/customers/".concat(customerId), method: 'get', headers: headers }, options);
};
export var getGetCustomerRegistrationsCustomerKey = function (customerId) {
    return ["/customerRegistrations/customers/".concat(customerId)];
};
/**
 * @summary customerRegistrations/customers/{customerId}
 */
export var useGetCustomerRegistrationsCustomer = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerRegistrationsCustomerKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerRegistrationsCustomer(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Creates a registration and returns its ID
 * @summary customerRegistrations
 */
export var createCustomerRegistration = function (client, globalCustomerRegistrationsRegistrationDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customerRegistrations",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomerRegistrationsRegistrationDtoBody,
    }, options);
};
/**
 * GET: Returns information about current registration status
 * @summary customers/{customerId}/registrationStatus
 */
export var getCustomerRegistrationStatus = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/registrationStatus"), method: 'get', headers: headers }, options);
};
export var getGetCustomerRegistrationStatusKey = function (customerId) {
    return ["/customers/".concat(customerId, "/registrationStatus")];
};
/**
 * @summary customers/{customerId}/registrationStatus
 */
export var useGetCustomerRegistrationStatus = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerRegistrationStatusKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerRegistrationStatus(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - Provides related product codes and relation types.
 * @summary products/{productCode}/relations
 */
export var getProductRelations = function (client, productCode, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/products/".concat(productCode, "/relations"), method: 'get', headers: headers, params: params }, options);
};
export var getGetProductRelationsKey = function (productCode, params) { return __spreadArray(["/products/".concat(productCode, "/relations")], (params ? [params] : []), true); };
/**
 * @summary products/{productCode}/relations
 */
export var useGetProductRelations = function (productCode, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!productCode;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetProductRelationsKey(productCode, params) : null); });
    var swrFn = function () {
        return getProductRelations(customInstance, productCode, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: returns settings for request validation (reCaptcha)
 * @summary requestValidationMetadata
 */
export var getRequestValidationMetadata = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/requestValidationMetadata", method: 'get', headers: headers, params: params }, options);
};
export var getGetRequestValidationMetadataKey = function (params) {
    return __spreadArray(["/requestValidationMetadata"], (params ? [params] : []), true);
};
/**
 * @summary requestValidationMetadata
 */
export var useGetRequestValidationMetadata = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetRequestValidationMetadataKey(params) : null); });
    var swrFn = function () {
        return getRequestValidationMetadata(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns terms info and html content
 * @summary requiredTerms
 */
export var getRequiredTerms = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/requiredTerms", method: 'get', headers: headers, params: params }, options);
};
export var getGetRequiredTermsKey = function (params) {
    return __spreadArray(["/requiredTerms"], (params ? [params] : []), true);
};
/**
 * @summary requiredTerms
 */
export var useGetRequiredTerms = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetRequiredTermsKey(params) : null); });
    var swrFn = function () {
        return getRequiredTerms(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Creates new revolut account bound to provided IBAN
 * @summary revolutProfiles
 */
export var createRevolutProfile = function (client, globalFinanceRevolutProfileDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/revolutProfiles",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalFinanceRevolutProfileDto,
    }, options);
};
/**
 * GET: Get shopping bag sales
 * @summary shoppingSessions/{sessionId}/sales
 */
export var getShoppingSessionSales = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/sales"), method: 'get', headers: headers }, options);
};
export var getGetShoppingSessionSalesKey = function (sessionId) {
    return ["/shoppingSessions/".concat(sessionId, "/sales")];
};
/**
 * @summary shoppingSessions/{sessionId}/sales
 */
export var useGetShoppingSessionSales = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionSalesKey(sessionId) : null); });
    var swrFn = function () {
        return getShoppingSessionSales(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * @summary salesmanagoClientData
 */
export var getSalesmanagoClientData = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/salesmanagoClientData", method: 'get', headers: headers }, options);
};
export var getGetSalesmanagoClientDataKey = function () { return ["/salesmanagoClientData"]; };
/**
 * @summary salesmanagoClientData
 */
export var useGetSalesmanagoClientData = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetSalesmanagoClientDataKey() : null); });
    var swrFn = function () {
        return getSalesmanagoClientData(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get evaluated section items
 * @summary shoppingSessions/{sessionId}/sections/{sectionId}/sectionItems
 */
export var getShoppingSessionSectionSectionItems = function (client, sessionId, sectionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/sections/").concat(sectionId, "/sectionItems"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetShoppingSessionSectionSectionItemsKey = function (sessionId, sectionId) {
    return ["/shoppingSessions/".concat(sessionId, "/sections/").concat(sectionId, "/sectionItems")];
};
/**
 * @summary shoppingSessions/{sessionId}/sections/{sectionId}/sectionItems
 */
export var useGetShoppingSessionSectionSectionItems = function (sessionId, sectionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(sessionId && sectionId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionSectionSectionItemsKey(sessionId, sectionId) : null); });
    var swrFn = function () {
        return getShoppingSessionSectionSectionItems(customInstance, sessionId, sectionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get list of shopping sections evaluated for current shopping bag
 * @summary shoppingSessions/{sessionId}/sections
 */
export var getShoppingSessionSections = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/sections"), method: 'get', headers: headers }, options);
};
export var getGetShoppingSessionSectionsKey = function (sessionId) {
    return ["/shoppingSessions/".concat(sessionId, "/sections")];
};
/**
 * @summary shoppingSessions/{sessionId}/sections
 */
export var useGetShoppingSessionSections = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionSectionsKey(sessionId) : null); });
    var swrFn = function () {
        return getShoppingSessionSections(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provide suggested product codes (max. 10 results is provided)
 * @summary shoppingSessions/{sessionId}/sectionSuggestions
 */
export var getShoppingSessionSectionSuggestions = function (client, sessionId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/sectionSuggestions"), method: 'get', headers: headers, params: params }, options);
};
export var getGetShoppingSessionSectionSuggestionsKey = function (sessionId, params) { return __spreadArray(["/shoppingSessions/".concat(sessionId, "/sectionSuggestions")], (params ? [params] : []), true); };
/**
 * @summary shoppingSessions/{sessionId}/sectionSuggestions
 */
export var useGetShoppingSessionSectionSuggestions = function (sessionId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionSectionSuggestionsKey(sessionId, params) : null); });
    var swrFn = function () {
        return getShoppingSessionSectionSuggestions(customInstance, sessionId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get product wish-list of the section
 * @summary shoppingSessions/{sessionId}/sections/{sectionId}/wishlist
 */
export var getShoppingSessionSectionWishlistItems = function (client, sessionId, sectionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/sections/").concat(sectionId, "/wishlist"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetShoppingSessionSectionWishlistItemsKey = function (sessionId, sectionId) { return ["/shoppingSessions/".concat(sessionId, "/sections/").concat(sectionId, "/wishlist")]; };
/**
 * @summary shoppingSessions/{sessionId}/sections/{sectionId}/wishlist
 */
export var useGetShoppingSessionSectionWishlistItems = function (sessionId, sectionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(sessionId && sectionId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionSectionWishlistItemsKey(sessionId, sectionId) : null); });
    var swrFn = function () {
        return getShoppingSessionSectionWishlistItems(customInstance, sessionId, sectionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * DELETE: Remove all products from section wish-list
 * @summary shoppingSessions/{sessionId}/sections/{sectionId}/wishlist
 */
export var deleteShoppingSessionSectionWishlistItems = function (client, sessionId, sectionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/sections/").concat(sectionId, "/wishlist"),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * POST: Add product to section wish-list
 * @summary shoppingSessions/{sessionId}/sections/{sectionId}/wishlist
 */
export var createShoppingSessionSectionWishlist = function (client, sessionId, sectionId, globalShoppingSectionWishlistItemDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/sections/").concat(sectionId, "/wishlist"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingSectionWishlistItemDtoBody,
    }, options);
};
/**
 * GET: Get wish-list item by product code
 * @summary shoppingSessions/{sessionId}/sections/{sectionId}/wishlist/{itemCode}
 */
export var getShoppingSessionSectionWishlist = function (client, sessionId, sectionId, itemCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/sections/").concat(sectionId, "/wishlist/").concat(itemCode),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetShoppingSessionSectionWishlistKey = function (sessionId, sectionId, itemCode) { return ["/shoppingSessions/".concat(sessionId, "/sections/").concat(sectionId, "/wishlist/").concat(itemCode)]; };
/**
 * @summary shoppingSessions/{sessionId}/sections/{sectionId}/wishlist/{itemCode}
 */
export var useGetShoppingSessionSectionWishlist = function (sessionId, sectionId, itemCode, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(sessionId && sectionId && itemCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetShoppingSessionSectionWishlistKey(sessionId, sectionId, itemCode) : null;
    });
    var swrFn = function () {
        return getShoppingSessionSectionWishlist(customInstance, sessionId, sectionId, itemCode, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Update product quantity in section wish-list
 * @summary shoppingSessions/{sessionId}/sections/{sectionId}/wishlist/{itemCode}
 */
export var updateShoppingSessionSectionWishlist = function (client, sessionId, sectionId, itemCode, globalShoppingSectionWishlistItemDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/sections/").concat(sectionId, "/wishlist/").concat(itemCode),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingSectionWishlistItemDtoBody,
    }, options);
};
/**
 * DELETE: Remove product from section wish-list
 * @summary shoppingSessions/{sessionId}/sections/{sectionId}/wishlist/{itemCode}
 */
export var deleteShoppingSessionSectionWishlist = function (client, sessionId, sectionId, itemCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/sections/").concat(sectionId, "/wishlist/").concat(itemCode),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Gets available facets for each category to use in search filters.
 * @summary settings/facets
 */
export var getSettingsFacets = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/settings/facets", method: 'get', headers: headers }, options);
};
export var getGetSettingsFacetsKey = function () { return ["/settings/facets"]; };
/**
 * @summary settings/facets
 */
export var useGetSettingsFacets = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetSettingsFacetsKey() : null); });
    var swrFn = function () {
        return getSettingsFacets(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Update Share and earn personal code
 * @summary applications/shareAndEarn/customer/{customerId}/personalCode
 */
export var updateApplicationsShareAndEarnCustomerPersonalCode = function (client, customerId, globalApplicationsShareAndEarnUpdatePersonalCodeRequestDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/shareAndEarn/customer/".concat(customerId, "/personalCode"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalApplicationsShareAndEarnUpdatePersonalCodeRequestDto,
    }, options);
};
/**
 * GET: Get selected free shipping product
 * @summary shoppingSessions/{sessionId}/shippingJokerChoice
 */
export var getShoppingSessionShippingJokerChoice = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/shippingJokerChoice"), method: 'get', headers: headers }, options);
};
export var getGetShoppingSessionShippingJokerChoiceKey = function (sessionId) {
    return ["/shoppingSessions/".concat(sessionId, "/shippingJokerChoice")];
};
/**
 * @summary shoppingSessions/{sessionId}/shippingJokerChoice
 */
export var useGetShoppingSessionShippingJokerChoice = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionShippingJokerChoiceKey(sessionId) : null); });
    var swrFn = function () {
        return getShoppingSessionShippingJokerChoice(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * DELETE: Reset free shipping selection
 * @summary shoppingSessions/{sessionId}/shippingJokerChoice
 */
export var deleteShoppingSessionShippingJokerChoice = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/shippingJokerChoice"), method: 'delete', headers: headers }, options);
};
/**
 * POST: Apply free shipping product
 * @summary shoppingSessions/{sessionId}/shippingJokerChoice
 */
export var createShoppingSessionShippingJokerChoice = function (client, sessionId, globalShoppingShippingChoiceDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/shippingJokerChoice"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingShippingChoiceDto,
    }, options);
};
/**
 * GET: Get selected free shipping products
 * @summary shoppingSessions/{sessionId}/shippingJokerChoices
 */
export var getShoppingSessionShippingJokerChoices = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/shippingJokerChoices"), method: 'get', headers: headers }, options);
};
export var getGetShoppingSessionShippingJokerChoicesKey = function (sessionId) {
    return ["/shoppingSessions/".concat(sessionId, "/shippingJokerChoices")];
};
/**
 * @summary shoppingSessions/{sessionId}/shippingJokerChoices
 */
export var useGetShoppingSessionShippingJokerChoices = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionShippingJokerChoicesKey(sessionId) : null); });
    var swrFn = function () {
        return getShoppingSessionShippingJokerChoices(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * DELETE: Reset free shipping selection
 * @summary shoppingSessions/{sessionId}/shippingJokerChoices
 */
export var deleteShoppingSessionShippingJokerChoices = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/shippingJokerChoices"), method: 'delete', headers: headers }, options);
};
/**
 * PUT: Apply free shipping products
 * @summary shoppingSessions/{sessionId}/shippingJokerChoices
 */
export var updateShoppingSessionShippingJokerChoices = function (client, sessionId, globalShoppingShippingChoicesDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/shippingJokerChoices"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingShippingChoicesDto,
    }, options);
};
/**
 * GET: Provides free shipping offers for selected or alternative delivery channel
 * @summary shoppingSessions/{sessionId}/shippingJokers
 */
export var getShoppingSessionShippingJokers = function (client, sessionId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/shippingJokers"), method: 'get', headers: headers, params: params }, options);
};
export var getGetShoppingSessionShippingJokersKey = function (sessionId, params) { return __spreadArray(["/shoppingSessions/".concat(sessionId, "/shippingJokers")], (params ? [params] : []), true); };
/**
 * @summary shoppingSessions/{sessionId}/shippingJokers
 */
export var useGetShoppingSessionShippingJokers = function (sessionId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionShippingJokersKey(sessionId, params) : null); });
    var swrFn = function () {
        return getShoppingSessionShippingJokers(customInstance, sessionId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Saves the shopping bag.
 * @summary shoppingSessions/{sessionId}/shoppingBag
 */
export var createShoppingSessionShoppingBag = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/shoppingBag"), method: 'post', headers: headers }, options);
};
/**
 * DELETE: Clears a shopping bag (added products, selected offers and all other user inputs).
 * @summary shoppingSessions/{sessionId}/shoppingBag
 */
export var deleteShoppingSessionShoppingBag = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/shoppingBag"), method: 'delete', headers: headers }, options);
};
/**
 * GET: Get list of aggregated shopping bag items.
 * @summary shoppingSessions/{sessionId}/shoppingBag/aggregatedItems
 */
export var getShoppingSessionShoppingBagAggregatedItems = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/shoppingBag/aggregatedItems"), method: 'get', headers: headers }, options);
};
export var getGetShoppingSessionShoppingBagAggregatedItemsKey = function (sessionId) {
    return ["/shoppingSessions/".concat(sessionId, "/shoppingBag/aggregatedItems")];
};
/**
 * @summary shoppingSessions/{sessionId}/shoppingBag/aggregatedItems
 */
export var useGetShoppingSessionShoppingBagAggregatedItems = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionShoppingBagAggregatedItemsKey(sessionId) : null); });
    var swrFn = function () {
        return getShoppingSessionShoppingBagAggregatedItems(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Update quantity of a shopping bag item.
 * @summary shoppingSessions/{sessionId}/shoppingBag/bagItems/{bagItemId}
 */
export var updateShoppingSessionShoppingBagBagItem = function (client, sessionId, bagItemId, globalShoppingShoppingBagItemDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/shoppingBag/bagItems/").concat(bagItemId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingShoppingBagItemDto,
    }, options);
};
/**
 * DELETE: Remove a shopping bag item.
 * @summary shoppingSessions/{sessionId}/shoppingBag/bagItems/{bagItemId}
 */
export var deleteShoppingSessionShoppingBagBagItem = function (client, sessionId, bagItemId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/shoppingBag/bagItems/").concat(bagItemId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Provide status of back-order demand.
 * @summary shoppingSessions/{sessionId}/shoppingBag/bagItems/{bagItemId}/backorder
 */
export var getShoppingSessionShoppingBagBagItemBackorder = function (client, sessionId, bagItemId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/shoppingBag/bagItems/").concat(bagItemId, "/backorder"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetShoppingSessionShoppingBagBagItemBackorderKey = function (sessionId, bagItemId) { return ["/shoppingSessions/".concat(sessionId, "/shoppingBag/bagItems/").concat(bagItemId, "/backorder")]; };
/**
 * @summary shoppingSessions/{sessionId}/shoppingBag/bagItems/{bagItemId}/backorder
 */
export var useGetShoppingSessionShoppingBagBagItemBackorder = function (sessionId, bagItemId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(sessionId && bagItemId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetShoppingSessionShoppingBagBagItemBackorderKey(sessionId, bagItemId) : null;
    });
    var swrFn = function () {
        return getShoppingSessionShoppingBagBagItemBackorder(customInstance, sessionId, bagItemId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Request to be out-of-stock product back-ordered.
 * @summary shoppingSessions/{sessionId}/shoppingBag/bagItems/{bagItemId}/backorder
 */
export var createShoppingSessionShoppingBagBagItemBackorder = function (client, sessionId, bagItemId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/shoppingBag/bagItems/").concat(bagItemId, "/backorder"),
        method: 'post',
        headers: headers,
    }, options);
};
/**
 * DELETE: Recall back-order demand.
 * @summary shoppingSessions/{sessionId}/shoppingBag/bagItems/{bagItemId}/backorder
 */
export var deleteShoppingSessionShoppingBagBagItemBackorder = function (client, sessionId, bagItemId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/shoppingBag/bagItems/").concat(bagItemId, "/backorder"),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Provide pending (not available) back-orders.
 * @summary shoppingSessions/{sessionId}/pendingBackorders
 */
export var getShoppingSessionPendingBackorders = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/pendingBackorders"), method: 'get', headers: headers }, options);
};
export var getGetShoppingSessionPendingBackordersKey = function (sessionId) {
    return ["/shoppingSessions/".concat(sessionId, "/pendingBackorders")];
};
/**
 * @summary shoppingSessions/{sessionId}/pendingBackorders
 */
export var useGetShoppingSessionPendingBackorders = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionPendingBackordersKey(sessionId) : null); });
    var swrFn = function () {
        return getShoppingSessionPendingBackorders(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Adds a new item to the shopping bag.
 * @summary shoppingSessions/{sessionId}/shoppingBag/bagItems
 */
export var createShoppingSessionShoppingBagBagItem = function (client, sessionId, globalShoppingShoppingBagItemDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/shoppingBag/bagItems"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingShoppingBagItemDto,
    }, options);
};
/**
 * PUT: Update shopping bag items (remove all current items and add specified items)
 * @summary shoppingSessions/{sessionId}/shoppingBag/bagItems
 */
export var updateShoppingSessionShoppingBagBagItems = function (client, sessionId, globalShoppingShoppingBagItemDtoArrayBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/shoppingBag/bagItems"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingShoppingBagItemDtoArrayBody,
    }, options);
};
/**
 * PUT: Update shopping bag items (remove all current items and add specified items)
Returns object with current shopping bag items and summary
 * @summary applications/wechatpbs/shoppingSessions/{sessionId}/shoppingBag/bagItems
 */
export var updateApplicationsWechatpbsShoppingSessionShoppingBagBagItems = function (client, sessionId, globalShoppingShoppingBagItemDtoArrayBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/wechatpbs/shoppingSessions/".concat(sessionId, "/shoppingBag/bagItems"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingShoppingBagItemDtoArrayBody,
    }, options);
};
/**
 * GET: Provides campaign points balance
 * @summary shoppingSessions/{sessionId}/campaigns/{campaignId}/points
 */
export var getShoppingSessionCampaignPoints = function (client, sessionId, campaignId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/campaigns/").concat(campaignId, "/points"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetShoppingSessionCampaignPointsKey = function (sessionId, campaignId) {
    return ["/shoppingSessions/".concat(sessionId, "/campaigns/").concat(campaignId, "/points")];
};
/**
 * @summary shoppingSessions/{sessionId}/campaigns/{campaignId}/points
 */
export var useGetShoppingSessionCampaignPoints = function (sessionId, campaignId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(sessionId && campaignId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionCampaignPointsKey(sessionId, campaignId) : null); });
    var swrFn = function () {
        return getShoppingSessionCampaignPoints(customInstance, sessionId, campaignId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get approved end-consumer orders
 * @summary shoppingSessions/{sessionId}/endConsumerOrders
 */
export var getShoppingSessionEndConsumerOrders = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/endConsumerOrders"), method: 'get', headers: headers }, options);
};
export var getGetShoppingSessionEndConsumerOrdersKey = function (sessionId) {
    return ["/shoppingSessions/".concat(sessionId, "/endConsumerOrders")];
};
/**
 * @summary shoppingSessions/{sessionId}/endConsumerOrders
 */
export var useGetShoppingSessionEndConsumerOrders = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionEndConsumerOrdersKey(sessionId) : null); });
    var swrFn = function () {
        return getShoppingSessionEndConsumerOrders(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * DELETE: Unapproved end-consumer order to prevent dropping to consultant's basket
 * @summary shoppingSessions/{sessionId}/endConsumerOrders/{endConsumerOrderId}
 */
export var deleteShoppingSessionEndConsumerOrder = function (client, sessionId, endConsumerOrderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/endConsumerOrders/").concat(endConsumerOrderId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Get items of end-consumer order
 * @summary shoppingSessions/{sessionId}/endConsumerOrders/{endConsumerOrderId}/items
 */
export var getShoppingSessionEndConsumerOrderItems = function (client, sessionId, endConsumerOrderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/endConsumerOrders/").concat(endConsumerOrderId, "/items"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetShoppingSessionEndConsumerOrderItemsKey = function (sessionId, endConsumerOrderId) { return ["/shoppingSessions/".concat(sessionId, "/endConsumerOrders/").concat(endConsumerOrderId, "/items")]; };
/**
 * @summary shoppingSessions/{sessionId}/endConsumerOrders/{endConsumerOrderId}/items
 */
export var useGetShoppingSessionEndConsumerOrderItems = function (sessionId, endConsumerOrderId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(sessionId && endConsumerOrderId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetShoppingSessionEndConsumerOrderItemsKey(sessionId, endConsumerOrderId)
            : null;
    });
    var swrFn = function () {
        return getShoppingSessionEndConsumerOrderItems(customInstance, sessionId, endConsumerOrderId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Modify number of purchased products in the end-consumer's order
 * @summary shoppingSessions/{sessionId}/endConsumerOrders/{endConsumerOrderId}/items/{itemCode}
 */
export var updateShoppingSessionEndConsumerOrderItem = function (client, sessionId, endConsumerOrderId, itemCode, globalShoppingEndConsumerOrderItemDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/endConsumerOrders/").concat(endConsumerOrderId, "/items/").concat(itemCode),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingEndConsumerOrderItemDto,
    }, options);
};
/**
 * DELETE: Delete product from end-consumer's order
 * @summary shoppingSessions/{sessionId}/endConsumerOrders/{endConsumerOrderId}/items/{itemCode}
 */
export var deleteShoppingSessionEndConsumerOrderItem = function (client, sessionId, endConsumerOrderId, itemCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/endConsumerOrders/").concat(endConsumerOrderId, "/items/").concat(itemCode),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Get list of shopping messages evaluated for current shopping bag
 * @summary shoppingSessions/{sessionId}/messages
 */
export var getShoppingSessionMessages = function (client, sessionId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/messages"), method: 'get', headers: headers, params: params }, options);
};
export var getGetShoppingSessionMessagesKey = function (sessionId, params) { return __spreadArray(["/shoppingSessions/".concat(sessionId, "/messages")], (params ? [params] : []), true); };
/**
 * @summary shoppingSessions/{sessionId}/messages
 */
export var useGetShoppingSessionMessages = function (sessionId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionMessagesKey(sessionId, params) : null); });
    var swrFn = function () {
        return getShoppingSessionMessages(customInstance, sessionId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Starts new shopping session. Session expires after defined time of inactivity.
 * @summary shoppingSessions
 */
export var createShoppingSession = function (client, globalShoppingShoppingDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingShoppingDto,
    }, options);
};
/**
 * GET: Gets shopping session data. Also refreshes the session, so it will not expire.
 * @summary shoppingSessions/{sessionId}
 */
export var getShoppingSession = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId), method: 'get', headers: headers }, options);
};
export var getGetShoppingSessionKey = function (sessionId) {
    return ["/shoppingSessions/".concat(sessionId)];
};
/**
 * @summary shoppingSessions/{sessionId}
 */
export var useGetShoppingSession = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionKey(sessionId) : null); });
    var swrFn = function () {
        return getShoppingSession(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * DELETE: Delete shopping session from Redis.
 * @summary shoppingSessions/{sessionId}
 */
export var deleteShoppingSession = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId), method: 'delete', headers: headers }, options);
};
/**
 * GET: Metadata for request validation functionality
 * @deprecated
 * @summary applications/simplifiedRegistration/requestValidation
 */
export var getApplicationsSimplifiedRegistrationRequestValidation = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/simplifiedRegistration/requestValidation", method: 'get', headers: headers }, options);
};
export var getGetApplicationsSimplifiedRegistrationRequestValidationKey = function () {
    return ["/applications/simplifiedRegistration/requestValidation"];
};
/**
 * @deprecated
 * @summary applications/simplifiedRegistration/requestValidation
 */
export var useGetApplicationsSimplifiedRegistrationRequestValidation = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsSimplifiedRegistrationRequestValidationKey() : null); });
    var swrFn = function () {
        return getApplicationsSimplifiedRegistrationRequestValidation(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Creates the visit to social media entity.
 * @deprecated
 * @summary applications/socialMediaLibrary/customers/{customerId}/socialEntities/{entityId}/visit
 */
export var createApplicationsSocialMediaLibraryCustomerSocialEntityVisit = function (client, customerId, entityId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/socialMediaLibrary/customers/".concat(customerId, "/socialEntities/").concat(entityId, "/visit"),
        method: 'post',
        headers: headers,
    }, options);
};
/**
 * Creates like of social media entity.
 * @deprecated
 * @summary applications/socialMediaLibrary/customers/{customerId}/socialEntities/{entityId}/like
 */
export var createApplicationsSocialMediaLibraryCustomerSocialEntityLike = function (client, customerId, entityId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/socialMediaLibrary/customers/".concat(customerId, "/socialEntities/").concat(entityId, "/like"),
        method: 'post',
        headers: headers,
    }, options);
};
/**
 * Delete like of social media entity.
 * @deprecated
 * @summary applications/socialMediaLibrary/customers/{customerId}/socialEntities/{entityId}/like
 */
export var deleteApplicationsSocialMediaLibraryCustomerSocialEntityLike = function (client, customerId, entityId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/socialMediaLibrary/customers/".concat(customerId, "/socialEntities/").concat(entityId, "/like"),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Gets all liked social entities of specified customer.
 * @deprecated
 * @summary applications/socialMediaLibrary/customers/{customerId}/SocialEntityLikes
 */
export var getApplicationsSocialMediaLibraryCustomerSocialEntityLikes = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/socialMediaLibrary/customers/".concat(customerId, "/SocialEntityLikes"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetApplicationsSocialMediaLibraryCustomerSocialEntityLikesKey = function (customerId) { return ["/applications/socialMediaLibrary/customers/".concat(customerId, "/SocialEntityLikes")]; };
/**
 * @deprecated
 * @summary applications/socialMediaLibrary/customers/{customerId}/SocialEntityLikes
 */
export var useGetApplicationsSocialMediaLibraryCustomerSocialEntityLikes = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetApplicationsSocialMediaLibraryCustomerSocialEntityLikesKey(customerId)
            : null;
    });
    var swrFn = function () {
        return getApplicationsSocialMediaLibraryCustomerSocialEntityLikes(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the social entities statistics.
 * @deprecated
 * @summary applications/socialMediaLibrary/stats
 */
export var getApplicationsSocialMediaLibraryStats = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/socialMediaLibrary/stats", method: 'get', headers: headers, params: params }, options);
};
export var getGetApplicationsSocialMediaLibraryStatsKey = function (params) { return __spreadArray(["/applications/socialMediaLibrary/stats"], (params ? [params] : []), true); };
/**
 * @deprecated
 * @summary applications/socialMediaLibrary/stats
 */
export var useGetApplicationsSocialMediaLibraryStats = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsSocialMediaLibraryStatsKey(params) : null); });
    var swrFn = function () {
        return getApplicationsSocialMediaLibraryStats(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get special offer evaluated by for current shopping bag
 * @summary shoppingSessions/{sessionId}/specialOffers/{offerId}
 */
export var getShoppingSessionSpecialOffer = function (client, sessionId, offerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/specialOffers/").concat(offerId), method: 'get', headers: headers }, options);
};
export var getGetShoppingSessionSpecialOfferKey = function (sessionId, offerId) {
    return ["/shoppingSessions/".concat(sessionId, "/specialOffers/").concat(offerId)];
};
/**
 * @summary shoppingSessions/{sessionId}/specialOffers/{offerId}
 */
export var useGetShoppingSessionSpecialOffer = function (sessionId, offerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(sessionId && offerId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionSpecialOfferKey(sessionId, offerId) : null); });
    var swrFn = function () {
        return getShoppingSessionSpecialOffer(customInstance, sessionId, offerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get offer choice preferences selected by customer
 * @summary shoppingSessions/{sessionId}/specialOffers/{offerId}/choice
 */
export var getShoppingSessionSpecialOfferChoice = function (client, sessionId, offerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/specialOffers/").concat(offerId, "/choice"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetShoppingSessionSpecialOfferChoiceKey = function (sessionId, offerId) {
    return ["/shoppingSessions/".concat(sessionId, "/specialOffers/").concat(offerId, "/choice")];
};
/**
 * @summary shoppingSessions/{sessionId}/specialOffers/{offerId}/choice
 */
export var useGetShoppingSessionSpecialOfferChoice = function (sessionId, offerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(sessionId && offerId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionSpecialOfferChoiceKey(sessionId, offerId) : null); });
    var swrFn = function () {
        return getShoppingSessionSpecialOfferChoice(customInstance, sessionId, offerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Select offer, backorder or replacement
 * @summary shoppingSessions/{sessionId}/specialOffers/{offerId}/choice
 */
export var updateShoppingSessionSpecialOfferChoice = function (client, sessionId, offerId, globalShoppingSpecialOfferChoiceDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/specialOffers/").concat(offerId, "/choice"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingSpecialOfferChoiceDto,
    }, options);
};
/**
 * DELETE: Reset offer choice selection
 * @summary shoppingSessions/{sessionId}/specialOffers/{offerId}/choice
 */
export var deleteShoppingSessionSpecialOfferChoice = function (client, sessionId, offerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/specialOffers/").concat(offerId, "/choice"),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Get alternative products for a special offer
 * @summary shoppingSessions/{sessionId}/specialOffers/{offerId}/replacements
 */
export var getShoppingSessionSpecialOfferReplacements = function (client, sessionId, offerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/specialOffers/").concat(offerId, "/replacements"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetShoppingSessionSpecialOfferReplacementsKey = function (sessionId, offerId) { return ["/shoppingSessions/".concat(sessionId, "/specialOffers/").concat(offerId, "/replacements")]; };
/**
 * @summary shoppingSessions/{sessionId}/specialOffers/{offerId}/replacements
 */
export var useGetShoppingSessionSpecialOfferReplacements = function (sessionId, offerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(sessionId && offerId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetShoppingSessionSpecialOfferReplacementsKey(sessionId, offerId) : null;
    });
    var swrFn = function () {
        return getShoppingSessionSpecialOfferReplacements(customInstance, sessionId, offerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get list of special offers evaluated for current shopping bag
 * @summary shoppingSessions/{sessionId}/specialOffers
 */
export var getShoppingSessionSpecialOffers = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/specialOffers"), method: 'get', headers: headers }, options);
};
export var getGetShoppingSessionSpecialOffersKey = function (sessionId) {
    return ["/shoppingSessions/".concat(sessionId, "/specialOffers")];
};
/**
 * @summary shoppingSessions/{sessionId}/specialOffers
 */
export var useGetShoppingSessionSpecialOffers = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionSpecialOffersKey(sessionId) : null); });
    var swrFn = function () {
        return getShoppingSessionSpecialOffers(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get offer voucher data and voucher items selected by customer
 * @summary shoppingSessions/{sessionId}/specialOffers/{offerId}/voucher
 */
export var getShoppingSessionSpecialOfferVoucher = function (client, sessionId, offerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/specialOffers/").concat(offerId, "/voucher"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetShoppingSessionSpecialOfferVoucherKey = function (sessionId, offerId) {
    return ["/shoppingSessions/".concat(sessionId, "/specialOffers/").concat(offerId, "/voucher")];
};
/**
 * @summary shoppingSessions/{sessionId}/specialOffers/{offerId}/voucher
 */
export var useGetShoppingSessionSpecialOfferVoucher = function (sessionId, offerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(sessionId && offerId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionSpecialOfferVoucherKey(sessionId, offerId) : null); });
    var swrFn = function () {
        return getShoppingSessionSpecialOfferVoucher(customInstance, sessionId, offerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * POST: Add offer voucher choice selected by customer
 * @summary shoppingSessions/{sessionId}/specialOffers/{offerId}/voucher/choices
 */
export var createShoppingSessionSpecialOfferVoucherChoice = function (client, sessionId, offerId, globalShoppingSpecialOfferVoucherChoiceDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/specialOffers/").concat(offerId, "/voucher/choices"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingSpecialOfferVoucherChoiceDto,
    }, options);
};
/**
 * DELETE: Remove offer voucher choice selected by customer
 * @summary shoppingSessions/{sessionId}/specialOffers/{offerId}/voucher/choices/{choiceId}
 */
export var deleteShoppingSessionSpecialOfferVoucherChoice = function (client, sessionId, offerId, choiceId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/specialOffers/").concat(offerId, "/voucher/choices/").concat(choiceId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Returns information about sponsor invite
 * @summary customers/{customerId}/sponsorChangeInvites
 */
export var getCustomerSponsorChangeInvites = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/sponsorChangeInvites"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerSponsorChangeInvitesKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/sponsorChangeInvites")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/sponsorChangeInvites
 */
export var useGetCustomerSponsorChangeInvites = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerSponsorChangeInvitesKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerSponsorChangeInvites(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Updates sponsor invite
 * @summary customers/{customerId}/sponsorChangeInvites
 */
export var updateCustomerSponsorChangeInvites = function (client, customerId, globalCustomersSponsorChangeInviteDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/sponsorChangeInvites"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersSponsorChangeInviteDto,
    }, options);
};
/**
 * GET: Returns information about inviting sponsor
 * @summary customers/{customerId}/sponsorChangeInvites/{sponsorChangeInviteId}/sponsorInfo
 */
export var getCustomerSponsorChangeInviteSponsorInfo = function (client, customerId, sponsorChangeInviteId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/sponsorChangeInvites/").concat(sponsorChangeInviteId, "/sponsorInfo"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetCustomerSponsorChangeInviteSponsorInfoKey = function (customerId, sponsorChangeInviteId) {
    return ["/customers/".concat(customerId, "/sponsorChangeInvites/").concat(sponsorChangeInviteId, "/sponsorInfo")];
};
/**
 * @summary customers/{customerId}/sponsorChangeInvites/{sponsorChangeInviteId}/sponsorInfo
 */
export var useGetCustomerSponsorChangeInviteSponsorInfo = function (customerId, sponsorChangeInviteId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && sponsorChangeInviteId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetCustomerSponsorChangeInviteSponsorInfoKey(customerId, sponsorChangeInviteId)
            : null;
    });
    var swrFn = function () {
        return getCustomerSponsorChangeInviteSponsorInfo(customInstance, customerId, sponsorChangeInviteId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns sponsor information of registration with given ID
 * @summary customerRegistrations/{registrationId}/sponsorDetails
 */
export var getCustomerRegistrationSponsorDetails = function (client, registrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customerRegistrations/".concat(registrationId, "/sponsorDetails"), method: 'get', headers: headers }, options);
};
export var getGetCustomerRegistrationSponsorDetailsKey = function (registrationId) {
    return ["/customerRegistrations/".concat(registrationId, "/sponsorDetails")];
};
/**
 * @summary customerRegistrations/{registrationId}/sponsorDetails
 */
export var useGetCustomerRegistrationSponsorDetails = function (registrationId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!registrationId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerRegistrationSponsorDetailsKey(registrationId) : null); });
    var swrFn = function () {
        return getCustomerRegistrationSponsorDetails(customInstance, registrationId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Modifies sponsor information of registration with given ID
 * @summary customerRegistrations/{registrationId}/sponsorDetails
 */
export var updateCustomerRegistrationSponsorDetails = function (client, registrationId, globalCustomerRegistrationsRegistrationSponsorDetailsDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customerRegistrations/".concat(registrationId, "/sponsorDetails"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomerRegistrationsRegistrationSponsorDetailsDto,
    }, options);
};
/**
 * GET: Returns information about the sponsor selected in the simplified registration process
 * @summary customerRegistrations/{registrationId}/sponsorDetails/sponsorInfo
 */
export var getCustomerRegistrationSponsorDetailsSponsorInfo = function (client, registrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customerRegistrations/".concat(registrationId, "/sponsorDetails/sponsorInfo"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetCustomerRegistrationSponsorDetailsSponsorInfoKey = function (registrationId) {
    return ["/customerRegistrations/".concat(registrationId, "/sponsorDetails/sponsorInfo")];
};
/**
 * @summary customerRegistrations/{registrationId}/sponsorDetails/sponsorInfo
 */
export var useGetCustomerRegistrationSponsorDetailsSponsorInfo = function (registrationId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!registrationId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetCustomerRegistrationSponsorDetailsSponsorInfoKey(registrationId) : null;
    });
    var swrFn = function () {
        return getCustomerRegistrationSponsorDetailsSponsorInfo(customInstance, registrationId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns profile image of selected sponsor
 * @summary customerRegistrations/{registrationId}/sponsorDetails/profileImage
 */
export var getCustomerRegistrationSponsorDetailsProfileImage = function (client, registrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customerRegistrations/".concat(registrationId, "/sponsorDetails/profileImage"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetCustomerRegistrationSponsorDetailsProfileImageKey = function (registrationId) {
    return ["/customerRegistrations/".concat(registrationId, "/sponsorDetails/profileImage")];
};
/**
 * @summary customerRegistrations/{registrationId}/sponsorDetails/profileImage
 */
export var useGetCustomerRegistrationSponsorDetailsProfileImage = function (registrationId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!registrationId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetCustomerRegistrationSponsorDetailsProfileImageKey(registrationId) : null;
    });
    var swrFn = function () {
        return getCustomerRegistrationSponsorDetailsProfileImage(customInstance, registrationId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns information about all sponsors for customer
 * @summary customers/{customerId}/sponsors
 */
export var getCustomerSponsors = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/sponsors"), method: 'get', headers: headers }, options);
};
export var getGetCustomerSponsorsKey = function (customerId) {
    return ["/customers/".concat(customerId, "/sponsors")];
};
/**
 * @summary customers/{customerId}/sponsors
 */
export var useGetCustomerSponsors = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerSponsorsKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerSponsors(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides steps to success tasks of specific customer
 * @summary customers/{customerId}/stepsToSuccess
 */
export var getCustomerStepsToSuccessTasks = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/stepsToSuccess"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerStepsToSuccessTasksKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/stepsToSuccess")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/stepsToSuccess
 */
export var useGetCustomerStepsToSuccessTasks = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerStepsToSuccessTasksKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerStepsToSuccessTasks(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides steps to success tasks phases of specific customer
 * @summary customers/{customerId}/stepsToSuccessPhases
 */
export var getCustomerStepsToSuccessTasksPhases = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/stepsToSuccessPhases"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerStepsToSuccessTasksPhasesKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/stepsToSuccessPhases")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/stepsToSuccessPhases
 */
export var useGetCustomerStepsToSuccessTasksPhases = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerStepsToSuccessTasksPhasesKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerStepsToSuccessTasksPhases(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets specific steps to success task of specific customer by id
 * @summary customers/{customerId}/stepsToSuccess/{taskId}
 */
export var getCustomerStepsToSuccessTask = function (client, customerId, taskId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/stepsToSuccess/").concat(taskId), method: 'get', headers: headers }, options);
};
export var getGetCustomerStepsToSuccessTaskKey = function (customerId, taskId) {
    return ["/customers/".concat(customerId, "/stepsToSuccess/").concat(taskId)];
};
/**
 * @summary customers/{customerId}/stepsToSuccess/{taskId}
 */
export var useGetCustomerStepsToSuccessTask = function (customerId, taskId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(customerId && taskId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerStepsToSuccessTaskKey(customerId, taskId) : null); });
    var swrFn = function () {
        return getCustomerStepsToSuccessTask(customInstance, customerId, taskId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Completes task for specific customer
 * @summary customers/{customerId}/stepsToSuccess/{taskId}/complete
 */
export var createCustomerStepsToSuccessComplete = function (client, customerId, taskId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/stepsToSuccess/").concat(taskId, "/complete"), method: 'post', headers: headers }, options);
};
/**
 * Get subscription configuration
 * @summary customers/{customerId}/subscriptionConfiguration
 */
export var getCustomerSubscriptionConfiguration = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/subscriptionConfiguration"), method: 'get', headers: headers }, options);
};
export var getGetCustomerSubscriptionConfigurationKey = function (customerId) {
    return ["/customers/".concat(customerId, "/subscriptionConfiguration")];
};
/**
 * @summary customers/{customerId}/subscriptionConfiguration
 */
export var useGetCustomerSubscriptionConfiguration = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerSubscriptionConfigurationKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerSubscriptionConfiguration(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get subscription availability per specified product/item
 * @summary customers/{customerId}/subscriptionAvailabilities
 */
export var getCustomerSubscriptionAvailabilities = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/subscriptionAvailabilities"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerSubscriptionAvailabilitiesKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/subscriptionAvailabilities")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/subscriptionAvailabilities
 */
export var useGetCustomerSubscriptionAvailabilities = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerSubscriptionAvailabilitiesKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerSubscriptionAvailabilities(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get subscription types.
Optionally filtered by product contained in subscription.
 * @summary customers/{customerId}/subscriptionTypes
 */
export var getCustomerSubscriptionTypes = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/subscriptionTypes"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerSubscriptionTypesKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/subscriptionTypes")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/subscriptionTypes
 */
export var useGetCustomerSubscriptionTypes = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerSubscriptionTypesKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerSubscriptionTypes(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Post subscription instruction.
Depends on instruction status (Pending/Finished) provides only validation or also creates new subscription if Finished
 * @summary customers/{customerId}/subscriptionInstructions
 */
export var createCustomerSubscriptionInstruction = function (client, customerId, globalCustomersSubscriptionInstructionDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/subscriptionInstructions"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersSubscriptionInstructionDto,
    }, options);
};
/**
 * Get subscriptions for specified period.
 * @summary customers/{customerId}/subscriptions
 */
export var getCustomerSubscriptions = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/subscriptions"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerSubscriptionsKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/subscriptions")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/subscriptions
 */
export var useGetCustomerSubscriptions = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerSubscriptionsKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerSubscriptions(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Cancels an active subscription.
 * @summary customers/{customerId}/subscriptions/{subscriptionId}
 */
export var deleteCustomerSubscription = function (client, customerId, subscriptionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/subscriptions/").concat(subscriptionId), method: 'delete', headers: headers }, options);
};
/**
 * Updates a subscription.
Currently the only legal modification is changing the status from 'Canceled' to 'Reactivated'.
No other modifications are supported at this time.
 * @summary customers/{customerId}/subscriptions/{subscriptionId}
 */
export var updateCustomerSubscription = function (client, customerId, subscriptionId, globalCustomersSubscriptionDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/subscriptions/").concat(subscriptionId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersSubscriptionDto,
    }, options);
};
/**
 * GET: Returns personal subscription profile
 * @summary customers/{customerId}/subscriptionProfile
 */
export var getCustomerSubscriptionProfile = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/subscriptionProfile"), method: 'get', headers: headers }, options);
};
export var getGetCustomerSubscriptionProfileKey = function (customerId) {
    return ["/customers/".concat(customerId, "/subscriptionProfile")];
};
/**
 * @summary customers/{customerId}/subscriptionProfile
 */
export var useGetCustomerSubscriptionProfile = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerSubscriptionProfileKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerSubscriptionProfile(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Update personal subscription profile
 * @summary customers/{customerId}/subscriptionProfile
 */
export var updateCustomerSubscriptionProfile = function (client, customerId, globalCustomersSubscriptionProfileDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/subscriptionProfile"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersSubscriptionProfileDto,
    }, options);
};
/**
 * Put subscription item. Currently the only supported change is replacing a subscribed product
by a similar one using the ItemCode property, all other changes will be ignored.
 * @summary customers/{customerId}/subscriptions/{subscriptionId}/subscriptionItems/{subscriptionItemId}
 */
export var updateCustomerSubscriptionSubscriptionItem = function (client, customerId, subscriptionId, subscriptionItemId, globalCustomersSubscriptionItemDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/subscriptions/").concat(subscriptionId, "/subscriptionItems/").concat(subscriptionItemId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersSubscriptionItemDto,
    }, options);
};
/**
 * Get all dropped subscriptions
 * @summary shoppingSessions/{sessionId}/subscriptions
 */
export var getShoppingSessionSubscriptions = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/subscriptions"), method: 'get', headers: headers }, options);
};
export var getGetShoppingSessionSubscriptionsKey = function (sessionId) {
    return ["/shoppingSessions/".concat(sessionId, "/subscriptions")];
};
/**
 * @summary shoppingSessions/{sessionId}/subscriptions
 */
export var useGetShoppingSessionSubscriptions = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionSubscriptionsKey(sessionId) : null); });
    var swrFn = function () {
        return getShoppingSessionSubscriptions(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get subscription by id
 * @summary shoppingSessions/{sessionId}/subscriptions/{subscriptionId}
 */
export var getShoppingSessionSubscription = function (client, sessionId, subscriptionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/subscriptions/").concat(subscriptionId),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetShoppingSessionSubscriptionKey = function (sessionId, subscriptionId) {
    return ["/shoppingSessions/".concat(sessionId, "/subscriptions/").concat(subscriptionId)];
};
/**
 * @summary shoppingSessions/{sessionId}/subscriptions/{subscriptionId}
 */
export var useGetShoppingSessionSubscription = function (sessionId, subscriptionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(sessionId && subscriptionId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionSubscriptionKey(sessionId, subscriptionId) : null); });
    var swrFn = function () {
        return getShoppingSessionSubscription(customInstance, sessionId, subscriptionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Cancel (delete) subscription
 * @summary shoppingSessions/{sessionId}/subscriptions/{subscriptionId}
 */
export var deleteShoppingSessionSubscription = function (client, sessionId, subscriptionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/subscriptions/").concat(subscriptionId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Get steps of the subscription dropped to the orders
 * @summary shoppingSessions/{sessionId}/subscriptions/{subscriptionId}/steps
 */
export var getShoppingSessionSubscriptionSteps = function (client, sessionId, subscriptionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/subscriptions/").concat(subscriptionId, "/steps"),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetShoppingSessionSubscriptionStepsKey = function (sessionId, subscriptionId) { return ["/shoppingSessions/".concat(sessionId, "/subscriptions/").concat(subscriptionId, "/steps")]; };
/**
 * @summary shoppingSessions/{sessionId}/subscriptions/{subscriptionId}/steps
 */
export var useGetShoppingSessionSubscriptionSteps = function (sessionId, subscriptionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(sessionId && subscriptionId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetShoppingSessionSubscriptionStepsKey(sessionId, subscriptionId) : null;
    });
    var swrFn = function () {
        return getShoppingSessionSubscriptionSteps(customInstance, sessionId, subscriptionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get subscription step by the step number
 * @summary shoppingSessions/{sessionId}/subscriptions/{subscriptionId}/steps/{stepNumber}
 */
export var getShoppingSessionSubscriptionStep = function (client, sessionId, subscriptionId, stepNumber, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/subscriptions/").concat(subscriptionId, "/steps/").concat(stepNumber),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetShoppingSessionSubscriptionStepKey = function (sessionId, subscriptionId, stepNumber) {
    return ["/shoppingSessions/".concat(sessionId, "/subscriptions/").concat(subscriptionId, "/steps/").concat(stepNumber)];
};
/**
 * @summary shoppingSessions/{sessionId}/subscriptions/{subscriptionId}/steps/{stepNumber}
 */
export var useGetShoppingSessionSubscriptionStep = function (sessionId, subscriptionId, stepNumber, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(sessionId && subscriptionId && stepNumber);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetShoppingSessionSubscriptionStepKey(sessionId, subscriptionId, stepNumber)
            : null;
    });
    var swrFn = function () {
        return getShoppingSessionSubscriptionStep(customInstance, sessionId, subscriptionId, stepNumber, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Postpone subscription to the next order
 * @summary shoppingSessions/{sessionId}/subscriptions/{subscriptionId}/steps/{stepNumber}
 */
export var deleteShoppingSessionSubscriptionStep = function (client, sessionId, subscriptionId, stepNumber, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/subscriptions/").concat(subscriptionId, "/steps/").concat(stepNumber),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Postpone subscription to the next order based on cycle and step
 * @summary shoppingSessions/{sessionId}/subscriptions/{subscriptionId}/cycles/{cycleNumber}/steps/{stepNumber}
 */
export var deleteShoppingSessionSubscriptionCycleStep = function (client, sessionId, subscriptionId, cycleNumber, stepNumber, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/subscriptions/").concat(subscriptionId, "/cycles/").concat(cycleNumber, "/steps/").concat(stepNumber),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Localization for SubscriptionWizard application
 * @summary applications/subscriptionWizard/localization
 */
export var getApplicationsSubscriptionWizardLocalization = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/subscriptionWizard/localization", method: 'get', headers: headers }, options);
};
export var getGetApplicationsSubscriptionWizardLocalizationKey = function () {
    return ["/applications/subscriptionWizard/localization"];
};
/**
 * @summary applications/subscriptionWizard/localization
 */
export var useGetApplicationsSubscriptionWizardLocalization = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsSubscriptionWizardLocalizationKey() : null); });
    var swrFn = function () {
        return getApplicationsSubscriptionWizardLocalization(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides customer downline (only IDs) in a given period. If the period is not specified, the current period is used.
 * @summary commissionPlans/successPlan/customers/{customerId}/downline/onlyId
 */
export var getCommissionPlansSuccessPlanCustomerDownlineOnlyId = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/commissionPlans/successPlan/customers/".concat(customerId, "/downline/onlyId"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCommissionPlansSuccessPlanCustomerDownlineOnlyIdKey = function (customerId, params) {
    return __spreadArray([
        "/commissionPlans/successPlan/customers/".concat(customerId, "/downline/onlyId")
    ], (params ? [params] : []), true);
};
/**
 * @summary commissionPlans/successPlan/customers/{customerId}/downline/onlyId
 */
export var useGetCommissionPlansSuccessPlanCustomerDownlineOnlyId = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetCommissionPlansSuccessPlanCustomerDownlineOnlyIdKey(customerId, params)
            : null;
    });
    var swrFn = function () {
        return getCommissionPlansSuccessPlanCustomerDownlineOnlyId(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides customer downline with basic overview of customers in a given period. If the period is not specified, the current period is used.
 * @summary commissionPlans/successPlan/customers/{customerId}/downlineBasicOverview
 */
export var getCommissionPlansSuccessPlanCustomerDownlineBasicOverview = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/commissionPlans/successPlan/customers/".concat(customerId, "/downlineBasicOverview"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCommissionPlansSuccessPlanCustomerDownlineBasicOverviewKey = function (customerId, params) {
    return __spreadArray([
        "/commissionPlans/successPlan/customers/".concat(customerId, "/downlineBasicOverview")
    ], (params ? [params] : []), true);
};
/**
 * @summary commissionPlans/successPlan/customers/{customerId}/downlineBasicOverview
 */
export var useGetCommissionPlansSuccessPlanCustomerDownlineBasicOverview = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetCommissionPlansSuccessPlanCustomerDownlineBasicOverviewKey(customerId, params)
            : null;
    });
    var swrFn = function () {
        return getCommissionPlansSuccessPlanCustomerDownlineBasicOverview(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides parameters about targets(conditions) to receive advanced (upper) bonuses
 * @summary commissionPlans/successPlan/advancedBonusesQualification
 */
export var getCommissionPlansSuccessPlanAdvancedBonusesQualification = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/commissionPlans/successPlan/advancedBonusesQualification",
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCommissionPlansSuccessPlanAdvancedBonusesQualificationKey = function (params) {
    return __spreadArray([
        "/commissionPlans/successPlan/advancedBonusesQualification"
    ], (params ? [params] : []), true);
};
/**
 * @summary commissionPlans/successPlan/advancedBonusesQualification
 */
export var useGetCommissionPlansSuccessPlanAdvancedBonusesQualification = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled ? getGetCommissionPlansSuccessPlanAdvancedBonusesQualificationKey(params) : null;
    });
    var swrFn = function () {
        return getCommissionPlansSuccessPlanAdvancedBonusesQualification(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Provides parameters about targets(conditions) to receive performance discount bonus
 * @summary commissionPlans/successPlan/performanceDiscountQualification
 */
export var getCommissionPlansSuccessPlanPerformanceDiscountQualification = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/commissionPlans/successPlan/performanceDiscountQualification",
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
export var getGetCommissionPlansSuccessPlanPerformanceDiscountQualificationKey = function (params) {
    return __spreadArray([
        "/commissionPlans/successPlan/performanceDiscountQualification"
    ], (params ? [params] : []), true);
};
/**
 * @summary commissionPlans/successPlan/performanceDiscountQualification
 */
export var useGetCommissionPlansSuccessPlanPerformanceDiscountQualification = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetCommissionPlansSuccessPlanPerformanceDiscountQualificationKey(params)
            : null;
    });
    var swrFn = function () {
        return getCommissionPlansSuccessPlanPerformanceDiscountQualification(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get shopping bag amounts summary
 * @summary shoppingSessions/{sessionId}/summary
 */
export var getShoppingSessionSummary = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/summary"), method: 'get', headers: headers }, options);
};
export var getGetShoppingSessionSummaryKey = function (sessionId) {
    return ["/shoppingSessions/".concat(sessionId, "/summary")];
};
/**
 * @summary shoppingSessions/{sessionId}/summary
 */
export var useGetShoppingSessionSummary = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionSummaryKey(sessionId) : null); });
    var swrFn = function () {
        return getShoppingSessionSummary(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get accounts balance before and after shopping
 * @summary shoppingSessions/{sessionId}/summary/accounts
 */
export var getShoppingSessionSummaryAccounts = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/summary/accounts"), method: 'get', headers: headers }, options);
};
export var getGetShoppingSessionSummaryAccountsKey = function (sessionId) {
    return ["/shoppingSessions/".concat(sessionId, "/summary/accounts")];
};
/**
 * @summary shoppingSessions/{sessionId}/summary/accounts
 */
export var useGetShoppingSessionSummaryAccounts = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionSummaryAccountsKey(sessionId) : null); });
    var swrFn = function () {
        return getShoppingSessionSummaryAccounts(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get discounts applied to reduce price of the order
 * @summary shoppingSessions/{sessionId}/summary/discounts
 */
export var getShoppingSessionSummaryDiscounts = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/summary/discounts"), method: 'get', headers: headers }, options);
};
export var getGetShoppingSessionSummaryDiscountsKey = function (sessionId) {
    return ["/shoppingSessions/".concat(sessionId, "/summary/discounts")];
};
/**
 * @summary shoppingSessions/{sessionId}/summary/discounts
 */
export var useGetShoppingSessionSummaryDiscounts = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionSummaryDiscountsKey(sessionId) : null); });
    var swrFn = function () {
        return getShoppingSessionSummaryDiscounts(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the categories.
 * @summary applications/supportCenter/categories
 */
export var getApplicationsSupportCenterCategories = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/supportCenter/categories", method: 'get', headers: headers }, options);
};
export var getGetApplicationsSupportCenterCategoriesKey = function () {
    return ["/applications/supportCenter/categories"];
};
/**
 * @summary applications/supportCenter/categories
 */
export var useGetApplicationsSupportCenterCategories = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsSupportCenterCategoriesKey() : null); });
    var swrFn = function () {
        return getApplicationsSupportCenterCategories(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the category by its key.
 * @summary applications/supportCenter/categories/{categoryId}
 */
export var getApplicationsSupportCenterCategory = function (client, categoryId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/supportCenter/categories/".concat(categoryId), method: 'get', headers: headers }, options);
};
export var getGetApplicationsSupportCenterCategoryKey = function (categoryId) {
    return ["/applications/supportCenter/categories/".concat(categoryId)];
};
/**
 * @summary applications/supportCenter/categories/{categoryId}
 */
export var useGetApplicationsSupportCenterCategory = function (categoryId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!categoryId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsSupportCenterCategoryKey(categoryId) : null); });
    var swrFn = function () {
        return getApplicationsSupportCenterCategory(customInstance, categoryId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets the localization.
 * @deprecated
 * @summary applications/supportCenter/localization
 */
export var getApplicationsSupportCenterLocalizationDeprecated = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/supportCenter/localization", method: 'get', headers: headers }, options);
};
export var getGetApplicationsSupportCenterLocalizationDeprecatedKey = function () {
    return ["/applications/supportCenter/localization"];
};
/**
 * @deprecated
 * @summary applications/supportCenter/localization
 */
export var useGetApplicationsSupportCenterLocalizationDeprecated = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsSupportCenterLocalizationDeprecatedKey() : null); });
    var swrFn = function () {
        return getApplicationsSupportCenterLocalizationDeprecated(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets all featured Faqs
 * @summary applications/supportCenter/featuredFaqs
 */
export var getApplicationsSupportCenterFeaturedFaqs = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/supportCenter/featuredFaqs", method: 'get', headers: headers }, options);
};
export var getGetApplicationsSupportCenterFeaturedFaqsKey = function () {
    return ["/applications/supportCenter/featuredFaqs"];
};
/**
 * @summary applications/supportCenter/featuredFaqs
 */
export var useGetApplicationsSupportCenterFeaturedFaqs = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsSupportCenterFeaturedFaqsKey() : null); });
    var swrFn = function () {
        return getApplicationsSupportCenterFeaturedFaqs(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Gets search results
 * @summary applications/supportCenter/search
 */
export var getApplicationsSupportCenterSearch = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/supportCenter/search", method: 'get', headers: headers, params: params }, options);
};
export var getGetApplicationsSupportCenterSearchKey = function (params) { return __spreadArray(["/applications/supportCenter/search"], (params ? [params] : []), true); };
/**
 * @summary applications/supportCenter/search
 */
export var useGetApplicationsSupportCenterSearch = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsSupportCenterSearchKey(params) : null); });
    var swrFn = function () {
        return getApplicationsSupportCenterSearch(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Provides group tags along with belonging tags.
 * @summary products/tagGroups
 */
export var getProductsTagGroups = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/products/tagGroups", method: 'get', headers: headers }, options);
};
export var getGetProductsTagGroupsKey = function () { return ["/products/tagGroups"]; };
/**
 * @summary products/tagGroups
 */
export var useGetProductsTagGroups = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetProductsTagGroupsKey() : null); });
    var swrFn = function () {
        return getProductsTagGroups(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Gets tax classification for given customer
 * @summary customers/{customerId}/taxClassifications
 */
export var getCustomerTaxClassifications = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/taxClassifications"), method: 'get', headers: headers }, options);
};
export var getGetCustomerTaxClassificationsKey = function (customerId) {
    return ["/customers/".concat(customerId, "/taxClassifications")];
};
/**
 * @summary customers/{customerId}/taxClassifications
 */
export var useGetCustomerTaxClassifications = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerTaxClassificationsKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerTaxClassifications(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns documents for tax document
 * @summary customers/{customerId}/taxDocument
 */
export var getCustomerTaxDocument = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/taxDocument"), method: 'get', headers: headers }, options);
};
export var getGetCustomerTaxDocumentKey = function (customerId) {
    return ["/customers/".concat(customerId, "/taxDocument")];
};
/**
 * @summary customers/{customerId}/taxDocument
 */
export var useGetCustomerTaxDocument = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerTaxDocumentKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerTaxDocument(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Change documents for tax document (temporary document are submitted and will no longer be deleted)
 * @summary customers/{customerId}/taxDocument
 */
export var updateCustomerTaxDocument = function (client, customerId, globalCustomersTaxDocumentDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/taxDocument"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersTaxDocumentDto,
    }, options);
};
/**
 * GET: Returns information about customer termination
 * @summary customers/{customerId}/terminationStatus
 */
export var getCustomerTerminationStatus = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/terminationStatus"), method: 'get', headers: headers }, options);
};
export var getGetCustomerTerminationStatusKey = function (customerId) {
    return ["/customers/".concat(customerId, "/terminationStatus")];
};
/**
 * @summary customers/{customerId}/terminationStatus
 */
export var useGetCustomerTerminationStatus = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerTerminationStatusKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerTerminationStatus(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Updates information about customer termination
 * @summary customers/{customerId}/terminationStatus
 */
export var updateCustomerTerminationStatus = function (client, customerId, globalCustomersTerminationStatusDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/terminationStatus"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersTerminationStatusDto,
    }, options);
};
/**
 * Returns terms info and html content
 * @deprecated
 * @summary terms/{termId}/html
 */
export var getTermHtmlDeprecated = function (client, termId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/terms/".concat(termId, "/html"), method: 'get', headers: headers }, options);
};
export var getGetTermHtmlDeprecatedKey = function (termId) { return ["/terms/".concat(termId, "/html")]; };
/**
 * @deprecated
 * @summary terms/{termId}/html
 */
export var useGetTermHtmlDeprecated = function (termId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!termId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTermHtmlDeprecatedKey(termId) : null); });
    var swrFn = function () {
        return getTermHtmlDeprecated(customInstance, termId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * @summary test/ping
 */
export var getTestPing = function (client, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/test/ping", method: 'get' }, options);
};
export var getGetTestPingKey = function () { return ["/test/ping"]; };
/**
 * @summary test/ping
 */
export var useGetTestPing = function (options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetTestPingKey() : null); });
    var swrFn = function () { return getTestPing(customInstance, requestOptions).then(function (d) { return d.data; }); };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns data for customer upgrade
 * @summary customers/{customerId}/upgradeRequest
 */
export var getCustomerUpgradeRequest = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/upgradeRequest"), method: 'get', headers: headers }, options);
};
export var getGetCustomerUpgradeRequestKey = function (customerId) {
    return ["/customers/".concat(customerId, "/upgradeRequest")];
};
/**
 * @summary customers/{customerId}/upgradeRequest
 */
export var useGetCustomerUpgradeRequest = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerUpgradeRequestKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerUpgradeRequest(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Upgrades VIP customer to consultant.
 * @summary customers/{customerId}/upgradeRequest
 */
export var updateCustomerUpgradeRequest = function (client, customerId, globalUpgradeRequestUpgradeRequestDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/upgradeRequest"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalUpgradeRequestUpgradeRequestDto,
    }, options);
};
/**
 * GET: Returns metadata for customer upgrade process
 * @summary customers/{customerId}/upgradeRequestMetadata
 */
export var getCustomerUpgradeRequestMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/upgradeRequestMetadata"), method: 'get', headers: headers }, options);
};
export var getGetCustomerUpgradeRequestMetadataKey = function (customerId) {
    return ["/customers/".concat(customerId, "/upgradeRequestMetadata")];
};
/**
 * @summary customers/{customerId}/upgradeRequestMetadata
 */
export var useGetCustomerUpgradeRequestMetadata = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerUpgradeRequestMetadataKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerUpgradeRequestMetadata(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET setting for specified customerId and specified business tool Id.
 * @summary businessTools/{businessToolId}/customerSettings/{customerId}
 */
export var getBusinessToolCustomerSetting = function (client, businessToolId, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/businessTools/".concat(businessToolId, "/customerSettings/").concat(customerId),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetBusinessToolCustomerSettingKey = function (businessToolId, customerId) { return ["/businessTools/".concat(businessToolId, "/customerSettings/").concat(customerId)]; };
/**
 * @summary businessTools/{businessToolId}/customerSettings/{customerId}
 */
export var useGetBusinessToolCustomerSetting = function (businessToolId, customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(businessToolId && customerId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetBusinessToolCustomerSettingKey(businessToolId, customerId) : null); });
    var swrFn = function () {
        return getBusinessToolCustomerSetting(customInstance, businessToolId, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * DELETE setting for specified business tool / external tool.
 * @summary businessTools/{businessToolId}/customerSettings/{customerId}
 */
export var deleteBusinessToolCustomerSetting = function (client, businessToolId, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/businessTools/".concat(businessToolId, "/customerSettings/").concat(customerId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * PUT setting for specified customerId and specified business tool Id, allow to store information if tool is activated for customer.
 * @summary businessTools/{businessToolId}/customerSettings/{customerId}
 */
export var updateBusinessToolCustomerSetting = function (client, businessToolId, customerId, globalConsultantsBusinessToolActivationDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/businessTools/".concat(businessToolId, "/customerSettings/").concat(customerId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalConsultantsBusinessToolActivationDto,
    }, options);
};
/**
 * GET settings
 * @summary settingsClients/{settingsClient}/settings/{settingId}/customers/{customerId}
 */
export var getSettingsClientSettingCustomer = function (client, settingsClient, settingId, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/settingsClients/".concat(settingsClient, "/settings/").concat(settingId, "/customers/").concat(customerId),
        method: 'get',
        headers: headers,
    }, options);
};
export var getGetSettingsClientSettingCustomerKey = function (settingsClient, settingId, customerId) { return ["/settingsClients/".concat(settingsClient, "/settings/").concat(settingId, "/customers/").concat(customerId)]; };
/**
 * @summary settingsClients/{settingsClient}/settings/{settingId}/customers/{customerId}
 */
export var useGetSettingsClientSettingCustomer = function (settingsClient, settingId, customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(settingsClient && settingId && customerId);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () {
        return isEnabled
            ? getGetSettingsClientSettingCustomerKey(settingsClient, settingId, customerId)
            : null;
    });
    var swrFn = function () {
        return getSettingsClientSettingCustomer(customInstance, settingsClient, settingId, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT settings
 * @summary settingsClients/{settingsClient}/settings/{settingId}/customers/{customerId}
 */
export var updateSettingsClientSettingCustomer = function (client, settingsClient, settingId, customerId, globalConsultantsSettingDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/settingsClients/".concat(settingsClient, "/settings/").concat(settingId, "/customers/").concat(customerId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalConsultantsSettingDto,
    }, options);
};
/**
 * DELETE settings
 * @summary settingsClients/{settingsClient}/settings/{settingId}/customers/{customerId}
 */
export var deleteSettingsClientSettingCustomer = function (client, settingsClient, settingId, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/settingsClients/".concat(settingsClient, "/settings/").concat(settingId, "/customers/").concat(customerId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Returns preferred type of document for VAT
 * @summary customers/{customerId}/vatDocumentType
 */
export var getCustomerVatDocumentType = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/vatDocumentType"), method: 'get', headers: headers }, options);
};
export var getGetCustomerVatDocumentTypeKey = function (customerId) {
    return ["/customers/".concat(customerId, "/vatDocumentType")];
};
/**
 * @summary customers/{customerId}/vatDocumentType
 */
export var useGetCustomerVatDocumentType = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerVatDocumentTypeKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerVatDocumentType(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Change preferred type of document for VAT
 * @summary customers/{customerId}/vatDocumentType
 */
export var updateCustomerVatDocumentType = function (client, customerId, globalCustomersCustomerSelectionDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/vatDocumentType"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersCustomerSelectionDtoBody,
    }, options);
};
/**
 * GET: Returns customer by phone number
 * @summary applications/vendingMachine/customer
 */
export var getApplicationsVendingMachineCustomer = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/vendingMachine/customer", method: 'get', headers: headers, params: params }, options);
};
export var getGetApplicationsVendingMachineCustomerKey = function (params) { return __spreadArray(["/applications/vendingMachine/customer"], (params ? [params] : []), true); };
/**
 * @summary applications/vendingMachine/customer
 */
export var useGetApplicationsVendingMachineCustomer = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsVendingMachineCustomerKey(params) : null); });
    var swrFn = function () {
        return getApplicationsVendingMachineCustomer(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET - provides content of Vip Customer Banner dependent on whether the customer is Vip End Customer.
 * @summary customers/{customerId}/vipCustomerBanner
 */
export var getCustomerVipCustomerBanner = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/vipCustomerBanner"), method: 'get', headers: headers }, options);
};
export var getGetCustomerVipCustomerBannerKey = function (customerId) {
    return ["/customers/".concat(customerId, "/vipCustomerBanner")];
};
/**
 * @summary customers/{customerId}/vipCustomerBanner
 */
export var useGetCustomerVipCustomerBanner = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerVipCustomerBannerKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerVipCustomerBanner(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get list of vouchers entered by customer
 * @summary shoppingSessions/{sessionId}/voucherCodes
 */
export var getShoppingSessionVoucherCodes = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/voucherCodes"), method: 'get', headers: headers }, options);
};
export var getGetShoppingSessionVoucherCodesKey = function (sessionId) {
    return ["/shoppingSessions/".concat(sessionId, "/voucherCodes")];
};
/**
 * @summary shoppingSessions/{sessionId}/voucherCodes
 */
export var useGetShoppingSessionVoucherCodes = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionVoucherCodesKey(sessionId) : null); });
    var swrFn = function () {
        return getShoppingSessionVoucherCodes(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * DELETE: Remove all vouchers entered by customer
 * @summary shoppingSessions/{sessionId}/voucherCodes
 */
export var deleteShoppingSessionVoucherCodes = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/voucherCodes"), method: 'delete', headers: headers }, options);
};
/**
 * POST: Remove all vouchers entered by customer
 * @summary shoppingSessions/{sessionId}/voucherCodes
 */
export var createShoppingSessionVoucherCode = function (client, sessionId, globalShoppingVoucherCodeDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/voucherCodes"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingVoucherCodeDto,
    }, options);
};
/**
 * GET: Get voucher entered by customer
 * @summary shoppingSessions/{sessionId}/voucherCodes/{voucherCode}
 */
export var getShoppingSessionVoucherCode = function (client, sessionId, voucherCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/voucherCodes/").concat(voucherCode), method: 'get', headers: headers }, options);
};
export var getGetShoppingSessionVoucherCodeKey = function (sessionId, voucherCode) {
    return ["/shoppingSessions/".concat(sessionId, "/voucherCodes/").concat(voucherCode)];
};
/**
 * @summary shoppingSessions/{sessionId}/voucherCodes/{voucherCode}
 */
export var useGetShoppingSessionVoucherCode = function (sessionId, voucherCode, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!(sessionId && voucherCode);
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionVoucherCodeKey(sessionId, voucherCode) : null); });
    var swrFn = function () {
        return getShoppingSessionVoucherCode(customInstance, sessionId, voucherCode, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * DELETE: Remove voucher entered by customer
 * @summary shoppingSessions/{sessionId}/voucherCodes/{voucherCode}
 */
export var deleteShoppingSessionVoucherCode = function (client, sessionId, voucherCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/voucherCodes/").concat(voucherCode),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Get list of active personal vouchers
 * @summary vouchers
 */
export var getVouchers = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/vouchers", method: 'get', headers: headers, params: params }, options);
};
export var getGetVouchersKey = function (params) {
    return __spreadArray(["/vouchers"], (params ? [params] : []), true);
};
/**
 * @summary vouchers
 */
export var useGetVouchers = function (params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetVouchersKey(params) : null); });
    var swrFn = function () {
        return getVouchers(customInstance, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Get list of vouchers evaluated for current shopping bag
 * @summary shoppingSessions/{sessionId}/vouchers
 */
export var getShoppingSessionVouchers = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/vouchers"), method: 'get', headers: headers }, options);
};
export var getGetShoppingSessionVouchersKey = function (sessionId) {
    return ["/shoppingSessions/".concat(sessionId, "/vouchers")];
};
/**
 * @summary shoppingSessions/{sessionId}/vouchers
 */
export var useGetShoppingSessionVouchers = function (sessionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!sessionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetShoppingSessionVouchersKey(sessionId) : null); });
    var swrFn = function () {
        return getShoppingSessionVouchers(customInstance, sessionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Localization for Vouchers application
 * @summary applications/vouchers/localization
 */
export var getApplicationsVouchersLocalization = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/vouchers/localization", method: 'get', headers: headers }, options);
};
export var getGetApplicationsVouchersLocalizationKey = function () {
    return ["/applications/vouchers/localization"];
};
/**
 * @summary applications/vouchers/localization
 */
export var useGetApplicationsVouchersLocalization = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsVouchersLocalizationKey() : null); });
    var swrFn = function () {
        return getApplicationsVouchersLocalization(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns wallet report
 * @summary customers/{customerId}/walletReport
 */
export var getCustomerWalletReport = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/walletReport"), method: 'get', headers: headers }, options);
};
export var getGetCustomerWalletReportKey = function (customerId) {
    return ["/customers/".concat(customerId, "/walletReport")];
};
/**
 * @summary customers/{customerId}/walletReport
 */
export var useGetCustomerWalletReport = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerWalletReportKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerWalletReport(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Returns wallet transactions list
 * @summary customers/{customerId}/walletTransactions
 */
export var getCustomerWalletTransactions = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/walletTransactions"), method: 'get', headers: headers, params: params }, options);
};
export var getGetCustomerWalletTransactionsKey = function (customerId, params) { return __spreadArray(["/customers/".concat(customerId, "/walletTransactions")], (params ? [params] : []), true); };
/**
 * @summary customers/{customerId}/walletTransactions
 */
export var useGetCustomerWalletTransactions = function (customerId, params, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerWalletTransactionsKey(customerId, params) : null); });
    var swrFn = function () {
        return getCustomerWalletTransactions(customInstance, customerId, params, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Creates new WeChat external account
 * @summary login/providers/weChat/externalAccount
 */
export var createLoginProvidersWeChatExternalAccount = function (client, globalLoginWeChatAccountDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/login/providers/weChat/externalAccount",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalLoginWeChatAccountDto,
    }, options);
};
/**
 * Provides collection of connected WeChat platform by unionId
 * @summary login/providers/weChat/externalAccount/{unionId}/platforms
 */
export var getLoginProvidersWeChatExternalAccountPlatforms = function (client, unionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/login/providers/weChat/externalAccount/".concat(unionId, "/platforms"), method: 'get', headers: headers }, options);
};
export var getGetLoginProvidersWeChatExternalAccountPlatformsKey = function (unionId) {
    return ["/login/providers/weChat/externalAccount/".concat(unionId, "/platforms")];
};
/**
 * @summary login/providers/weChat/externalAccount/{unionId}/platforms
 */
export var useGetLoginProvidersWeChatExternalAccountPlatforms = function (unionId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!unionId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetLoginProvidersWeChatExternalAccountPlatformsKey(unionId) : null); });
    var swrFn = function () {
        return getLoginProvidersWeChatExternalAccountPlatforms(customInstance, unionId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Add new platform to specific WeChat
 * @summary login/providers/weChat/externalAccount/{unionId}/platforms
 */
export var createLoginProvidersWeChatExternalAccountPlatform = function (client, unionId, globalLoginProvidersWeChatPlatformDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/login/providers/weChat/externalAccount/".concat(unionId, "/platforms"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalLoginProvidersWeChatPlatformDto,
    }, options);
};
/**
 * Get wellness club configuration
 * @summary applications/wellnessClub/localization
 */
export var getApplicationsWellnessClubLocalization = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/wellnessClub/localization", method: 'get', headers: headers }, options);
};
export var getGetApplicationsWellnessClubLocalizationKey = function () {
    return ["/applications/wellnessClub/localization"];
};
/**
 * @summary applications/wellnessClub/localization
 */
export var useGetApplicationsWellnessClubLocalization = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsWellnessClubLocalizationKey() : null); });
    var swrFn = function () {
        return getApplicationsWellnessClubLocalization(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * Get wellnes club configuration
 * @summary applications/wellnessClub/configuration
 */
export var getApplicationsWellnessClubConfiguration = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/wellnessClub/configuration", method: 'get', headers: headers }, options);
};
export var getGetApplicationsWellnessClubConfigurationKey = function () {
    return ["/applications/wellnessClub/configuration"];
};
/**
 * @summary applications/wellnessClub/configuration
 */
export var useGetApplicationsWellnessClubConfiguration = function (headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetApplicationsWellnessClubConfigurationKey() : null); });
    var swrFn = function () {
        return getApplicationsWellnessClubConfiguration(customInstance, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * GET: Returns information about wellness life for given customer
 * @summary customers/{customerId}/wellnessLife
 */
export var getCustomerWellnessLife = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/wellnessLife"), method: 'get', headers: headers }, options);
};
export var getGetCustomerWellnessLifeKey = function (customerId) {
    return ["/customers/".concat(customerId, "/wellnessLife")];
};
/**
 * @summary customers/{customerId}/wellnessLife
 */
export var useGetCustomerWellnessLife = function (customerId, headers, options) {
    var _a;
    var customInstance = useApiClient();
    var _b = options !== null && options !== void 0 ? options : {}, swrOptions = _b.swr, requestOptions = _b.request;
    var isEnabled = (swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.enabled) !== false && !!customerId;
    var swrKey = (_a = swrOptions === null || swrOptions === void 0 ? void 0 : swrOptions.swrKey) !== null && _a !== void 0 ? _a : (function () { return (isEnabled ? getGetCustomerWellnessLifeKey(customerId) : null); });
    var swrFn = function () {
        return getCustomerWellnessLife(customInstance, customerId, headers, requestOptions).then(function (d) { return d.data; });
    };
    var query = useSwr(swrKey, swrFn, swrOptions);
    return __assign({ swrKey: swrKey }, query);
};
/**
 * PUT: Change wellness life approval flag
 * @summary customers/{customerId}/wellnessLife
 */
export var updateCustomerWellnessLife = function (client, customerId, globalCustomersCustomerBooleanDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/wellnessLife"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersCustomerBooleanDtoBody,
    }, options);
};

